webpackJsonp([220],{

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_privilege__ = __webpack_require__(188);






var LOGIN_URL = '../token';

var REFRESH_TOKEN_URL = '../token';

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        var that = this;

        Vue.http.interceptors.request.use(function (config) {
            var accessToken = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth.accessToken || "";
            if (accessToken.length > 0) {
                config.headers.Authorization = 'Bearer ' + accessToken;
            }
            return config;
        }, function (error) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });

        Vue.http.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            if (that._isInvalidToken(error.response)) {
                return that._refreshToken(error.config);
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
        });

        Vue.prototype.$auth = Vue.auth = this;
    },
    login: function login(creds, redirect) {
        var _this = this;

        debugger;
        var data = "grant_type=sms&username=" + creds.username + "&password=" + creds.password + "&code=" + creds.code;

        return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(LOGIN_URL, data).then(function (response) {
            debugger;
            console.log('login-response', response);

            _this._storeToken(response);

            if (redirect) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: redirect });
            }
            debugger;
            console.log('login-response.data', response.data);
            return response.data;
        });
    },
    loginAuth: function loginAuth(data) {
        var _this2 = this;

        debugger;
        data = JSON.parse(data);
        console.log('loginAuth', data);
        return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('../api/AuthLogin/GetAuth', data).then(function (response) {
            debugger;

            if (response.data.ErrorCode != 0) {
                throw response.data.Message;
                return;
            }

            response.data = response.data.Data;
            console.log('login-response', response);

            _this2._storeToken(response);

            if (data.url) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace({ query: { redirect: data.url } });
            }

            debugger;
            console.log('login-response.data', response.data);
            return response.data;
        });
    },
    logout: function logout() {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('CLEAR_ALL_DATA');
        __WEBPACK_IMPORTED_MODULE_4__plugins_privilege__["a" /* default */].reset();

        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'login' });
    },
    _retry: function _retry(config) {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.request(config);
    },
    _refreshToken: function _refreshToken(config) {
        var _this3 = this;

        var params = "grant_type=refresh_token&refresh_token=" + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth.refreshToken;

        return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(REFRESH_TOKEN_URL, params).then(function (resp) {
            _this3._storeToken(resp);
            return _this3._retry(config);
        }).catch(function (err) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
    },
    _storeToken: function _storeToken(response) {
        var auth = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.auth;

        auth.isLoggedIn = true;
        auth.accessToken = response.data.access_token;
        auth.refreshToken = response.data.refresh_token;

        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('UPDATE_AUTH', auth);
    },
    _isInvalidToken: function _isInvalidToken(response) {
        var status = response.status;
        var error = response.statusText;
        return status == 401 && (error == 'invalid_token' || error == 'expired_token');
    }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        if (!window.GLOBAL_USER_ACTIONS && localStorage.GLOBAL_USER_ACTIONS) {
            window.GLOBAL_USER_ACTIONS = JSON.parse(localStorage.GLOBAL_USER_ACTIONS);
        }
        Vue.directive("privilege", {
            bind: function bind(el, binding) {
                var actions = window.GLOBAL_USER_ACTIONS || [];
                for (var i = 0, count = actions.length; i < count; i++) {
                    if (actions[i] == binding.value) {
                        return;
                    }
                }

                el.style.display = "none";
            }
        });
    },
    reset: function reset() {
        delete window.GLOBAL_USER_ACTIONS;
        localStorage.removeItem("GLOBAL_USER_ACTIONS");
    }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_router__ = __webpack_require__(369);






var App = function App(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Login = function Login(resolve) {
    return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(726)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Main = function Main(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Home = function Home(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(725)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Unauthorized = function Unauthorized(resolve) {
    return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NotFound = function NotFound(resolve) {
    return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(722)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var InternalServerError = function InternalServerError(resolve) {
    return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(723)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Auth = function Auth(resolve) {
    return __webpack_require__.e/* require */(193).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(724)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: [{
        path: '/login',
        name: 'login',
        meta: { keepAlive: true },
        component: Login
    }, {
        path: '/loginNew',
        name: 'loginNew',

        component: Login
    }, {
        path: '/loginAuth/:authinfo',
        name: 'loginAuth',

        component: Login
    }, {
        path: '/401',
        name: '401',
        component: Unauthorized
    }, {
        path: '/404',
        name: '404',
        component: NotFound
    }, {
        path: '/500',
        name: '500',
        component: InternalServerError
    }, {
        path: '/auth/:userId/:targetUrl',
        name: 'auth',
        component: Auth
    }, {
        path: '/',
        redirect: { name: 'home' },
        meta: { keepAlive: true },
        component: Main,
        children: [{
            path: 'home',
            name: 'home',
            meta: { keepAlive: true },
            component: Home
        }]
    }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(generateRoutesFromModules()), [{ path: '*', redirect: '/404' }])
});

router.beforeEach(function (to, from, next) {
    if (to.name === "loginNew" || to.name === "loginAuth" || to.name === "login" || to.name === "auth" || to.name === "401" || to.name === "404" || to.name === "500") {
        next();
        return;
    }
    guardRoute(to, from, next);
});

function generateRoutesFromModules() {
    return __WEBPACK_IMPORTED_MODULE_3__module_router__["a" /* default */];
}

function guardRoute(to, from, next) {
    var auth = router.app.$options.store.state.auth;
    if (!auth.isLoggedIn) {
        if (to.name === 'home') {
            next({
                name: 'login'
            });
        } else {
            next({
                name: 'login',
                query: { redirect: to.fullPath }
            });
        }
    } else {
        next();
    }
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins__ = __webpack_require__(374);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
    mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__,
    plugins: __WEBPACK_IMPORTED_MODULE_6__plugins__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var STORAGE_KEY = 'PortalStorage';

var syncedData = {
    auth: {
        isLoggedIn: false,
        accessToken: null,
        refreshToken: null
    },
    user: {
        userId: null,
        userName: null,
        nickName: null,
        avatarUrl: null,
        departName: null,
        departId: null
    }
};

if (localStorage.getItem(STORAGE_KEY)) {
    syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(syncedData);

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_reset_css__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_rtportal_css__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_rtportal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_rtportal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_rtportal_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_fonts_styles_css__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_fonts_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_fonts_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme_index_css__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_privilege__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_i18n__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_i18n_map__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_format__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_xlsx_table__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_xlsx_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_xlsx_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__packages__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_baidu_map__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_baidu_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_baidu_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__App__);
var version = "6.5";














__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http = __WEBPACK_IMPORTED_MODULE_9_axios___default.a;

if (false) {
    axios.defaults.baseURL = localStorage.serverAddress;
}


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__auth__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__plugins_privilege__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]);



var defaultLocale = localStorage.i18nLocale;
if (defaultLocale === null || defaultLocale === undefined) {
    defaultLocale = __WEBPACK_IMPORTED_MODULE_13__config_i18n_map__["a" /* locales */][0].value;
}
var _i18n = new __WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]({
    locale: defaultLocale,
    messages: __WEBPACK_IMPORTED_MODULE_13__config_i18n_map__["b" /* messages */] });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n = _i18n;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.request.use(function (config) {
    var locale = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.locale;
    if (locale !== null && locale.length > 0) {
        config.headers["Accept-Language"] = locale;
    }
    return config;
});





var formater = __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale_format___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui___default.a, {
    i18n: function i18n(path, options) {
        var value = _i18n.t(path);
        if (value !== null && value !== undefined) return formater(value, options);
        var array = path.split('.');
        for (var i = 0, j = array.length; i < j; i += 1) {
            var property = array[i];
            value = _i18n.t(property);
            if (i === j - 1) return formater(value, options);
            if (!value) return '';
        }
        return '';
    }
});


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_xlsx_table___default.a, {
    rABS: true
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__packages__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.debug = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_baidu_map___default.a, {
    ak: 'Dy9gTfiNyOuiUCpi6UooCugl'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.DateFormatter = function (row, attribute, isDate) {
    if (row[attribute]) {
        if (row[attribute].indexOf("-") != -1) {
            row[attribute] = row[attribute].replace(new RegExp(/-/gm), "/");
        }
        return new Date(row[attribute]).getZoneTime(isDate);
    }
};


new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    i18n: _i18n,
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_20__App___default.a
    }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_locale_lang_en__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_locale_lang_zh_CN__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_locale_lang_en__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_locale_lang_zh_CN__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__module_locale_langForCrm_crmMetadata_1033__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__module_locale_langForCrm_crmMetadata_2052__ = __webpack_require__(366);














var locales = [{
    value: 'zh-CN',
    name: 'Chinese',
    native: '简体中文'
}, {
    value: 'en-US',
    name: 'English',
    native: 'English'
}];

var messages = {
    "zh-CN": __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__components_locale_lang_zh_CN__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_CN___default.a, __WEBPACK_IMPORTED_MODULE_6__module_locale_lang_zh_CN__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__module_locale_langForCrm_crmMetadata_2052__["a" /* default */]),
    "en-US": __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_locale_lang_en__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default.a, __WEBPACK_IMPORTED_MODULE_5__module_locale_lang_en__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__module_locale_langForCrm_crmMetadata_1033__["a" /* default */])
};

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(682),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtAnnotation",
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      attachmentData: [],
      fileAutoSize: 10485760,
      isIE: false,
      isNotIE: true
    };
  },

  props: {
    entityname: {
      type: String,
      require: true
    },
    objectid: {
      type: String,
      require: true
    },
    showDetail: {
      type: Boolean,
      require: true
    },
    disabledStatus: {
      type: Boolean,
      require: false
    },
    showAdd: {
      type: Boolean,
      require: false
    },
    showDelete: {
      type: Boolean,
      require: false
    },
    subject: {
      type: String,
      require: false
    },
    noteText: {
      type: String,
      require: true
    },
    stateFied: {},
    stateValue: {
      type: Number
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.attachmentData = [];
    this.$nextTick(function () {
      return _this.fetchRecords();
    });
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("Trident") > -1) {
      this.isIE = true;
      this.isNotIE = false;
    } else {
      this.isIE = false;
      this.isNotIE = true;
    }
  },
  methods: {
    fetchRecords: function fetchRecords() {
      var _this2 = this;

      if (this.objectid) {
        this.loading = true;
        var requestStr = "../api/annotation/getannotation/" + this.objectid;
        rt.get(requestStr).then(function (res) {
          var attachmentList = res;
          var list = _this2.mapAttachments(attachmentList);
          _this2.attachmentData = list;
          _this2.loading = false;
          _this2.$emit("isExitatt", _this2.attachmentData.length);
        }).catch(function (error) {
          rt.showErrorToast(error);
          _this2.loading = false;
        });
      }
    },

    mapAttachments: function mapAttachments(attachmentList) {
      var _this3 = this;

      var list = [];
      attachmentList.map(function (step) {
        var filelink = "data:" + step.mimetype + ";base64," + step.documentbody;
        var blob = _this3.base64Img2Blob(filelink);
        var userAgent = navigator.userAgent;
        step.filelink = window.URL.createObjectURL(blob);
        step.blob = blob;
        list.push(step);
      });
      return list;
    },

    onFileChange: function onFileChange() {
      var that = this;
      var id = that.objectid;
      var files = that.$refs.upload.files;
      var reader = new FileReader();
      var file = files[0];
      var ifSame = that.checkSameName(file.name);
      if (ifSame) {
        that.$message({
          type: "warning",
          message: that.$t("ExistSameFile")
        });
      } else {
        reader.readAsDataURL(file);
        reader.onload = function (f) {
          if (file.size >= that.fileAutoSize) {
            that.$message({
              type: "warning",
              message: that.$t("FileIn10M")
            });
          } else {
            var annotation = {};
            annotation["filename"] = file.name;
            annotation["type"] = file.type;
            if (f.target.result !== "data:") {
              annotation["documentbody"] = f.target.result.substring(f.target.result.indexOf(",") + 1);
            }
            if (that.showDetail) {
              annotation["subject"] = that.subject;
              annotation["notetext"] = that.noteText;
            }
            annotation["id"] = id;
            annotation["filesize"] = file.size;
            annotation["entityname"] = that.entityname;
            var requestStr = "../api/annotation/addannotation";
            rt.post(requestStr, annotation).then(function (res) {
              rt.showSuccessToast(res);
              that.fetchRecords();
            }).catch(function (error) {
              rt.showErrorToast(error);
            });
          }
        };
      }
      that.$refs.upload.value = "";
    },

    checkSameName: function checkSameName(val) {
      if (this.attachmentData.length == 0) {
        return false;
      } else {
        for (var i in this.attachmentData) {
          if (this.attachmentData[i].filename == val) {
            return true;
          }
        }
        return false;
      }
    },

    uploadFile: function uploadFile() {
      if (rt.isNullOrWhiteSpace(this.objectid)) {
        this.$message({
          type: "warning",
          message: this.$t("PleaseSave")
        });
        return;
      }

      if (this.approvalstatus) {
        if (this.approvalstatus != 1 && this.approvalstatus != 4 || this.approvalstatus == 5) {
          this.$message({
            type: "warning",
            message: this.$t("NotSingleAndRejectCanNotAdd")
          });
          return;
        }
      }
      this.$refs.upload.click();
    },

    deleteData: function deleteData() {
      var _this4 = this;

      var selection = this.$refs.gridTable.selection;
      if (selection == null || selection.length == 0) {
        this.$message({
          type: "warning",
          message: this.$t("PleaseChooseAtLeastOne")
        });
      } else {
        this.$confirm(this.$t("ThisActionDeletePerpetually"), this.$t("Tip"), {
          confirmButtonText: this.$t("BUTTON_DETERMINE"),
          confirmButtonClass: "ConfirmButtonClass",
          cancelButtonText: this.$t("BUTTON_CANCEL"),
          cancelButtonClass: "CancelButtonClass",
          type: "warning"
        }).then(function () {
          _this4.loading = true;
          var deleteList = [];
          for (var i in selection) {
            deleteList.push(selection[i].annotationid);
          }
          var params = deleteList;
          var requestStr = "../api/annotation/deleteannotation";
          rt.post(requestStr, params).then(function (res) {
            rt.showSuccessToast(res);
            _this4.fetchRecords();
          }).catch(function (error) {
            rt.showErrorToast(error);
            _this4.loading = false;
          });
        }).catch(function (error) {
          _this4.$message({
            type: "info",
            message: _this4.$t("HasCancelledForDeleting")
          });
        });
      }
    },

    downLoadFile: function downLoadFile(index, row) {
      var filelink = "data:" + row.mimetype + ";base64," + row.documentbody;
      row.blob = this.base64Img2Blob(filelink);
      row.filelink = window.URL.createObjectURL(row.blob);
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Trident") > -1) {
        window.navigator.msSaveBlob(row.blob, row.filename);
      }
    },

    downLoadOrOpenFile: function downLoadOrOpenFile(index, row) {
      var filelink = "data:" + row.mimetype + ";base64," + row.documentbody;
      row.blob = this.base64Img2Blob(filelink);
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Trident") > -1) {
        window.navigator.msSaveOrOpenBlob(row.blob, row.filename);
      }
    },
    base64Img2Blob: function base64Img2Blob(code) {
      var parts = code.split(";base64,");
      var contentType = parts[0].split(":")[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;

      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType
      });
    }
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__progress__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RtApprovalProgressDialog',
    components: {
        'rt-approval-progress': __WEBPACK_IMPORTED_MODULE_0__progress___default.a
    },
    data: function data() {
        return {
            dialogVisible: false
        };
    },

    props: {
        entityName: {
            type: String,
            require: true
        },
        entityId: {
            type: String,
            require: true
        }
    },
    methods: {
        show: function show() {
            this.dialogVisible = true;
        }
    }

});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RtApprovalProgress',
  data: function data() {
    return {
      stateList: [],
      trackList: []
    };
  },

  props: {
    entityName: {
      type: String,
      require: true
    },
    entityId: {
      type: String,
      require: true
    }
  },
  watch: {
    entityId: function entityId(val) {
      if (val) {
        this.getStateList(val);
        this.getTrackList(val);
      }
    }
  },
  mounted: function mounted() {
    if (!rt.isNullOrWhiteSpace(this.entityId)) {
      this.getStateList(this.entityId);
      this.getTrackList(this.entityId);
    }
  },
  methods: {
    getStateList: function getStateList(entityId) {
      var _this = this;

      rt.get("../api/CrmFlow/GetFlowApprovalStep/" + entityId).then(function (res) {
        if (res == null || res.length == 0) {
          return;
        }

        var submit = {
          OwneridName: res[0]["ApplyUserName"] + " 提交",
          ApproveDate: res[0]["ApplyDate"],
          Status: 0
        };
        res.unshift(submit);

        _this.stateList = res;
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    },
    getTrackList: function getTrackList(entityId) {
      var _this2 = this;

      rt.get("../api/CrmFlow/GetFlowApprovalTrack/" + entityId).then(function (res) {
        _this2.trackList = res;
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    }
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtButton",
    props: {
        type: {
            type: String,
            required: true
        },
        text: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            iconClass: null,
            buttonText: null
        };
    },
    created: function created() {
        this.iconClass = "rt-icon-" + this.type;
        switch (this.type) {
            case "add":
                this.buttonText = this.text || this.$t('BUTTON_ADD');
                break;
            case "print":
                this.buttonText = this.text || this.$t('BUTTON_PRINT');
                break;
            case "confirm":
                this.buttonText = this.text || this.$t('BUTTON_DETERMINE');
                break;
            case "approve-progress":
                this.buttonText = this.text || this.$t('BUTTON_APPROVALPROGRESS');
                break;
            case "delete":
                this.buttonText = this.text || this.$t('BUTTON_DELETE');
                break;
            case "enable":
                this.buttonText = this.text || this.$t('BUTTON_ENABLE');
                break;
            case "disable":
                this.buttonText = this.text || this.$t('BUTTON_DISABLE');
                break;
            case "more":
                this.buttonText = this.text || this.$t('BUTTON_MORE');
                break;
            case "export":
                this.buttonText = this.text || this.$t('BUTTON_EXPORT');
                break;
            case "import":
                this.buttonText = this.text || this.$t('BUTTON_IMPORT');
                break;
            case "submit":
                this.buttonText = this.text || this.$t('BUTTON_SUBMIT');
                break;
            case "revert":
                this.buttonText = this.text || this.$t('BUTTON_WITHDRAW');
                break;
            case "download":
                this.buttonText = this.text || this.$t('BUTTON_DOWNLOAD');
                break;
            case "save":
                this.buttonText = this.text || this.$t('BUTTON_SAVE');
                break;
            default:
                this.iconClass = "";
                this.buttonText = this.text || "<Text>";
                break;
        }
    },

    methods: {
        handleClick: function handleClick() {
            this.$emit("click");
        }
    }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtContent",
    props: {},
    data: function data() {
        return {
            sideStyle: null
        };
    },
    mounted: function mounted() {
        if (this.$slots.side) {}
    }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtExcelImportDialog",
    props: {
        title: {
            type: String,
            require: true
        },
        action: {
            type: String,
            require: true
        },
        templateUrl: String,
        onSuccess: Function
    },
    data: function data() {
        return {
            dialogVisible: false,

            isImporting: false,
            selectedFile: {},
            importResult: null,
            isSuccessed: null
        };
    },

    computed: {
        templateExcelUrl: function templateExcelUrl() {
            return rt.getBaseUrl() + this.templateUrl;
        }
    },
    methods: {
        handleChange: function handleChange(file, fileList) {
            this.selectedFile = file;
        },
        handleImport: function handleImport() {
            this.$refs.upload.submit();
        },
        handleHttpRequest: function handleHttpRequest() {
            var _this = this;

            if (this.isImporting) {
                return;
            }

            this.importResult = null;
            this.isSuccessed = null;

            this.isImporting = true;
            var data = new FormData();
            data.append("file", this.selectedFile.raw);

            rt.post(this.action, data).then(function (res) {
                _this.isSuccessed = true;
                _this.importResult = res;
                _this.isImporting = false;

                if (_this.onSuccess) {
                    _this.onSuccess();
                }
            }, function (error) {
                _this.isSuccessed = false;
                _this.importResult = error;
                _this.isImporting = false;
            });
        },
        handleDialogClose: function handleDialogClose() {
            this._reset();

            this.dialogVisible = false;
        },
        show: function show() {
            this.dialogVisible = true;
        },
        _reset: function _reset() {
            this.$refs.upload.clearFiles();

            this.isImporting = false;
            this.selectedFile = {};
            this.importResult = null;
            this.isSuccessed = null;
        }
    }
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RtFlowSubmitDialog',
  data: function data() {
    return {
      isSubmiting: false,
      dialogVisible: false,
      selectedFlowId: '',
      flowList: [],
      selectedUserId: [],
      stepList: []
    };
  },

  props: {
    entityName: {
      type: String,
      require: true
    },
    entityId: {
      type: String,
      require: true
    },
    onSuccess: {
      type: Function
    }
  },
  mounted: function mounted() {},
  watch: {
    selectedFlowId: function selectedFlowId(val) {
      var _this = this;

      if (rt.isNullOrWhiteSpace(val)) {
        this.stepList = [];
        return;
      }

      rt.get("../api/CrmFlow/GetFlowStep?flowid=" + val + "&entityname=" + this.entityName + "&entityid=" + this.entityId).then(function (res) {
        for (var i in res) {
          if (res[i].UserList.length > 0) {
            res[i].ApproveUserId = res[i].UserList[0].UserId;
          }
        }
        _this.stepList = res;
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    }

  },

  methods: {
    getFlowList: function getFlowList() {
      var _this2 = this;

      rt.get("../api/CrmFlow/GetFlowList?entityName=" + this.entityName).then(function (res) {
        if (res.length > 0) {
          _this2.flowList = res;
          _this2.selectedFlowId = res[0].FlowId;
        }
      }).catch(function (error) {
        rt.showErrorToast(error);
      });
    },
    submitFlow: function submitFlow() {
      var _this3 = this;

      var approveList = [];
      this.stepList.map(function (step) {
        approveList.push({
          StepId: step.StepId,
          ApproveUserId: step.ApproveUserId
        });
      });

      var data = {
        EntityId: this.entityId,
        EntityTypeName: this.entityName,
        FlowId: this.selectedFlowId,
        ApproveList: approveList
      };

      this.isSubmiting = true;
      rt.post("../api/CrmFlow/submit", data).then(function (res) {
        rt.showSuccessToast(res);

        if (_this3.onSuccess) {
          _this3.onSuccess();
        }

        _this3.closeDialog();
      }).catch(function (error) {
        rt.showErrorToast(error);
      }).finally(function () {
        _this3.isSubmiting = false;
      });
    },
    handleClose: function handleClose() {
      this.closeDialog();
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;

      this.flowList = [];
      this.selectedFlowId = '';
    },
    show: function show() {
      this.dialogVisible = true;

      this.getFlowList();
    }
  }

});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtGrid",
  data: function data() {
    return {
      quickSearch: null,

      showHidden: false,
      isShowSearch: true,
      pageIndex: 1,
      pageSize: 20,
      layout: "sizes,total,->, prev, pager, next, jumper",
      pageSizes: [10, 20, 30, 40, 50]
    };
  },

  props: {
    quicksearchPlaceholder: String,
    showPagination: {
      type: Boolean,
      default: true,
      required: false
    },
    totalRecord: {
      type: Number,
      required: false
    },
    searchButtonName: {
      type: String,
      default: '查询',
      required: false
    },
    resetButtonName: {
      type: String,
      default: '重置',
      required: false
    }
  },
  computed: {
    iconClass: function iconClass() {
      return this.showHidden ? "el-icon-arrow-up" : "el-icon-arrow-down";
    }
  },
  mounted: function mounted() {
    var _this = this;

    document.querySelector("body").onkeydown = function (even) {
      if (even.keyCode == "13") {
        _this.handleQuickSearch();
      }
    };
  },

  methods: {
    handleCollapse: function handleCollapse() {
      this.showHidden = !this.showHidden;
    },
    handleReset: function handleReset() {
      this.$emit("reset");
    },
    handleSearch: function handleSearch() {
      this.pageIndex = 1;
      this.$emit("search");
    },
    handleQuickSearch: function handleQuickSearch() {
      this.pageIndex = 1;
      this.$emit("quick-search");
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    handleIndexChange: function handleIndexChange(val) {
      this.pageIndex = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    getPageIndex: function getPageIndex() {
      return this.pageIndex;
    },
    setPageSizes: function setPageSizes(val) {
      this.pageSizes = val;
    },
    setisShowSearch: function setisShowSearch(val) {
      this.isShowSearch = val;
    },
    getPageSize: function getPageSize() {
      return this.pageSize;
    },
    getSearchString: function getSearchString() {
      return this.quickSearch;
    },
    setSearchString: function setSearchString(quicksearch) {
      this.quickSearch = quicksearch;
    }
  }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtHeader",
  props: {
    title: {
      type: String,
      default: "",
      required: true
    }
  }
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "JsLookupDialog",
  props: {
    title: {
      type: String,
      default: "查找"
    },
    entity: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      default: function _default() {
        return "../api/CrmLookupView/GetData";
      }
    },
    nameField: {
      type: String,
      default: function _default() {
        return "new_name";
      }
    },
    idField: {
      type: String,
      default: function _default() {
        return this.entity + "id";
      }
    },
    displayFields: {
      type: Array,
      default: function _default() {
        return [{ name: "new_name", label: "名称" }, { name: "createdon", label: "创建日期", width: 180 }];
      }
    },
    condition: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    orderbyFields: {
      type: String,
      default: function _default() {
        return "createdon desc";
      }
    },
    filterFields: {
      type: String,
      default: function _default() {
        return "new_name";
      }
    },
    searchPlaceholder: {
      type: String,
      default: function _default() {
        return "搜索记录";
      }
    },
    checkSelectable: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,

      filterValue: "",
      lastSearchedFilterValue: "",

      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,

      tableData: [],
      selectedRows: []
    };
  },

  computed: {
    dialogTitle: function dialogTitle() {
      return "查找";
    },

    selectString: {
      get: function get() {
        var selectFields = [];
        selectFields.push(this.nameField);
        selectFields.push(this.idField);
        for (var i in this.displayFields) {
          var fieldName = this.displayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }

        return selectFields.join(",");
      }
    },
    orderbyString: {
      get: function get() {
        return this.orderbyFields;
      }
    },
    filterString: {
      get: function get() {
        return this.filterFields;
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    show: function show() {
      this.dialogVisible = true;

      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleSearch: function handleSearch() {
      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleClick: function handleClick(row) {},
    handleSortChange: function handleSortChange() {
      alert("未实现");
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;

      this._fetchRecords();
    },
    handleIndexChange: function handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;

      this._fetchRecords();
    },
    handleConfirm: function handleConfirm() {
      var _this = this;

      var selectedRows = this.$refs.lookupTable.selection;
      if (selectedRows.length == 0) {
        rt.showErrorToast("请选择一条记录");
        return;
      }
      this.$emit("data-selected", this.$refs.lookupTable.selection.map(function (seletedItem) {
        return {
          id: seletedItem[_this.idField],
          name: seletedItem[_this.nameField]
        };
      }));

      this.dialogVisible = false;
    },
    _fetchRecords: function _fetchRecords() {
      var _this2 = this;

      this.loading = true;
      var requestStr = this.requestUrl + "?entityName=" + this.entity + "&page=" + this.pageIndex + "&count=" + this.pageSize + "&select=" + this.selectString + "&orderby=" + this.orderbyString + "&condition=" + this.condition + "&filter=" + this.filterString + "&filterValue=" + encodeURIComponent(this.filterValue || "");
      this.lastSearchedFilterValue = this.filterValue;
      var self = this;
      rt.get(requestStr).then(function (res) {
        _this2.tableData = res.Data;
        _this2.totalRecordCount = res.TotalRecordCount;
      }).catch(function (error) {
        rt.showErrorToast(error);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    selectable: function selectable(row) {
      if (this.checkSelectable) {
        return row.selectable;
      } else {
        return true;
      }
    }
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lookup_chooser_dialog__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lookup_chooser_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lookup_chooser_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "JsLookup",
  props: {
    buttonText: null,
    title: null,
    value: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    entity: {
      type: String,
      required: true
    },
    condition: String,
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    disa: false,
    searchPlaceholder: String,
    checkSelectable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "js-lookup-dialog": __WEBPACK_IMPORTED_MODULE_0__lookup_chooser_dialog___default.a
  },
  computed: {},
  data: function data() {
    return {};
  },


  rules: {},
  methods: {
    showLookupDialog: function showLookupDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.lookupDialog.show();
    },
    handleDataSelected: function handleDataSelected(val) {
      this.$emit("data-selected", val);
    }
  },
  watch: {

    methods: {
      showLookupDialog: function showLookupDialog() {
        this.$refs.lookupDialog.show();
      },
      handleDataSelected: function handleDataSelected(val) {
        this.$emit("data-selected", val);
      }
    }
  }
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtLookupDialog",
  props: {
    isMaskShow: {
      type: Boolean,
      required: false
    },
    entity: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      default: function _default() {
        return "../api/CrmLookupView/GetData";
      }
    },
    nameField: {
      type: String,
      default: function _default() {
        return "new_name";
      }
    },
    idField: {
      type: String,
      default: function _default() {
        return this.entity + "id";
      }
    },
    displayFields: {
      type: Array,
      default: function _default() {
        return [{ name: "new_name", label: "名称" }, { name: "createdon", label: "创建日期", width: 180 }];
      }
    },
    condition: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    orderbyFields: {
      type: String,
      default: function _default() {
        return "createdon desc";
      }
    },
    filterFields: {
      type: String,
      default: function _default() {
        return "new_name";
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,

      filterValue: "",

      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,

      tableData: [],
      currentRow: null
    };
  },

  computed: {
    dialogTitle: function dialogTitle() {
      return "查找";
    },

    selectString: {
      get: function get() {
        var selectFields = [];
        selectFields.push(this.nameField);
        selectFields.push(this.idField);
        for (var i in this.displayFields) {
          var fieldName = this.displayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }

        return selectFields.join(",");
      }
    },
    orderbyString: {
      get: function get() {
        return this.orderbyFields;
      }
    },
    filterString: {
      get: function get() {
        return this.filterFields;
      }
    }
  },
  mounted: function mounted() {},

  watch: {
    condition: function condition(e) {
      if (e.split(" eq ")[1] == " ") {
        this.handleConfirm();
      }
    }
  },
  methods: {
    show: function show() {
      this.dialogVisible = true;

      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleSearch: function handleSearch() {
      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSortChange: function handleSortChange() {
      alert("未实现");
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;

      this._fetchRecords();
    },
    handleIndexChange: function handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;

      this._fetchRecords();
    },
    handleReset: function handleReset() {
      this.$emit("data-selected", {
        id: null,
        logicalName: this.logicalName,
        name: null
      });

      this.dialogVisible = false;
    },
    handleConfirm: function handleConfirm() {
      if (this.tableData.length > 0) {
        var selectedRow = this.$refs.lookupTable.store.states.currentRow;
        console.log(selectedRow);
        if (rt.isNull(selectedRow)) {
          rt.showErrorToast("请选择一条记录");
          return;
        }
        if (selectedRow.isfinish == "1" && rt.getParameterValue("IsUnfinishedProductShippable") != "true") {
            rt.showErrorToast("未完工物料不可出货");
            return;
          }
        this.$emit("data-selected", {
          id: selectedRow[this.idField],
          name: selectedRow[this.nameField]
        });
      } else {
        this.$emit("data-selected", {
          id: " ",
          name: " "
        });
      }

      this.dialogVisible = false;
    },
    _fetchRecords: function _fetchRecords() {
      var _this = this;

      this.loading = true;
      var requestStr = this.requestUrl + "?entityName=" + this.entity + "&page=" + this.pageIndex + "&count=" + this.pageSize + "&select=" + this.selectString + "&orderby=" + this.orderbyString + "&condition=" + this.condition + "&filter=" + this.filterString + "&filterValue=" + encodeURIComponent(this.filterValue || "");

      rt.get(requestStr).then(function (res) {
        _this.tableData = res.Data;
        if (_this.tableData.length < 1) {
          _this.$emit("data-selected", {
            id: " ",
            name: " " });
        }
        _this.totalRecordCount = res.TotalRecordCount;
      }).catch(function (error) {
        rt.showErrorToast(error);
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lookup_dialog__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lookup_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lookup_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtLookup",
  props: {
    isMaskShow: {
      type: Boolean,
      default: function _default() {
        return true;
      },
      required: false
    },
    value: {
      type: Object | String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    entity: {
      type: String,
      required: true
    },
    condition: String,
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    disa: false
  },
  components: {
    "rt-lookup-dialog": __WEBPACK_IMPORTED_MODULE_0__lookup_dialog___default.a
  },
  computed: {
    setDisabled: function setDisabled() {
      if (!this.lookupValue && this.disabled) {
        this.disa = true;
      }
    }
  },
  data: function data() {
    return {
      lookupValue: {}
    };
  },


  rules: {},
  methods: {
    deletevalue: function deletevalue() {
      if (!this.disabled) {
        this.lookupValue = {};
        this.$emit("input", this.lookupValue);
      }
    },
    showLookupDialog: function showLookupDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.lookupDialog.show();
    },
    handleDataSelected: function handleDataSelected(val) {
      this.lookupValue = val;
      this.$emit("input", val);
    }
  },
  watch: {
    value: {
      handler: function handler(newValue) {
        this.lookupValue = newValue || {};
      },

      immediate: true
    },

    methods: {
      showLookupDialog: function showLookupDialog() {
        this.$refs.lookupDialog.show();
      },
      handleDataSelected: function handleDataSelected(val) {
        this.lookupValue = val;
        this.$emit("input", val);
      }
    }
  }
});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RtNavItem',
    props: {
        href: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    data: function data() {
        return {
            index: 0
        };
    },

    computed: {
        active: function active() {
            return this.index === this.$parent.activeIndex;
        }
    },
    created: function created() {
        this.index = this.$parent.$children.length - 1;
    },
    mounted: function mounted() {},

    methods: {
        handleItemClick: function handleItemClick() {
            if (this.disabled) {
                return;
            }

            this.$parent.activeIndex = this.index;

            var anchor = document.getElementById(this.href.substring(1));
            var contentMains = document.getElementById("appContent");
            if (contentMains != null) {
                contentMains.scrollTop = anchor.offsetTop - 60;
            }
        }
    }
});

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RtNav',

    data: function data() {
        return {
            activeIndex: 0
        };
    },
    mounted: function mounted() {
        var contentMain = document.getElementById("contentMain");

        var subs = [];

        var count = this.$children.length;
        for (var i = 0; i < count; i++) {
            var anchor = document.getElementById(this.$children[i].href.substring(1));
            if (anchor != null) {
                subs.push({
                    min: anchor.offsetTop - 20,
                    max: 9999
                });

                if (i != 0) {
                    subs[i - 1].max = anchor.offsetTop - 20;
                }
            }
        }

        var that = this;
        contentMain.onscroll = function () {
            var scrollTop = this.scrollTop;
            for (var i = 0; i < subs.length; i++) {
                if (scrollTop >= subs[i].min && scrollTop < subs[i].max) {
                    that.activeIndex = i;
                    break;
                }
            }
        };
    },

    methods: {}
});

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtPicklist",
    props: {
        value: [String, Number],
        entity: {
            type: String,
            required: true
        },
        attribute: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        showAll: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data: function data() {
        return {
            selectedValue: "",
            options: []
        };
    },

    watch: {
        value: function value(newVal, oldVal) {
            this.selectedValue = newVal;
        }
    },
    methods: {
        bindPicklist: function bindPicklist() {
            var self = this;
            rt.get("../api/crmpicklist/options/" + this.entity + "/" + this.attribute).then(function (res) {
                if (self.showAll) {
                    res.unshift({ Text: '全部', Value: null });
                }
                self.options = res;
            });
        },
        handleChange: function handleChange(val) {
            this.$emit("input", val);
        }
    },
    mounted: function mounted() {
        this.bindPicklist();
    }
});

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtQuery",
    props: {
        rows: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            showHidden: true
        };
    },

    computed: {
        icon: function icon() {
            return this.showHidden ? "arrow-down" : "arrow-up";
        },
        hintMessage: function hintMessage() {
            return this.showHidden ? "点击展开" : "点击收起";
        }
    },
    methods: {
        handleCollapse: function handleCollapse() {
            this.showHidden = !this.showHidden;
            this.$emit('collapse', this.showHidden);
        },
        handleReset: function handleReset() {
            this.$emit('reset');
        },
        handleSearch: function handleSearch() {
            this.$emit('search');
        }
    }
});

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "RtSection",
    props: {
        title: {
            type: String,
            default: '',
            required: true
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            isCollapsed: this.collapsed
        };
    },

    computed: {
        iconClass: function iconClass() {
            return this.isCollapsed ? "el-icon-arrow-down" : "el-icon-arrow-right";
        }
    },
    methods: {
        handleClick: function handleClick() {
            this.isCollapsed = !this.isCollapsed;
        }
    }
});

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RtToolbar",
  props: {
    showBack: {
      type: Boolean,
      default: false,
      required: false
    },
    showAutoback: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    handleBackClick: function handleBackClick() {
      if (this.showAutoback) {
        this.$router.back();
      } else {
        this.$emit("goback");
      }
    }
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_heartbeat__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(116);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    if (!__WEBPACK_IMPORTED_MODULE_0__plugins_heartbeat__["a" /* default */].isAlive()) {
      __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].logout();
    }

    __WEBPACK_IMPORTED_MODULE_0__plugins_heartbeat__["a" /* default */].keepAlive();
  }
});

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "JSLastApprovalMemo",
  data: function data() {
    return {
      lastApprovalMemo: ""
    };
  },

  props: ["id"],
  mounted: function mounted() {
    this.dataBind();
  },
  methods: {
    dataBind: function dataBind() {
      this.getLastApprovalMemo();
    },
    getLastApprovalMemo: function getLastApprovalMemo() {
      var that = this;
      rt.get("../api/Approval/GetLastApprovalMemo?entityId=" + this.id).then(function (res) {
        if (res != null && res.length > 0) {
          that.lastApprovalMemo = res;
        }
      }).catch(function (error) {
        rt.showErrorToast("获取捷顺最新签核意见失败:" + error);
      });
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);




!function (factory) {
    if ("function" === 'function' && (typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports)) === 'object' && ( false ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(module)) === 'object') {
        var target = module['exports'] || exports;
        factory(target);
    } else if (typeof define === 'function' && __webpack_require__(701)) {
        define(['exports'], factory);
    } else {
        factory(window['rt'] = {});
    }
}(function (utExports) {
    'use strict';

    var rt = typeof utExports !== 'undefined' ? utExports : {};

    var odataRequestUrl = "../api/crmdata/";

    rt.getLable = function (vm, label, value) {
        if (!rt.isNullOrWhiteSpace(value)) {
            console.log(vm.$t('a.c'));
        }
        return "123";
    };

    Date.prototype.getZoneTime = function (isDateTime) {
        var a;
        var defaultTimeZone = a || -8;
        var date = new Date(this);
        var d = new Date();
        var realTimeZoneOffset = defaultTimeZone - d.getTimezoneOffset() / 60;
        var timeWithTimezone = new Date(date.getTime() + realTimeZoneOffset * 3600000);
        if (isDateTime) {
            return rt.formatDateTime(timeWithTimezone, 'yyyy-mm-dd HH:MM:ss');
        }
        return rt.formatDateTime(timeWithTimezone, 'yyyy-mm-dd');
    };

    Date.prototype.getSystemTime = function (isDateTime) {

        var a;
        var defaultTimeZone = a || -8;
        var date = new Date(this);
        var d = new Date().getTimezoneOffset();
        var realTimeZoneOffset = d / 60 - defaultTimeZone;
        var timeWithTimezone = null;
        if (isDateTime) {
            timeWithTimezone = new Date(date.getTime() + realTimeZoneOffset * 3600000);
            return rt.formatDateTime(timeWithTimezone, 'yyyy-mm-dd HH:MM:ss');
        }
        timeWithTimezone = d > 0 ? new Date(date.getTime() + 24 * 3600000) : new Date(date.getTime());
        return rt.formatDateTime(timeWithTimezone, 'yyyy-mm-dd');
    };

    rt.createAsync = function (entitySetName, entity) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isString(entitySetName)) {
                throw new Error('rt.createAsyn entitySetName parameter must be a string.');
            }
            if (rt.isNull(entity)) {
                throw new Error('rt.createAsyn entity parameter must not be null or undefined.');
            }

            rt.post(odataRequestUrl + 'create/' + entitySetName, entity).then(function (res) {
                resolve(res.headers['odata-entityid'].split('(')[1].replace(')', ''));
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    rt.deleteAsync = function (entitySetName, entityId) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isString(entitySetName)) {
                throw new Error('rt.deleteAsyn entitySetName parameter must be a string.');
            }
            if (!rt.isString(entityId)) {
                throw new Error('rt.deleteAsyn entityId parameter must be a string.');
            }

            rt.post(odataRequestUrl + 'delete/' + entitySetName + '(' + entityId.replace('{', '').replace('}', '') + ')').then(function (res) {
                resolve(res.status);
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    rt.retrieveAsync = function (queryString, useFormattedValue) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isString(queryString)) {
                throw new Error('rt.retrieve queryString parameter must be a string.');
            }
            if (!rt.isBoolean(useFormattedValue)) {
                throw new Error('rt.retrieveMultiple useFormattedValue parameter must be a boolean.');
            }
            var url = odataRequestUrl + 'Retrieve/' + queryString;

            var config = {};
            if (useFormattedValue) {
                config = {
                    headers: {
                        Prefer: 'odata.include-annotations="OData.Community.Display.V1.FormattedValue"'
                    }
                };
            }
            rt.get(url, config).then(function (res) {
                resolve(res.data);
            }).catch(function (err) {
                resolve(err);
            });
        });
    };

    rt.retrieveMultipleAsync = function (queryString, useFormattedValue) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isString(queryString)) {
                throw new Error('rt.retrieveMultiple queryString parameter must be a string.');
            }
            if (!rt.isBoolean(useFormattedValue)) {
                throw new Error('rt.retrieveMultiple useFormattedValue parameter must be a boolean.');
            }
            var url = odataRequestUrl + 'Retrieve/' + queryString;

            var config = {};
            if (useFormattedValue) {
                config = {
                    headers: {
                        Prefer: 'odata.include-annotations="OData.Community.Display.V1.FormattedValue"'
                    }
                };
            }

            rt.get(url, config).then(function (res) {
                resolve(res.data);
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    rt.fetchAsync = function (entityName, fetchXml, useFormattedValue) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isBoolean(useFormattedValue)) {
                throw new Error('rt.fetchAsync useFormattedValue parameter must be a boolean.');
            }
            if (rt.isNullOrWhiteSpace(entityName)) {
                throw new Error('rt.fetchAsync entityName parameter must be string.');
            }
            if (rt.isNullOrWhiteSpace(fetchXml)) {
                throw new Error('rt.fetchAsync fetchXml parameter must be valuable.');
            }
            var fetchStr = odataRequestUrl + 'Retrieve/' + entityName + '?fetchXml=' + fetchXml;
            if (useFormattedValue) {}
            rt.get(fetchStr).then(function (res) {
                reject(res.data);
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    rt.updateAsync = function (entitySetName, entityId, entity) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isString(entitySetName)) {
                throw new Error('rt.updateAsync entitySetName parameter must be a string.');
            }
            if (!rt.isString(entityId)) {
                throw new Error('rt.updateAsync entityId parameter must be a string.');
            }
            if (rt.isNull(entity)) {
                throw new Error('rt.updateAsync entity parameter must not be null or undefined.');
            }

            var url = odataRequestUrl + 'Update/' + entitySetName + '(' + entityId.replace('{', '').replace('}', '') + ')';
            rt.post(url, entity).then(function (res) {
                resolve(res.headers['odata-entityid'].split('(')[1].replace(')', ''));
            }).catch(function (err) {
                resolve(err);
            });
        });
    };

    rt.updateSingleFieldAsync = function (entitySetName, entityId, fieldName, fieldValue) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isString(entitySetName)) {
                throw new Error('rt.updateSingleFieldAsync entitySetName parameter must be a string.');
            }
            if (!rt.isString(entityId)) {
                throw new Error('rt.updateSingleFieldAsync entityId parameter must be a string.');
            }

            rt.post(odataRequestUrl + 'Update/' + entitySetName + '(' + entityId.replace('{', '').replace('}', '') + ')/' + fieldName, {
                'value': fieldValue
            }).then(function (res) {
                resolve(res.headers['odata-entityid'].split('(')[1].replace(')', ''));
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    rt.getFieldValueAsync = function (id, typeName, returnField, useFormattedValue) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!rt.isBoolean(useFormattedValue)) {
                throw new Error('rt.getFieldValueAsync useFormattedValue parameter must be a boolean.');
            }
            if (rt.isNullOrWhiteSpace(id)) {
                throw new Error('rt.getFieldValueAsync id parameter must be string.');
            }
            if (rt.isNullOrWhiteSpace(typeName)) {
                throw new Error('rt.getFieldValueAsync typeName parameter must be string.');
            }

            var queryString = odataRequestUrl + 'Retrieve/' + typeName + '(' + id.replace('{', '').replace('{', '') + ')';
            if (!rt.isNullOrWhiteSpace(returnField) && returnField != "*") {
                queryString += '?$select=' + returnField;
            }

            rt.get(queryString).then(function (res) {
                resolve(res.data);
            }).catch(function (err) {
                reject(err);
            });
        });
    };

    rt.getParameterValue = function (paramName) {
        var result;
        var fetchXml = "<fetch mapping='logical' version='1.0'>" + "<entity name='new_systemparameter'>" + "<attribute name='new_value' />" + "<filter>" + "<condition attribute='new_name' operator='eq' value='" + paramName + "' />" + "</filter>" + "</entity>" + "</fetch>";

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(rt.fetchAsync('new_systemparameters', fetchXml, false).then(function (res) {
            return res.value[0].new_value;
        }));
    };

    rt.export2Excel = function (filename, val, excelTitle, exclude) {
        var excludelist = [];

        if (exclude) {
            excludelist = exclude.split(',');
        }
        var explorer = '';
        if (!!window.ActiveXObject || "ActiveXObject" in window) explorer = 'ie';

        if (explorer == 'ie') {
            var arrData = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) != 'object' ? JSON.parse(val) : val;
            try {
                var oXL = new ActiveXObject("Excel.Application");
            } catch (e) {
                alert("无法启动Excel，请确保电脑中已经安装了Excel!\n\n如果已经安装了Excel，" + "请调整IE的安全级别。\n\n具体操作：\n\n" + "工具 → Internet选项 → 安全 → 自定义级别 → ActiveX 控件和插件 → 对未标记为可安全执行脚本的ActiveX 控件初始化并执行脚本 → 启用 → 确定");
            }
            var oWB = oXL.Workbooks.Add();
            var oSheet = oWB.ActiveSheet;
            var Lenr = arrData.length;
            for (var i = 0; i < excelTitle.length; i++) {
                oSheet.Cells(1, i + 1).value = excelTitle[i];
            }

            for (var i = 0; i < Lenr; i++) {
                var td = 0;
                for (var j in arrData[i]) {
                    if (excludelist.length > 0 && excludelist.indexOf(j) >= 0) continue;
                    oSheet.Cells(i + 2, td + 1).value = arrData[i][j];
                    td++;
                }
            }
            oXL.Visible = true;

            var fname = oXL.Application.GetSaveAsFilename(filename + ".xls", "Excel Spreadsheets (*.xls), *.xls");
            oWB.SaveAs(fname);
            oWB.Close();
            oXL.Quit();
        } else {
                var arrData = (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) != 'object' ? JSON.parse(val) : val;
                var excel = '<table>';
                var row = "<tr>";
                for (var i = 0; i < excelTitle.length; i++) {
                    row += "<td>" + excelTitle[i] + "</td>";
                }
                excel += row + "</tr>";
                for (var i = 0; i < arrData.length; i++) {
                    var row = "<tr>";
                    for (var j in arrData[i]) {
                        if (excludelist.length > 0 && excludelist.indexOf(j) >= 0) continue;
                        var td = arrData[i][j];
                        row += "<td>" + td + "</td>";
                    }
                    excel += row + "</tr>";
                }
                excel += "</table>";
                var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " + "xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
                excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
                excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel';
                excelFile += '; charset=UTF-8">';
                excelFile += "<head>";
                excelFile += "<!--[if gte mso 9]>";
                excelFile += "<xml>";
                excelFile += "<x:ExcelWorkbook>";
                excelFile += "<x:ExcelWorksheets>";
                excelFile += "<x:ExcelWorksheet>";
                excelFile += "<x:Name>";
                excelFile += "sheet";
                excelFile += "</x:Name>";
                excelFile += "<x:WorksheetOptions>";
                excelFile += "<x:DisplayGridlines/>";
                excelFile += "</x:WorksheetOptions>";
                excelFile += "</x:ExcelWorksheet>";
                excelFile += "</x:ExcelWorksheets>";
                excelFile += "</x:ExcelWorkbook>";
                excelFile += "</xml>";
                excelFile += "<![endif]-->";
                excelFile += "</head>";
                excelFile += "<body>";
                excelFile += excel;
                excelFile += "</body>";
                excelFile += "</html>";
                var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(excelFile);
                var link = document.createElement("a");
                link.href = uri;
                link.style = "visibility:hidden";

                link.download = filename + ".xls";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
    };

    rt.revoke = function (entityname, entityid) {
        var data = {
            EntityId: entityid,
            EntityTypeName: entityname
        };
        return rt.post("../api/CrmFlow/revoke", data).then(function (res) {
            rt.showSuccessToast(res);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }).catch(function (error) {
            rt.showErrorToast(error);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
    };

    rt.getBaseUrl = function () {
        if (true) {
            return "";
        }

        var baseUrl = localStorage.serverAddress;
        if (!baseUrl.endWith("/")) {
            baseUrl += "/";
        }

        return baseUrl;
    };

    rt.get = function (apiUrl, params) {
        var queryString = "";
        if (!this.isNull(params)) {
            for (var key in params) {
                queryString += '&' + key + '=' + encodeURIComponent(params[key]);
            }

            queryString = queryString.substr(1);
        }

        if (!this.isNullOrWhiteSpace(queryString)) {
            apiUrl += "?" + queryString;
        }
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(apiUrl).then(function (response) {
            if (response.data != null && response.data.ErrorCode != null) {
                if (response.data.ErrorCode !== 0) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.Message);
                } else {
                    return response.data.Data;
                }
            }
            return response.data;
        }, function (errorResponse) {
            if (errorResponse.status === 401) {
                alert("您没有权限访问该资源.");
                return;
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorResponse.statusText);
        });
    };

    rt.post = function (apiUrl, data, params) {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post(apiUrl, data, params).then(function (response) {
            if (response.data != null && response.data.ErrorCode != null) {
                if (response.data.ErrorCode !== 0) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.Message);
                } else {
                    return response.data.Data;
                }
            }
            return response.data;
        }, function (errorResponse) {
            if (errorResponse.status === 401) {
                alert("您没有权限访问该资源.");
                return;
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorResponse.statusText);
        });
    };

    var loadingInstance;

    rt.sLookup = function (url) {
        var l = (screen.availWidth - 560) / 2;
        var t = (screen.availHeight - 614) / 2;

        window.open(url, "_blank", "width=560,height=614,top=" + t + ",left=" + l + ",toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no");
    };

    rt.editWindow = function (url) {
        var l = (screen.availWidth - 1440) / 2;
        var t = (screen.availHeight - 900) / 2;

        window.open(url, "_blank", "width=1440,height=900,top=" + t + ",left=" + l + ",toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no");
    };

    rt.alert = function (content, callback) {
        rt.showAlertDialog('提示', content, {
            callback: callback
        });
    };

    rt.showAlertDialog = function (title, content, options) {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$alert(content, title, options);
    };

    rt.confirm = function (content) {
        return rt.showConfirmDialog('', content, '确定', '取消', 'info');
    };

    rt.showConfirmDialog = function (title, content, confirmButtonContent, CancelButtonContent, confirmType) {
        if (!rt.isString(title)) {
            throw new Error('rt.showConfirmDialog title parameter must be string.');
        }
        if (!rt.isString(content)) {
            throw new Error('rt.showConfirmDialog content parameter must be string.');
        }
        if (!rt.isString(confirmButtonContent)) {
            throw new Error('rt.showConfirmDialog confirmButtonContent parameter must be string.');
        }
        if (!rt.isString(CancelButtonContent)) {
            throw new Error('rt.showConfirmDialog CancelButtonContent parameter must be string.');
        }
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$confirm(content, title, {
            confirmButtonText: confirmButtonContent,
            CancelButtonText: CancelButtonContent,
            type: confirmType
        });
    };

    rt.showLoadingToast = function (content, dom) {
        if (!rt.isNull(loadingInstance)) {
            return;
        }
        var options = {};
        if (!rt.isNull(content)) {
            options.text = content;
        }
        if (!rt.isNull(dom)) {
            options.target = dom;
        }
        loadingInstance = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$loading(options);
    };

    rt.hideLoadingToast = function () {
        if (rt.isNull(loadingInstance)) {
            return;
        }
        loadingInstance.close();
        loadingInstance = null;
    };

    rt.showErrorToast = function (content, isClose) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message({
            showClose: isClose,
            message: content,
            type: 'error'
        });
    };

    rt.showSuccessToast = function (content, isClose) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message({
            showClose: isClose,
            message: content,
            type: 'success'
        });
    };

    rt.goBack = function () {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].router.go(-1);
    };

    rt.logout = function () {
        rt.showConfirmDialog('', '确认注销？', '确定', '取消', 'warning').then(function () {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$auth.logout();
        });
    };

    rt.logTime = function (message) {
        var time1 = new Date();
        var hour = time1.getHours();
        var min = time1.getMinutes();
        var sec = time1.getSeconds();
        var millsec = time1.getMilliseconds();
        var str = "";
        if (hour < 10) str += "0";
        str += hour;
        str += ":";
        if (min < 10) str += "0";
        str += min;
        str += ":";
        if (sec < 10) str += "0";
        str += sec;
        str += ".";
        if (millsec < 10) sec += "0";
        if (millsec < 100) sec += "0";
        str += millsec;
        if (message) {
            str += "  ";
            str += message;
        }
        console.log(str);
    };

    rt.getUserId = function () {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$auth.getUserInfo().systemUserId;
    };

    rt.getUserName = function () {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$auth.getUserInfo().userCode;
    };

    rt.getPaginationSize = function () {
        return 50;
    };

    rt.refreshParentPage = function () {
        if (window.top != null && window.top.opener != null) {
            window.top.opener.location.reload();
        }
    };

    rt.showFullWindow = function (url) {
        var width = screen.width;
        var height = screen.height;
        return this.showWindow(url, {
            width: width,
            height: height
        });
    };

    rt.showLargeWindow = function (url) {
        return this.showWindow(url, {
            width: 1024,
            height: 768
        });
    };

    rt.showSmallWindow = function (url) {
        return this.showWindow(url, {
            width: 400,
            height: 300
        });
    };

    rt.showWindow = function (url, config) {
        if (this.isNull(config)) {
            config = {};
        }

        if (this.isNull(config.width) || config.width === 0) {
            config.width = 800;
        }

        if (this.isNull(config.height) || config.height === 0) {
            config.height = 600;
        }

        var WINDOWS_TASK_BAR_HEIGHT = 40;
        var winTop = Math.round((screen.height - config.height - WINDOWS_TASK_BAR_HEIGHT) * 0.5);
        var winLeft = Math.round((screen.width - config.width) * 0.5);

        var strFeatures = "help=no,maximize=no,minimize=no,menubar=no,toolbar=no,status=no,location=no,resizable=no" + ",width=" + config.width + ",height=" + config.height + ",top=" + winTop + ",left=" + winLeft;

        window.open(url, "_blank", strFeatures);
    };

    rt.refresh = function () {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].router.go(0);
    };

    Date.prototype.dateAdd = function (datepart, number) {
        var d = new Date(this.getTime());

        var k = {
            'y': 'FullYear',
            'q': 'Month',
            'm': 'Month',
            'w': 'Date',
            'd': 'Date',
            'h': 'Hours',
            'n': 'Minutes',
            's': 'Seconds',
            'ms': 'MilliSeconds'
        };
        var n = {
            'q': 3,
            'w': 7
        };
        eval('d.set' + k[datepart] + '(d.get' + k[datepart] + '()+' + (n[datepart] || 1) * number + ')');
        return d;
    };

    Date.prototype.dateDiff = function (datepart, enddate) {
        var d = this,
            i = {},
            t = d.getTime(),
            t2 = enddate.getTime();
        i['y'] = enddate.getFullYear() - d.getFullYear();
        i['q'] = i['y'] * 4 + Math.floor(enddate.getMonth() / 4) - Math.floor(d.getMonth() / 4);
        i['m'] = i['y'] * 12 + enddate.getMonth() - d.getMonth();
        i['ms'] = enddate.getTime() - d.getTime();
        i['w'] = Math.floor((t2 + 345600000) / 604800000) - Math.floor((t + 345600000) / 604800000);
        i['d'] = Math.floor(t2 / 86400000) - Math.floor(t / 86400000);
        i['h'] = Math.floor(t2 / 3600000) - Math.floor(t / 3600000);
        i['n'] = Math.floor(t2 / 60000) - Math.floor(t / 60000);
        i['s'] = Math.floor(t2 / 1000) - Math.floor(t / 1000);
        return i[datepart];
    };

    Date.prototype.toUniversalTime = function () {
        var yearUTC = this.getUTCFullYear();
        var monthUTC = this.getUTCMonth();
        var dayUTC = this.getUTCDate();
        var hoursUTC = this.getUTCHours();
        var minutesUTC = this.getUTCMinutes();
        var secondsUTC = this.getUTCSeconds();

        return new Date(yearUTC, monthUTC, dayUTC, hoursUTC, minutesUTC, secondsUTC);
    };

    String.prototype.contains = function (substr, ignoreCase) {
        if (ignoreCase === null || ignoreCase === undefined) {
            ignoreCase = false;
        }

        if (ignoreCase) {
            return this.search(new RegExp(substr, "i")) > -1;
        } else {
            return this.search(substr) > -1;
        }
    };

    String.prototype.endWith = function (s, ignoreCase) {
        if (s === null || s === "" || this.length === 0 || s.length > this.length) {
            return false;
        }
        var ns = this.substring(this.length - s.length);
        if (ignoreCase) {
            return ns.toLowerCase() === s.toLowerCase();
        } else {
            return ns === s;
        }
    };

    String.prototype.format = function () {
        var content = this;
        for (var i = 0; i < arguments.length; i++) {
            var replacement = '{' + i + '}';
            content = content.replace(replacement, arguments[i]);
        }
        return content;
    };

    String.prototype.startWith = function (s, ignoreCase) {
        if (s === null || s === "" || this.length === 0 || s.length > this.length) {
            return false;
        }
        var ns = this.substr(0, s.length);
        if (ignoreCase) {
            return ns.toLowerCase() === s.toLowerCase();
        } else {
            return ns === s;
        }
    };

    String.prototype.trim = function (trimChars) {
        var result = this;

        if (typeof trimChars !== "string" || trimChars.length <= 0) {
            trimChars = " ";
        }

        var count = result.length;

        while (count > 0) {
            if (trimChars.indexOf(result[0]) >= 0) {
                result = result.substring(1);
                count--;
            } else {
                break;
            }
        }
        while (count > 0) {
            if (trimChars.indexOf(result[count - 1]) >= 0) {
                result = result.substring(0, count - 1);
                count--;
            } else {
                break;
            }
        }
        return result;
    };

    rt.convertGPS2BaiduLocation = function (longitude, latitude, success) {
        var url = "http://api.map.baidu.com/geoconv/v1/?coords=" + longitude + "," + latitude + "&from=1&to=5&ak=ROninBdEIu93CBGDHc3fSPHE&callback=MYCALLBACK";

        this.jsonp(url, function (data) {
            success(data.result[0]);
        });
    };

    rt.delay = function (action, delayMilliseconds) {
        if (!this.isFunction(action)) {
            throw new Error("第一个参数必须是function对象.");
        }

        if (this.isNull(delayMilliseconds)) {
            delayMilliseconds = 2 * 1000;
        }

        setTimeout(action, delayMilliseconds);
    };

    rt.formatDateTime = function (date, mask, utc) {

        var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
            timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
            timezoneClip = /[^-+\dA-Z]/g,
            pad = function pad(val, len) {
            val = String(val);
            len = len || 2;
            while (val.length < len) {
                val = "0" + val;
            }return val;
        };

        var dateFormat = {
            masks: {},
            i18n: {}
        };

        dateFormat.masks = {
            "default": "ddd mmm dd yyyy HH:MM:ss",
            shortDate: "m/d/yy",
            mediumDate: "mmm d, yyyy",
            longDate: "mmmm d, yyyy",
            fullDate: "dddd, mmmm d, yyyy",
            shortTime: "h:MM TT",
            mediumTime: "h:MM:ss TT",
            longTime: "h:MM:ss TT Z",
            isoDate: "yyyy-mm-dd",
            isoTime: "HH:MM:ss",
            isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
            isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
        };

        dateFormat.i18n = {
            dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        };

        return function (date, mask, utc) {
            var dF = dateFormat;

            if (arguments.length === 1 && Object.prototype.toString.call(date) === "[object String]" && !/\d/.test(date)) {
                mask = date;
                date = undefined;
            }

            date = date ? new Date(date) : new Date();
            if (isNaN(date)) throw SyntaxError("invalid date");

            mask = String(dF.masks[mask] || mask || dF.masks["default"]);

            if (mask.slice(0, 4) == "UTC:") {
                mask = mask.slice(4);
                utc = true;
            }

            var _ = utc ? "getUTC" : "get",
                d = date[_ + "Date"](),
                D = date[_ + "Day"](),
                m = date[_ + "Month"](),
                y = date[_ + "FullYear"](),
                H = date[_ + "Hours"](),
                M = date[_ + "Minutes"](),
                s = date[_ + "Seconds"](),
                L = date[_ + "Milliseconds"](),
                o = utc ? 0 : date.getTimezoneOffset(),
                flags = {
                d: d,
                dd: pad(d),
                ddd: dF.i18n.dayNames[D],
                dddd: dF.i18n.dayNames[D + 7],
                m: m + 1,
                mm: pad(m + 1),
                mmm: dF.i18n.monthNames[m],
                mmmm: dF.i18n.monthNames[m + 12],
                yy: String(y).slice(2),
                yyyy: y,
                h: H % 12 || 12,
                hh: pad(H % 12 || 12),
                H: H,
                HH: pad(H),
                M: M,
                MM: pad(M),
                s: s,
                ss: pad(s),
                l: pad(L, 3),
                L: pad(L > 99 ? Math.round(L / 10) : L),
                t: H < 12 ? "a" : "p",
                tt: H < 12 ? "am" : "pm",
                T: H < 12 ? "A" : "P",
                TT: H < 12 ? "AM" : "PM",
                Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
            };

            return mask.replace(token, function ($0) {
                return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
            });
        };
    }();

    rt.formatNumber = function (number, pattern) {

        var str = number.toString();
        var strInt;
        var strFloat;
        var formatInt;
        var formatFloat;
        if (/\./g.test(pattern)) {
            formatInt = pattern.split('.')[0];
            formatFloat = pattern.split('.')[1];
        } else {
            formatInt = pattern;
            formatFloat = null;
        }

        if (/\./g.test(str)) {
            if (formatFloat !== null) {
                var tempFloat = Math.round(parseFloat('0.' + str.split('.')[1]) * Math.pow(10, formatFloat.length)) / Math.pow(10, formatFloat.length);
                strInt = (Math.floor(number) + Math.floor(tempFloat)).toString();
                strFloat = /\./g.test(tempFloat.toString()) ? tempFloat.toString().split('.')[1] : '0';
            } else {
                strInt = Math.round(number).toString();
                strFloat = '0';
            }
        } else {
            strInt = str;
            strFloat = '0';
        }
        var zero;
        if (formatInt !== null) {
            var outputInt;
            outputInt = '';
            zero = formatInt.match(/0*$/)[0].length;
            var comma = null;
            if (/,/g.test(formatInt)) {
                comma = formatInt.match(/,[^,]*/)[0].length - 1;
            }
            var newReg = new RegExp('(\\d{' + comma + '})', 'g');

            if (strInt.length < zero) {
                outputInt = new Array(zero + 1).join('0') + strInt;
                outputInt = outputInt.substr(outputInt.length - zero, zero);
            } else {
                outputInt = strInt;
            }
            outputInt = outputInt.substr(0, outputInt.length % comma) + outputInt.substring(outputInt.length % comma).replace(newReg, (comma !== null ? ',' : '') + ' JavaScript Content ');
            outputInt = outputInt.replace(/^,/, '');

            strInt = outputInt;
        }

        if (formatFloat !== null) {
            var outputFloat = '';
            zero = formatFloat.match(/^0*/)[0].length;
            if (strFloat.length < zero) {
                outputFloat = strFloat + new Array(zero + 1).join('0');

                var outputFloat1 = outputFloat.substring(0, zero);
                var outputFloat2 = outputFloat.substring(zero, formatFloat.length);
                outputFloat = outputFloat1 + outputFloat2.replace(/0*$/, '');
            } else {
                outputFloat = strFloat.substring(0, formatFloat.length);
            }

            strFloat = outputFloat;
        } else {
            if (pattern !== '' || pattern === '' && strFloat === '0') {
                strFloat = '';
            }
        }

        return strInt + (strFloat === '' ? '' : '.' + strFloat);
    };

    rt.getJSON = function (serverUrl) {
        var xmlhttp = this.getXHR();
        xmlhttp.open("get", serverUrl, false);
        xmlhttp.setRequestHeader("Accept", "application/json");
        xmlhttp.setRequestHeader("Content-Type", "application/json; charset=utf-8");
        xmlhttp.send();
        return xmlhttp.responseText;
    };

    rt.getLastDayOfMonth = function () {

        var Nowdate = new Date();
        var MonthNextFirstDay = new Date(Nowdate.getFullYear(), Nowdate.getMonth() + 1, 1);
        return new Date(MonthNextFirstDay - 86400000);
    };

    rt.getObject = function (serverUrl) {
        var json = this.getJSON(serverUrl);
        try {
            return JSON.parse(json);
        } catch (e) {
            return null;
        }
    };

    rt.getResponse = function (serverUrl) {
        var xmlhttp = rt.getXHR();
        xmlhttp.open("get", serverUrl, false);
        xmlhttp.send();

        return xmlhttp.responseText;
    };

    rt.getScreenHeight = function () {
        return document.documentElement.clientHeight || document.body.clientHeight;
    };

    rt.getScreenWidth = function () {
        return document.documentElement.clientWidth || document.body.clientWidth;
    };

    rt.getUrlParam = function (name) {

        try {
            var query = location.search.substring(1);
            var pairs = query.split("&");
            for (var i = 0; i < pairs.length; i++) {
                var pos = pairs[i].indexOf('=');
                if (pos == -1) continue;
                var argname = pairs[i].substring(0, pos);
                if (argname == name) return pairs[i].substring(pos + 1);
            }
        } catch (e) {
            alert(e);
        }
        return '';
    };

    rt.getXHR = function () {
        if (window.XMLHttpRequest) {
            return new XMLHttpRequest();
        } else if (window.ActiveXObject) {
            try {
                return new ActiveXObject("Microsoft.XMLHTTP");
            } catch (e) {
                return new ActiveXObject("Msxml2.XMLHTTP");
            }
        }
        return null;
    };

    rt.isBoolean = function (obj) {
        return typeof obj === "boolean";
    };

    rt.isCellphone = function (str) {
        var regex = /^1[3|4|5|7|8][0-9]{9}$/;
        return regex.test(str);
    };

    rt.isDate = function (d) {
        if (rt.isNull(d)) {
            return false;
        }

        return d instanceof Date && !isNaN(d.valueOf());
    };

    rt.isEmailAddress = function (str) {
        var regex = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;

        return regex.test(str);
    };

    rt.isFunction = function (f) {
        if (rt.isNull(f)) {
            return false;
        }

        return typeof f === 'function';
    };

    rt.isIDCard = function (str) {
        var regex = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
        return regex.test(str);
    };

    rt.isInteger = function (str) {
        var regex = /^[-]{0,1}[0-9]{1,}$/;
        return regex.test(str);
    };

    rt.isNull = function (o) {
        return o === undefined || o === null;
    };

    rt.isNullOrWhiteSpace = function (s) {
        return this.isNull(s) || s.trim() === "";
    };

    rt.isNumeric = function (str) {

        var regex = /^(-|\+)?\d+(\.\d+)?$/;

        return regex.test(str);
    };

    rt.isPhone = function (str) {
        return this.isCellphone(str) || this.isTelephone(str);
    };

    rt.isSameGuid = function (guid1, guid2) {

        var isEqual;
        if (guid1 === null || guid2 === null) {
            isEqual = false;
        } else {
            isEqual = guid1.replace(/[{}]/g, "").toLowerCase() === guid2.replace(/[{}]/g, "").toLowerCase();
        }

        return isEqual;
    };

    rt.isString = function (obj) {
        return typeof obj === "string";
    };

    rt.isTelephone = function (str) {
        var reg = /^\d{3,4}-\d{7,8}(-\d{3,4})?$/;
        return reg.test(str);
    };

    rt.isUnsignedInteger = function (str) {
        var regex = /^[1]{0,1}[0-9]{1,}$/;

        return regex.test(str);
    };

    rt.isUnsignedNumeric = function (str) {
        var regex = /^\d+(\.\d+)?$/;

        return regex.test(str);
    };

    rt.isUrl = function (str) {
        return !this.isNullOrWhiteSpace(str) && (str.startWith("http://") || str.startWith("https://"));
    };

    rt.jsonp = function (url, callback) {
        var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
        window[callbackName] = function (data) {
            delete window[callbackName];
            document.body.removeChild(script);
            callback(data);
        };

        var script = document.createElement('script');
        script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
        document.body.appendChild(script);
    };

    rt.newGuid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };

    rt.noop = function () {};

    rt.postResponse = function (url, data) {
        var xmlhttp = this.getXHR();
        xmlhttp.open("post", url, false);
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xmlhttp.send(data);

        return xmlhttp.responseText;
    };

    var hexcase = 0;

    var b64pad = "";

    var chrsz = 8;

    rt.md5 = function (s) {
        return hex_md5(s);
    };

    rt.hmacmd5 = function (s) {
        return hex_hmac_md5();
    };

    function hex_md5(s) {
        return binl2hex(core_md5(str2binl(s), s.length * chrsz));
    };

    function b64_md5(s) {
        return binl2b64(core_md5(str2binl(s), s.length * chrsz));
    }

    function str_md5(s) {
        return binl2str(core_md5(str2binl(s), s.length * chrsz));
    }

    function hex_hmac_md5(key, data) {
        return binl2hex(core_hmac_md5(key, data));
    }

    function b64_hmac_md5(key, data) {
        return binl2b64(core_hmac_md5(key, data));
    }

    function str_hmac_md5(key, data) {
        return binl2str(core_hmac_md5(key, data));
    }

    function md5_vm_test() {
        return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
    }

    function core_md5(x, len) {
        x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;

        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;

        for (var i = 0; i < x.length; i += 16) {
            var olda = a;
            var oldb = b;
            var oldc = c;
            var oldd = d;

            a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
            d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
            b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

            a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
            a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

            a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
            d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
            c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

            a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
            d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

            a = safe_add(a, olda);
            b = safe_add(b, oldb);
            c = safe_add(c, oldc);
            d = safe_add(d, oldd);
        }
        return Array(a, b, c, d);
    }

    function md5_cmn(q, a, b, x, s, t) {
        return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
    }

    function md5_ff(a, b, c, d, x, s, t) {
        return md5_cmn(b & c | ~b & d, a, b, x, s, t);
    }

    function md5_gg(a, b, c, d, x, s, t) {
        return md5_cmn(b & d | c & ~d, a, b, x, s, t);
    }

    function md5_hh(a, b, c, d, x, s, t) {
        return md5_cmn(b ^ c ^ d, a, b, x, s, t);
    }

    function md5_ii(a, b, c, d, x, s, t) {
        return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
    }

    function core_hmac_md5(key, data) {
        var bkey = str2binl(key);
        if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

        var ipad = Array(16),
            opad = Array(16);
        for (var i = 0; i < 16; i++) {
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }

        var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
        return core_md5(opad.concat(hash), 512 + 128);
    }

    function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    }

    function bit_rol(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    }

    function str2binl(str) {
        var bin = Array();
        var mask = (1 << chrsz) - 1;
        for (var i = 0; i < str.length * chrsz; i += chrsz) {
            bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
        }return bin;
    }

    function binl2str(bin) {
        var str = "";
        var mask = (1 << chrsz) - 1;
        for (var i = 0; i < bin.length * 32; i += chrsz) {
            str += String.fromCharCode(bin[i >> 5] >>> i % 32 & mask);
        }return str;
    }

    function binl2hex(binarray) {
        var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
        var str = "";
        for (var i = 0; i < binarray.length * 4; i++) {
            str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
        }
        return str;
    }

    function binl2b64(binarray) {
        var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var str = "";
        for (var i = 0; i < binarray.length * 4; i += 3) {
            var triplet = (binarray[i >> 2] >> 8 * (i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4) & 0xFF;
            for (var j = 0; j < 4; j++) {
                if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;else str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
            }
        }
        return str;
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(702)(module)))

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    LOGIN: "Login",
    LOGIN_USERNAME: "Username",
    LOGIN_PASSWORD: "Password",
    LOGIN_FORGOT_PASSWORD: "Forgot password?",
    LOGIN_LOGINING: "Logining",
    LOGIN_PLS_INPUT_USERNAME: "Please input username",
    LOGIN_PLS_INPUT_PASSWORD: "Please input password",
    LOGIN_USERNAME_OR_PASSWORD_INCORRECT: "Incorrect username or password",

    NO_LOGIN_PERMISSIONS: "No login permissions",

    SETTING_ABOUT_ME: "About me",

    SETTING_CHANGE_PASSWORD: "Change Password",
    SETTING_CHANGE_AVATAR: "Change Profile Photo",
    SETTING_LOGOUT: "Logout",

    HOMEPAGE: "Homepage",

    GOODMORNING: "Good morning",
    GOODAFTERNOON: "Good afternoon",
    GOODNIGHT: "Good night",

    More: "More",
    Notice: "Notice",
    NoticePublishTime: "Publish Time",
    DataDownload: "Files",
    FileName: "File Name ",

    Select: "Please Select",
    SelectDate: "Choose A Date",
    QuickSearch: "Quick Search",

    BUTTON_ADD: "Add",
    BUTTON_EDIT: "Edit",
    BUTTON_DELETE: "Delete",
    BUTTON_EXPORT: "Export",
    BUTTON_IMPORT: "Import",
    BUTTON_SEARCH: "Search",
    BUTTON_MORE: "More",
    BUTTON_DOWNLOAD: "Download",

    BUTTON_SAVE: "Save",
    BUTTON_SUBMIT: "Submit",
    BUTTON_RETURN: "Return",
    BUTTON_MAPDISPATCH: "Assign on Map",
    BUTTON_MORESCREEN: "More Options",

    BUTTON_RESET: "Reset",
    BUTTON_BATCHADD: "Batch Add",
    BUTTON_WITHDRAW: "Withdraw",
    BUTTON_APPROVALPROGRESS: "Approval Progress",
    BUTTON_PRINT: "Print",
    BUTTON_DETERMINE: "Determine",
    BUTTON_CANCEL: "Cancel",
    BUTTON_REASSIGN: "Reassign",
    BUTTON_UPLOAD: "Upload",
    BUTTON_ENABLE: "Enable",
    BUTTON_DISABLE: "Disable",
    BUTTON_SYNCHRONISE: "Synchronise",
    BUTTON_CLOSE: "Close",
    BUTTON_RESETPASS: "Reset Password",

    Flow: "Workflow",
    ChooseSignFlow: "Choose An Approval Procedure(Please select the right one from the following options.)",
    ChooseSignUser: "Choose the Approver(Please select the right one from the following options.)",
    ServiceSignStep1: "Approval Progress of Work Order",
    RecordOfApproval: "Approval Record",
    History: "History Record",

    BUTTON_REMOVE: "RemoveValue",
    BUTTON_ConAndSend: "Confirm And Send Invoice",
    BUTTON_ASSIGN: "Assign",
    BUTTON_SIGNANDCON: "Sinn And Confirm",
    BUTTON_REPLY: "Reply",
    BUTTON_SENDCONFIRM: "Ship Confirm",

    BUTTON_SENDVCODE: "Send Verification Code",
    LOGIN_VCODE: "Verification Code",
    LOGIN_PLS_INPUT_VCODE: "Please input verification code"
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    LOGIN: "登录",
    LOGIN_USERNAME: "用户名",
    LOGIN_PASSWORD: "密码",
    LOGIN_FORGOT_PASSWORD: "忘记密码?",
    LOGIN_LOGINING: "登录中",
    LOGIN_PLS_INPUT_USERNAME: "请输入用户名",
    LOGIN_PLS_INPUT_PASSWORD: "请输入密码",
    LOGIN_USERNAME_OR_PASSWORD_INCORRECT: "用户名或密码不正确",

    NO_LOGIN_PERMISSIONS: "当前用户没有登录权限",

    SETTING_CHANGE_PASSWORD: "更改密码",
    SETTING_CHANGE_AVATAR: "更换头像",
    SETTING_LOGOUT: "注销",

    HOMEPAGE: "首页",
    PRODUCTLIST: "产品价格查询",
    KHGL: "客户管理",
    BUSINESSMANAGEMENT: "商务管理",
    NONSTANDARDAUDIT: "非标评审",
    ORDERMANAGEMENT: "订单管理",
    TECHNICALSUPPORT: "技术支持",
    SALESSERVICE: "售后服务",
    FINANCIALMANAGEMENT: "财务管理",
    ORDERORSHIPMENT: "下单/发货预测",
    MAINTENCEORDER: "维修申请订单",
    QUERYLIST: "维修订单",
    PARTSSTANDARD: "配件/标准订单申请报表查询",
    ORDERSTATUSQUERY: "配件/标准订单完工入库情况查询",
    DEALERORDER: "标准/配件订单下单申请",
    KEHU: "客户",
    CONTACT: "联系人",
    LEAD: "线索报备",
    LEADREGINSTER: "线索跟进任务",
    STANDARDORDER: "标准订单",
    PARTSORDER: "配件订单",
    OPPORTUNITY: "商机管理",
    PROJECTCREDIT: "项目授权申请",
    SERVICETICKET: "服务单",
    PARTSBORROW: "配件借用",
    APPLICATION: "开票申请",
    DELIVERYNOTE: "开票申请首页",
    INVOICEAPPLICATIONLIST: "开票申请列表",
    INVOICEDELIVERYLIST: "发票签收",
    INVOICEDEALERLIST: "发票",

    RECEPTION: "客户接待",
    APPLYSERVICE: "工程/售后服务申请",
    ORDERMAINTAIN: "维修申请订单",
    CROSSPROJECTITEM: "跨区域工程项目",
    TICKETSUM: "经销商可开票汇总",
    ACHIEVEMENTAPPLY: "跨区域服务费结算任务",
    PAYMENTAPPLY: "付款申请",
    PJTITEM: "工程项目",
    QUALITY: "品质反馈",
    PROJECTSUPPORT: "项目技术支持任务",
    EXPACHIEVEMENTAPPLY: "跨区域业绩划拨利润",
    SERVICESUPPORT: "按次服务支持任务",
    ACCOUNTPROJECT: "客户项目",
    EQUIPMENTRECEIVE: "仓库收货",
    PROJECTLIST: "项目设备管理",
    DEALERCHARGE: "待请款金额",
    DEALERLETTER: "函件管理",

    GOODMORNING: "早上好",
    GOODAFTERNOON: "中午好",
    GOODNIGHT: "晚上好",

    More: "更多",
    Notice: "公告标题",
    NOTICELIST: "公告通知",
    NoticePublishTime: "发布时间",
    DataDownload: "资料下载 ",
    FileName: "文件名 ",
    MesContent: "消息内容",
    FormCode: "单号",
    SendTime: "发送时间",

    DealerRights: "经销商权益",

    Select: "请选择",
    SelectDate: "选择日期",
    QuickSearch: "快速搜索",

    BUTTON_ADD: "新增",
    BUTTON_EDIT: "编辑",
    BUTTON_DELETE: "删除",
    BUTTON_EXPORT: "导出",
    BUTTON_IMPORT: "导入",
    BUTTON_SEARCH: "查询",
    BUTTON_MORE: "更多",
    BUTTON_DOWNLOAD: "下载",

    BUTTON_SAVE: "保存",
    BUTTON_SUBMIT: "提交",
    BUTTON_RETURN: "返回",
    BUTTON_MAPDISPATCH: "地图派工",
    BUTTON_MORESCREEN: "更多筛选",

    BUTTON_RESET: "重置",
    BUTTON_BATCHADD: "批量添加",
    BUTTON_WITHDRAW: "撤回",
    BUTTON_APPROVALPROGRESS: "审批进度",
    BUTTON_PRINT: "打印",
    BUTTON_DETERMINE: "确定",
    BUTTON_CANCEL: "取消",
    BUTTON_REASSIGN: "改派",
    BUTTON_UPLOAD: "上传",
    BUTTON_ENABLE: "启用",
    BUTTON_DISABLE: "停用",
    BUTTON_SYNCHRONISE: "同步",
    BUTTON_CLOSE: "关闭",
    BUTTON_RESETPASS: "重置密码",

    Flow: "签核流程",
    ChooseSignFlow: "选择签核流程 (下拉框中可能存在多个可选项目,请注意选择合适的流程)",
    ChooseSignUser: "选择签核用户 (下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)",
    ServiceSignStep1: "服务单签核步骤1",
    RecordOfApproval: "审批记录",
    History: "历史记录",

    BUTTON_REMOVE: '移除值',
    BUTTON_ConAndSend: "确认并寄送发票",
    BUTTON_ASSIGN: "派工",
    BUTTON_SIGNANDCON: "签收确认",
    BUTTON_REPLY: "回复",
    BUTTON_SENDCONFIRM: "发运确认",

    BUTTON_SENDVCODE: "发送验证码",
    LOGIN_VCODE: "验证码",
    LOGIN_PLS_INPUT_VCODE: "请输入验证码",
    CREDITINFOLIST: "授信申请",
    DEALERBILLLIST: "账单管理",
    DELAYLIST: "账单延期申请",

    ACCOUNTINFO: "账户信息",
    CHECKBILL: "对账单",
    ZHANGHUZICHAN: '账户资产',
    HANJIAN: '函件管理',
    KEHULIEBIAO: '客户列表',
    XIADAN: '下单申请',
    GONGCHENG: '跨区工程申请',
    ZHICHI: '技术支持服务',
    SHOUHOU: '跨区售后申请',
    SHOUXIN: '授信申请',
    SERVICEORDERFORM: '服务订单',
    PURCHASEORDERFORM: '采购订单',
    SHIPMENT: '出货信息',
    FWRY2: '服务人员'
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ "new_srv_claimfine": "Bonus and Punishment", "new_srv_claimfine.versionnumber": null, "new_srv_claimfine.createdon": "Created On", "new_srv_claimfine.new_findate": "Date", "new_srv_claimfine.new_type": "Working Related", "new_srv_claimfine.new_curr_flowstepsid": "Current Approval Step", "new_srv_claimfine.new_curr_approvestep_name": "Current Approval Step", "new_srv_claimfine.new_last_approve_time": "The Last Approval Time", "new_srv_claimfine.new_checkmonth": "Month", "new_srv_claimfine.new_curr_flowsteps_seq": "Current Approval Step Number", "new_srv_claimfine.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_claimfine.new_last_flowstepsid": "The Last Approval Step", "new_srv_claimfine.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_claimfine.new_name": "Document Number", "new_srv_claimfine.owningteam": "Owning Team", "new_srv_claimfine.overriddencreatedon": "Record Created On", "new_srv_claimfine.new_submit_time": "Submitted On", "new_srv_claimfine.statecode": "Status", "new_srv_claimfine.statecode0": "Active", "new_srv_claimfine.statecode1": "Inactive", "new_srv_claimfine.new_checkitem": "For What", "new_srv_claimfine.new_last_flowsteps_seq": "The Last Approval Step Number", "new_srv_claimfine.new_approvalstatus": "Approval State", "new_srv_claimfine.new_approvalstatus1": "To be Submitted", "new_srv_claimfine.new_approvalstatus2": "Under Review", "new_srv_claimfine.new_approvalstatus3": "Approved", "new_srv_claimfine.new_approvalstatus4": "Rejected", "new_srv_claimfine.new_approvalstatus5": "Veto", "new_srv_claimfine.new_amount": "Sum of Bonus and Punishment", "new_srv_claimfine.new_last_approvestep_user": "The Last Approval Person", "new_srv_claimfine.new_finetype": "Bonus or Punishment", "new_srv_claimfine.new_finetype1": "Bonus", "new_srv_claimfine.new_finetype2": "Punishment", "new_srv_claimfine.createdonbehalfby": "Created By (Delegate)", "new_srv_claimfine.createdby": "Created By", "new_srv_claimfine.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_claimfine.new_year": "Year", "new_srv_claimfine.new_srv_station_id": "Service Station", "new_srv_claimfine.ownerid": "Owner", "new_srv_claimfine.modifiedon": "Modified On", "new_srv_claimfine.importsequencenumber": "Import Sequence Number", "new_srv_claimfine.new_curr_approvestep_user": "Current Approver", "new_srv_claimfine.new_approved_time": "Approval Tme", "new_srv_claimfine.modifiedby": "Modified By", "new_srv_claimfine.new_expenseclaimid": "Expense Settlement Number", "new_srv_claimfine.new_srv_workorderid": "Work Order", "new_srv_claimfine.new_srv_claimfineid": "Document Number of Bonus and Punishment", "new_srv_claimfine.owninguser": "Owning User", "new_srv_claimfine.new_iscommit": "Limited or Not", "new_srv_claimfine.new_iscommit0": "NO", "new_srv_claimfine.new_iscommit1": "YES", "new_srv_claimfine.statuscode": "Status Reason", "new_srv_claimfine.statuscode1": "Active", "new_srv_claimfine.statuscode2": "Inactive", "new_srv_claimfine.new_last_approvestep_name": "The Last Approval Step", "new_srv_claimfine.new_memo": "Memo", "new_srv_claimfine.owningbusinessunit": "Owning Business Unit", "new_srv_trouble": "Malfunction Mode Information", "new_srv_trouble.new_memo": "Memo", "new_srv_trouble.owningteam": "Owning Team", "new_srv_trouble.statecode": "Status", "new_srv_trouble.statecode0": "Active", "new_srv_trouble.statecode1": "Inactive", "new_srv_trouble.new_srv_errorgroup_id": "Spart Parts with Malfunction", "new_srv_trouble.new_solution": "Maintainance Measures", "new_srv_trouble.owninguser": "Owning User", "new_srv_trouble.createdonbehalfby": "Created By (Delegate)", "new_srv_trouble.new_srv_troubleid": "Malfunction Mode Information", "new_srv_trouble.importsequencenumber": "Import Sequence Number", "new_srv_trouble.new_srv_workorder_id": "Work Order Number", "new_srv_trouble.new_srv_errorassembly_id": "System with Malfunction", "new_srv_trouble.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_trouble.owningbusinessunit": "Owning Business Unit", "new_srv_trouble.new_name": "Name", "new_srv_trouble.modifiedby": "Modified By", "new_srv_trouble.createdby": "Created By", "new_srv_trouble.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_trouble.new_description": "Malfunction Description", "new_srv_trouble.modifiedon": "Modified On", "new_srv_trouble.statuscode": "Status Reason", "new_srv_trouble.statuscode1": "Active", "new_srv_trouble.statuscode2": "Inactive", "new_srv_trouble.createdon": "Created On", "new_srv_trouble.new_srv_workhours_id": "Maintainance Memo", "new_srv_trouble.new_errormodule_id": "Parts with Malfunction", "new_srv_trouble.new_srv_error_id": "Phenomenon with Malfunction", "new_srv_trouble.versionnumber": null, "new_srv_trouble.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_trouble.ownerid": "Owner", "new_srv_trouble.overriddencreatedon": "Record Created On", "kbarticle": "Article", "kbarticle.modifiedonbehalfby": "Modified By (Delegate)", "kbarticle.statecode": "Status ", "kbarticle.statecode1": "Draft", "kbarticle.statecode2": "Unapproved", "kbarticle.statecode3": "Published", "kbarticle.languagecode": "Language", "kbarticle.createdon": "Created On", "kbarticle.createdonbehalfby": "Created By (Delegate)", "kbarticle.transactioncurrencyid": "Currency", "kbarticle.entityimageid": "Entity Image Id", "kbarticle.importsequencenumber": "Import Sequence Number", "kbarticle.organizationid": "Organization", "kbarticle.kbarticletemplateid": "Base Template", "kbarticle.subjectid": "Subject", "kbarticle.comments": "Comments", "kbarticle.statuscode": "Status Reason", "kbarticle.statuscode1": "Draft", "kbarticle.statuscode2": "Unapproved", "kbarticle.statuscode3": "Published", "kbarticle.keywords": "Key Words", "kbarticle.versionnumber": "Title", "kbarticle.modifiedby": "Modified By", "kbarticle.createdby": "Created By", "kbarticle.articlexml": "Article XML", "kbarticle.exchangerate": "Exchange Rate", "kbarticle.kbarticleid": "Article", "kbarticle.modifiedon": "Modified On", "kbarticle.title": "Title", "kbarticle.content": "Content", "kbarticle.number": "Number", "kbarticle.description": "Description", "kbarticle.overriddencreatedon": "Record Created On", "new_srv_station": "Service Station Profile", "new_srv_station.owninguser": "Owning User", "new_srv_station.statecode": "Status", "new_srv_station.statecode0": "Active", "new_srv_station.statecode1": "Inactive", "new_srv_station.new_province_id": "Province", "new_srv_station.new_city_id": "City", "new_srv_station.new_email": "Email Address", "new_srv_station.new_siteowner": "Principal of Service Station", "new_srv_station.versionnumber": null, "new_srv_station.new_county_id": "County", "new_srv_station.createdonbehalfby": "Created By (Delegate)", "new_srv_station.new_fax": "Fax", "new_srv_station.importsequencenumber": "Import Sequence Number", "new_srv_station.new_name": "Name of Service Station", "new_srv_station.new_type": "Type of Service Station", "new_srv_station.new_type1": "Self-employed", "new_srv_station.new_type2": "Partner", "new_srv_station.new_type3": "Owned", "new_srv_station.new_region_id": "Region", "new_srv_station.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_station.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_station.statuscode": "Status Reason", "new_srv_station.statuscode1": "Active", "new_srv_station.statuscode2": "Inactive", "new_srv_station.owningbusinessunit": "Owning Business Unit", "new_srv_station.new_phone": "Telephone of Principal", "new_srv_station.owningteam": "Owning Team", "new_srv_station.modifiedby": "Modified By", "new_srv_station.new_code": "Service Station Number", "new_srv_station.new_address": "Address", "new_srv_station.new_level": "Level of  Service Station", "new_srv_station.new_level1": "First Level", "new_srv_station.new_level2": "Second Level", "new_srv_station.new_level3": "Third Level", "new_srv_station.new_areacode_id": "Region Code", "new_srv_station.new_currentamount": "Curent Quota", "new_srv_station.modifiedon": "Modified On", "new_srv_station.new_region": "Area", "new_srv_station.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_station.new_srv_stationid": "Service Station Pofile", "new_srv_station.createdon": "Created On", "new_srv_station.createdby": "Created By", "new_srv_station.new_limitamount": "Limit Quota or Not", "new_srv_station.new_limitamount0": "NO", "new_srv_station.new_limitamount1": "YES", "new_srv_station.new_postalcode": "Postal Code", "new_srv_station.new_beginamount": "Original Quota", "new_srv_station.ownerid": "Owner", "new_srv_station.overriddencreatedon": "Record Created On", "new_srv_outsideline": "Expediture Detail", "new_srv_outsideline.new_memo": "Expense Description", "new_srv_outsideline.owningteam": "Owning Team", "new_srv_outsideline.new_endstate": "Completion Situation", "new_srv_outsideline.new_endstate1": "Completed", "new_srv_outsideline.new_endstate2": "Service Again", "new_srv_outsideline.new_endstate3": "Failure", "new_srv_outsideline.statecode": "Status", "new_srv_outsideline.statecode0": "Active", "new_srv_outsideline.statecode1": "Inactive", "new_srv_outsideline.statuscode": "Status Reason", "new_srv_outsideline.statuscode1": "Active", "new_srv_outsideline.statuscode2": "Inactive", "new_srv_outsideline.new_begintime": "Departed On", "new_srv_outsideline.new_foodcost": "Food and Beverage Fee", "new_srv_outsideline.createdonbehalfby": "Created By (Delegate)", "new_srv_outsideline.transactioncurrencyid": "Currency", "new_srv_outsideline.new_end": "Arrival Location", "new_srv_outsideline.new_endmemo": "Arrival Location", "new_srv_outsideline.new_statecode": "Service State", "new_srv_outsideline.new_statecode1": "To be Reserved", "new_srv_outsideline.new_statecode2": "To set off", "new_srv_outsideline.new_statecode3": "Set off", "new_srv_outsideline.new_statecode4": "Arrived", "new_srv_outsideline.new_statecode10": "Finished", "new_srv_outsideline.new_appointmenttime": "Appointment Time", "new_srv_outsideline.importsequencenumber": "Import Sequence Number", "new_srv_outsideline.createdon": "Created On", "new_srv_outsideline.owninguser": "Owning User", "new_srv_outsideline.new_srv_workorder_id": "Work Order Number", "new_srv_outsideline.versionnumber": null, "new_srv_outsideline.modifiedon": "Modified On", "new_srv_outsideline.new_stationid": "Service Station", "new_srv_outsideline.new_otherfee": "Other Expenses", "new_srv_outsideline.new_name": "Name", "new_srv_outsideline.modifiedby": "Modified By", "new_srv_outsideline.createdby": "Created By", "new_srv_outsideline.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_outsideline.overriddencreatedon": "Record Created On", "new_srv_outsideline.new_srv_worker_id": "Service Personal", "new_srv_outsideline.owningbusinessunit": "Owning Business Unit", "new_srv_outsideline.new_returntime": "Returned On", "new_srv_outsideline.new_arrivepoint": "Arrival Latitude and Longitude", "new_srv_outsideline.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_outsideline.exchangerate": "Exchange Rate", "new_srv_outsideline.new_appointmentcreatetime": "Reservation Created On", "new_srv_outsideline.ownerid": "Owner", "new_srv_outsideline.new_travelcost": "Trafifc Expense", "new_srv_outsideline.new_solution": "Memo", "new_srv_outsideline.new_arrivetime": "Arrived On", "new_srv_outsideline.new_start": "Departed Location", "new_srv_outsideline.new_startmemo": "Expediture Detail", "new_srv_outsideline.new_boardcost": "Accommodation Fee", "new_srv_outsideline.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_outsideline.new_srv_outsidelineid": "Expediture Detail", "new_srv_outsideline.new_startpoint": "Departure Latitude and Longitude", "new_srv_worker": "Service Personal", "new_srv_worker.owninguser": "Owning User", "new_srv_worker.owningteam": "Owning Team", "new_srv_worker.statecode": "Status", "new_srv_worker.statecode0": "Active", "new_srv_worker.statecode1": "Inactive", "new_srv_worker.statuscode": "Status Reason", "new_srv_worker.statuscode1": "Active", "new_srv_worker.statuscode2": "Inactive", "new_srv_worker.createdonbehalfby": "Created By (Delegate)", "new_srv_worker.new_trainnumber": "Training Times", "new_srv_worker.importsequencenumber": "Import Sequence Number", "new_srv_worker.new_skill": "Skills", "new_srv_worker.versionnumber": null, "new_srv_worker.new_srv_workerid": "Service Staff", "new_srv_worker.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_worker.owningbusinessunit": "Owning Business Unit", "new_srv_worker.new_phone": "Telephone", "new_srv_worker.new_name": "Name", "new_srv_worker.modifiedby": "Modified By", "new_srv_worker.new_code": "Code of Service Personal", "new_srv_worker.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_worker.new_workyear": "Working Years", "new_srv_worker.new_srv_station_id": "Service Station", "new_srv_worker.modifiedon": "Modified On", "new_srv_worker.new_sex": "Sex", "new_srv_worker.new_sex1": "Male", "new_srv_worker.new_sex2": "Female", "new_srv_worker.new_region": "Responsible Regions", "new_srv_worker.createdon": "Created On", "new_srv_worker.createdby": "Created By", "new_srv_worker.new_job": "Job Title", "new_srv_worker.new_job1": "Junior Engineer", "new_srv_worker.new_job2": "Mid-level Engineer", "new_srv_worker.new_job3": "Senior Engineer", "new_srv_worker.new_wechat": "WeChat Name", "new_srv_worker.new_password": "XMobile Password", "new_srv_worker.new_postalcode": "Postal Code", "new_srv_worker.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_worker.new_educationlevel": "Education Degree", "new_srv_worker.new_educationlevel1": "Primary School", "new_srv_worker.new_educationlevel2": "Middle School", "new_srv_worker.new_educationlevel3": "Secondary School", "new_srv_worker.new_educationlevel4": "High School", "new_srv_worker.new_educationlevel5": "Technical School", "new_srv_worker.new_educationlevel6": "College", "new_srv_worker.new_educationlevel7": "University", "new_srv_worker.ownerid": "Owner", "new_srv_worker.overriddencreatedon": "Record Created On", "new_srv_expense_claim": "Expense Settlement", "new_srv_expense_claim.versionnumber": null, "new_srv_expense_claim.new_settleway": "Settlement Principle", "new_srv_expense_claim.new_settleway1": "By Working Hours", "new_srv_expense_claim.new_settleway2": "By Contract", "new_srv_expense_claim.createdon": "Created On", "new_srv_expense_claim.owninguser": "Owning User", "new_srv_expense_claim.new_srv_expense_claimid": "Expense Settlement", "new_srv_expense_claim.new_bankname": "Account Name", "new_srv_expense_claim.createdonbehalfby": "Created By (Delegate)", "new_srv_expense_claim.new_totalcost": "Total Amount of Money", "new_srv_expense_claim.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_expense_claim.new_branchamount": "Approved Amount oF Money", "new_srv_expense_claim.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_expense_claim.new_name": "Expense Settlement Number", "new_srv_expense_claim.new_month": "Month", "new_srv_expense_claim.new_month1": "1", "new_srv_expense_claim.new_month2": "2", "new_srv_expense_claim.new_month3": "3", "new_srv_expense_claim.new_month4": "4", "new_srv_expense_claim.new_month5": "5", "new_srv_expense_claim.new_month6": "6", "new_srv_expense_claim.new_month7": "7", "new_srv_expense_claim.new_month8": "8", "new_srv_expense_claim.new_month9": "9", "new_srv_expense_claim.new_month10": "10", "new_srv_expense_claim.new_month11": "11", "new_srv_expense_claim.new_month12": "12", "new_srv_expense_claim.new_workhourcost": "Total Work hour Expenses", "new_srv_expense_claim.new_manexpense": "Total Work hour Expenses", "new_srv_expense_claim.owningteam": "Owning Team", "new_srv_expense_claim.overriddencreatedon": "Record Created On", "new_srv_expense_claim.new_submit_time": "Submitted On", "new_srv_expense_claim.statecode": "Status", "new_srv_expense_claim.statecode0": "Active", "new_srv_expense_claim.statecode1": "Inactive", "new_srv_expense_claim.new_expressname": "Delivery Provider", "new_srv_expense_claim.new_othercost": "Total Amount of Other Expenses", "new_srv_expense_claim.new_sendnumber": "Delivery Number", "new_srv_expense_claim.new_decreasecarriage": "Delivery Expense", "new_srv_expense_claim.new_maker": "Created By", "new_srv_expense_claim.new_performance": "Examination Result", "new_srv_expense_claim.new_approvalstatus": "Approval State", "new_srv_expense_claim.new_approvalstatus1": "To be Submitted", "new_srv_expense_claim.new_approvalstatus2": "Under Review", "new_srv_expense_claim.new_approvalstatus3": "Approved", "new_srv_expense_claim.new_fineamount": "Total Amount of Adjusted Expenses", "new_srv_expense_claim.new_approvaltime": "Approved On", "new_srv_expense_claim.new_partcost": "Total Amount of Parts Expenses", "new_srv_expense_claim.new_invoicedate": "Date of Invoice Received", "new_srv_expense_claim.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_expense_claim.new_otherfeeremark": "Description of Other Expenses", "new_srv_expense_claim.new_formstatus": "Expense Settlement State", "new_srv_expense_claim.new_formstatus1": "To be Submitted", "new_srv_expense_claim.new_formstatus2": "Old Parts to be Returned", "new_srv_expense_claim.new_formstatus3": "Old Parts to be Received", "new_srv_expense_claim.new_formstatus4": "Expenses to be Calculated", "new_srv_expense_claim.new_formstatus5": "Expenses to be Confirmed", "new_srv_expense_claim.new_formstatus6": "Expenses Confirmed", "new_srv_expense_claim.new_formstatus7": "Invoice Accepted", "new_srv_expense_claim.new_formstatus8": "Expenses Paid", "new_srv_expense_claim.new_year": "Year", "new_srv_expense_claim.new_year2013": "2013", "new_srv_expense_claim.new_year2014": "2014", "new_srv_expense_claim.new_year2015": "2015", "new_srv_expense_claim.new_year2016": "2016", "new_srv_expense_claim.new_year2017": "2017", "new_srv_expense_claim.new_year2018": "2018", "new_srv_expense_claim.new_year2019": "2019", "new_srv_expense_claim.new_year2020": "2020", "new_srv_expense_claim.new_bank": "Bank Name", "new_srv_expense_claim.new_branchcomment": "Approval Opinion", "new_srv_expense_claim.modifiedon": "Modified On", "new_srv_expense_claim.importsequencenumber": "Import Sequence Number", "new_srv_expense_claim.new_approved_time": "Approved On", "new_srv_expense_claim.new_siteconfirmstatus": "Service Station Confirmed or Not", "new_srv_expense_claim.new_siteconfirmstatus1": "Unstarted", "new_srv_expense_claim.new_siteconfirmstatus2": "Confirming", "new_srv_expense_claim.new_siteconfirmstatus3": "Confirmed", "new_srv_expense_claim.new_siteconfirmstatus4": "Rejected", "new_srv_expense_claim.ownerid": "Owner", "new_srv_expense_claim.new_cityid": "City of the Bank", "new_srv_expense_claim.new_outsidecost": "Total Travel Expenses", "new_srv_expense_claim.new_addcarriage": "Transportation Expense Allowance", "new_srv_expense_claim.new_approvalamount": "Approved Amount", "new_srv_expense_claim.createdby": "Created By", "new_srv_expense_claim.modifiedby": "Modified By", "new_srv_expense_claim.new_srv_station_id": "Service Station", "new_srv_expense_claim.new_confirmdate": "Confirmed Date", "new_srv_expense_claim.new_adjustamount": "Final Amount", "new_srv_expense_claim.new_section": "Expenses Period", "new_srv_expense_claim.new_section1": "First Half of the Year", "new_srv_expense_claim.new_section2": "Second Half of the Year", "new_srv_expense_claim.new_sitecode": "Service Provider Code", "new_srv_expense_claim.owningbusinessunit": "Owning Business Unit", "new_srv_expense_claim.new_ispayed": "Payment Received or Not", "new_srv_expense_claim.new_ispayed0": "NO", "new_srv_expense_claim.new_ispayed1": "YES", "new_srv_expense_claim.new_returnamount": "Transportation Expenses of Parts Return and Transfer", "new_srv_expense_claim.new_payeddate": "Paid On", "new_srv_expense_claim.new_oldpartamount": "Transportation Expenses of Parts Back to Factory", "new_srv_expense_claim.new_iscommit": "Submitted or Not", "new_srv_expense_claim.new_iscommit0": "NO", "new_srv_expense_claim.new_iscommit1": "YES", "new_srv_expense_claim.new_provinceid": "Province of Bank", "new_srv_expense_claim.new_bankcode": "Account Number", "new_srv_expense_claim.statuscode": "Status Reason", "new_srv_expense_claim.statuscode1": "Active", "new_srv_expense_claim.statuscode2": "Inactive", "new_srv_expense_claim.new_invoiceno": "Invoice Number", "new_noticeread": "Notice Read and Reply", "new_noticeread.modifiedonbehalfby": "Modified By (Delegate)", "new_noticeread.new_replystatus": "Reply State", "new_noticeread.new_replystatus1": "Unreplied", "new_noticeread.new_replystatus2": "Replied", "new_noticeread.statecode": "Status", "new_noticeread.statecode0": "Active", "new_noticeread.statecode1": "Inactive", "new_noticeread.new_replydate": "Replied On", "new_noticeread.statuscode": "Status Reason", "new_noticeread.statuscode1": "Active", "new_noticeread.statuscode2": "Inactive", "new_noticeread.owninguser": "Owning User", "new_noticeread.createdonbehalfby": "Created By (Delegate)", "new_noticeread.new_readercode": "Read By", "new_noticeread.new_noticereadid": "Notice Read and Reply", "new_noticeread.importsequencenumber": "Import Sequence Number", "new_noticeread.new_name": "Name", "new_noticeread.versionnumber": null, "new_noticeread.new_readstatus": "Notice Read State", "new_noticeread.new_readstatus1": "Unread", "new_noticeread.new_readstatus2": "Rread", "new_noticeread.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_noticeread.owningbusinessunit": "Owning Business Unit", "new_noticeread.owningteam": "Owning Team", "new_noticeread.modifiedby": "Modified By", "new_noticeread.createdby": "Created By", "new_noticeread.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_noticeread.modifiedon": "Modified On", "new_noticeread.new_replycontent": "Content", "new_noticeread.createdon": "Created On", "new_noticeread.new_isreply": "Is reply necessary or not?", "new_noticeread.new_isreply0": "NO", "new_noticeread.new_isreply1": "YES", "new_noticeread.new_noticeid": "Document Number", "new_noticeread.new_publishdate": "Released On", "new_noticeread.new_readername": "Read By", "new_noticeread.ownerid": "Owner", "new_noticeread.overriddencreatedon": "Record Created On", "new_srv_expense_claimline": "Expenses Settlement Details", "new_srv_expense_claimline.owninguser": "Owning User", "new_srv_expense_claimline.new_workhourcost": "Work hour Expenses", "new_srv_expense_claimline.new_othercost": "Other Expenses", "new_srv_expense_claimline.createdonbehalfby": "Created By (Delegate)", "new_srv_expense_claimline.new_totalcost": "Total Amount", "new_srv_expense_claimline.new_srv_expense_claim_id": "Expense Settlement Number", "new_srv_expense_claimline.importsequencenumber": "Import Sequence Number", "new_srv_expense_claimline.statecode": "Status", "new_srv_expense_claimline.statecode0": "Active", "new_srv_expense_claimline.statecode1": "Inactive", "new_srv_expense_claimline.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_expense_claimline.new_otherfeedesc": "Description of Other Expenses", "new_srv_expense_claimline.owningbusinessunit": "Owning Business Unit", "new_srv_expense_claimline.new_name": "Document Number", "new_srv_expense_claimline.modifiedby": "Modified By", "new_srv_expense_claimline.createdby": "Created By", "new_srv_expense_claimline.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_expense_claimline.new_srv_station_id": "Service Station", "new_srv_expense_claimline.owningteam": "Owning Team", "new_srv_expense_claimline.new_srv_expense_claimlineid": "Expenses Settlement Details", "new_srv_expense_claimline.modifiedon": "Modified On", "new_srv_expense_claimline.new_outsidecost": "Expediture Expenses", "new_srv_expense_claimline.new_srv_workorderid": "Work Order", "new_srv_expense_claimline.statuscode": "Status Reason", "new_srv_expense_claimline.statuscode1": "Active", "new_srv_expense_claimline.statuscode2": "Inactive", "new_srv_expense_claimline.createdon": "Created On", "new_srv_expense_claimline.new_partcost": "Parts Expenses", "new_srv_expense_claimline.versionnumber": null, "new_srv_expense_claimline.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_expense_claimline.ownerid": "Owner", "new_srv_expense_claimline.overriddencreatedon": "Record Created On", "new_notice": "Notice", "new_notice.new_ispublish": "Released or Not?", "new_notice.new_ispublish0": "NO", "new_notice.new_ispublish1": "YES", "new_notice.modifiedonbehalfby": "Modified By (Delegate)", "new_notice.owningteam": "Owning Team", "new_notice.modifiedon": "Modified On", "new_notice.statecode": "Status", "new_notice.statecode0": "Active", "new_notice.statecode1": "Inactive", "new_notice.new_isurgent": "Urgent or Not", "new_notice.new_isurgent0": "NO", "new_notice.new_isurgent1": "YES", "new_notice.owninguser": "Owning User", "new_notice.createdonbehalfby": "Created By (Delegate)", "new_notice.new_buid": "Released Department", "new_notice.new_publishdate": "Released On", "new_notice.importsequencenumber": "Import Sequence Number", "new_notice.new_type": "Notice Type", "new_notice.new_type100000000": "Marketing Policy", "new_notice.new_type100000001": "Marketing Policy", "new_notice.new_type100000002": "Product Notice", "new_notice.new_type1": "Administrative Notice", "new_notice.new_type2": "Sales Policy", "new_notice.new_type3": "Promotion Notice", "new_notice.new_type4": "New Product Release", "new_notice.new_type5": "Others", "new_notice.new_noticetypeid": "Notice Type", "new_notice.new_isreply": "Is reply necessary or not?", "new_notice.new_isreply0": "NO", "new_notice.new_isreply1": "YES", "new_notice.owningbusinessunit": "Owning Business Unit", "new_notice.new_noticeid": "Notice", "new_notice.new_name": "Document Number", "new_notice.modifiedby": "Modified By", "new_notice.createdby": "Created By", "new_notice.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_notice.statuscode": "Status Reason", "new_notice.statuscode1": "Active", "new_notice.statuscode2": "Inactive", "new_notice.createdon": "Created On", "new_notice.new_content": "Content", "new_notice.versionnumber": null, "new_notice.new_title": "Notice Title", "new_notice.ownerid": "Released By", "new_notice.overriddencreatedon": "Record Created On", "new_notice.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "product": "Product", "product.iskit": "Is Kit", "product.iskit0": "No", "product.iskit1": "Yes", "product.productid": "Product", "product.createdon": "Created On", "product.currentcost": "Current Cost", "product.standardcost_base": "Standard Cost (Base)", "product.new_productmodel": "#N/A", "product.productstructure": "Product Structure", "product.productstructure1": "Product", "product.productstructure2": "Product Family", "product.productstructure3": "Product Bundle", "product.new_productgroupid": "Product line", "product.validfromdate": "Valid From", "product.new_productgroup": "Product or Parts", "product.new_productgroup1": "Product", "product.new_productgroup2": "Parts", "product.price_base": "List Price (Base)", "product.modifiedonbehalfby": "Modified By (Delegate)", "product.exchangerate": "Exchange Rate", "product.overriddencreatedon": "Record Created On", "product.producturl": "URL", "product.statecode": "Status", "product.statecode0": "Active", "product.statecode1": "Retired", "product.statecode2": "Draft", "product.statecode3": "Under Revision", "product.price": "List Price", "product.defaultuomscheduleid": "Unit Group", "product.timezoneruleversionnumber": "Time Zone Rule Version Number", "product.new_productin": "#N/A", "product.size": "Size", "product.pricelevelid": "Default Price List", "product.new_is_barcodemanagement": "#N/A", "product.new_is_barcodemanagement1": "#N/A", "product.new_is_barcodemanagement2": "#N/A", "product.versionnumber": "Version Number", "product.traversedpath": "Traversed Path", "product.new_isreturn": "Back to Factory or Not", "product.new_isreturn0": "NO", "product.new_isreturn1": "YES", "product.createdonbehalfby": "Created By (Delegate)", "product.modifiedbyexternalparty": "Modified By (External Party)", "product.new_fouryards": "Four-letter Code", "product.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "product.entityimageid": "Entity Image Id", "product.new_userprofile_id": "Equipment", "product.vendorname": "Vendor", "product.producttypecode": "Product Type", "product.producttypecode1": "Sales Inventory", "product.producttypecode2": "Miscellaneous Charges", "product.producttypecode3": "Services", "product.producttypecode4": "Flat Fees", "product.vendorpartnumber": "Vendor Name", "product.modifiedon": "Modified On", "product.importsequencenumber": "Import Sequence Number", "product.new_productmodule_id": "Product Model", "product.processid": "Process", "product.description": "Description", "product.parentproductid": "Parent", "product.subjectid": "Subject", "product.stageid": "Process Stage", "product.new_productcategories": "Product Category", "product.new_parstypeid": "Parts Category", "product.defaultuomid": "Default Unit", "product.stockvolume": "Stock Volume", "product.quantitydecimal": "Decimals Supported", "product.transactioncurrencyid": "Currency", "product.isstockitem": "Stock Item", "product.isstockitem0": "No", "product.isstockitem1": "Yes", "product.quantityonhand": "Quantity On Hand", "product.createdby": "Created By", "product.modifiedby": "Modified By", "product.vendorid": "Vendor ID", "product.currentcost_base": "Current Cost (Base)", "product.createdbyexternalparty": "Created By (External Party)", "product.hierarchypath": "Hierarchy Path", "product.suppliername": "Supplier Name", "product.validtodate": "Valid To", "product.name": "Name", "product.stockweight": "Stock Weight", "product.statuscode": "Status Reason", "product.statuscode1": "Active", "product.statuscode2": "Retired", "product.statuscode0": "Draft", "product.statuscode3": "Under Revision", "product.dmtimportstate": "Internal Use Only", "product.organizationid": "Organization", "product.productnumber": "Product ID", "product.new_desc": "Product Desc", "product.standardcost": "Standard Cost", "product.new_seriescategory": "#N/A", "product.new_seriescategory1": "#N/A", "product.new_seriescategory2": "#N/A", "product.new_seriescategory3": "#N/A", "new_srv_repair": "Repair Information", "new_srv_repair.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_repair.new_workhourcost": "Sum of Money", "new_srv_repair.new_standardhour": "Standard Work Hour", "new_srv_repair.owninguser": "Owning User", "new_srv_repair.createdonbehalfby": "Created By (Delegate)", "new_srv_repair.transactioncurrencyid": "Currency", "new_srv_repair.new_project_id": "Maintainance Project", "new_srv_repair.importsequencenumber": "Import Sequence Number", "new_srv_repair.new_srv_workorder_id": "Work Order Number", "new_srv_repair.new_srv_repairid": "Repair Information", "new_srv_repair.statecode": "Status", "new_srv_repair.statecode0": "Active", "new_srv_repair.statecode1": "Inactive", "new_srv_repair.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_repair.new_name": "Name", "new_srv_repair.modifiedby": "Modified By", "new_srv_repair.createdby": "Created By", "new_srv_repair.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_repair.owningteam": "Owning Team", "new_srv_repair.modifiedon": "Modified On", "new_srv_repair.exchangerate": "Exchange Rate", "new_srv_repair.new_workhourprice": "Price", "new_srv_repair.statuscode": "Status Reason", "new_srv_repair.statuscode1": "Active", "new_srv_repair.statuscode2": "Inactive", "new_srv_repair.createdon": "Created On", "new_srv_repair.new_srv_workhours_id": "Maintainance Item", "new_srv_repair.owningbusinessunit": "Owning Business Unit", "new_srv_repair.new_memo": "Memo", "new_srv_repair.versionnumber": null, "new_srv_repair.ownerid": "Owner", "new_srv_repair.overriddencreatedon": "Record Created On", "new_srv_partsreturnline": "Details of Old Parts Back to the Factory", "new_srv_partsreturnline.new_modal": "Model", "new_srv_partsreturnline.new_approvalqty": "Actual Quantity", "new_srv_partsreturnline.versionnumber": null, "new_srv_partsreturnline.new_partsid": "Parts Name", "new_srv_partsreturnline.createdon": "Created On", "new_srv_partsreturnline.new_errorqty": "Unqualified Quantity", "new_srv_partsreturnline.new_errorassemblyid": "System with Malfunction", "new_srv_partsreturnline.new_fault_desc": "Malfunction Reason", "new_srv_partsreturnline.new_appraiser": "Identified By", "new_srv_partsreturnline.new_deliverydate": "Back Date", "new_srv_partsreturnline.overriddencreatedon": "Record Created On", "new_srv_partsreturnline.new_notbyreason": "Unqualified Reason", "new_srv_partsreturnline.new_errormoduleid": "Part with Malfunction", "new_srv_partsreturnline.new_vendorcode": "Supplier Code", "new_srv_partsreturnline.new_appraisalresult": "Identification Result", "new_srv_partsreturnline.new_appraisalresult0": "NO", "new_srv_partsreturnline.new_appraisalresult1": "YES", "new_srv_partsreturnline.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_partsreturnline.new_name": "Name", "new_srv_partsreturnline.new_appqty": "Applied Quantity", "new_srv_partsreturnline.new_repairdate": "Repair Date", "new_srv_partsreturnline.owningteam": "Owning Team", "new_srv_partsreturnline.new_unit": "Unit", "new_srv_partsreturnline.statecode": "Status", "new_srv_partsreturnline.statecode0": "Active", "new_srv_partsreturnline.statecode1": "Inactive", "new_srv_partsreturnline.new_partscode": "Parts Code", "new_srv_partsreturnline.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_partsreturnline.new_oldno": "Factory Number of Old Part", "new_srv_partsreturnline.new_srv_partsreturnlineid": "Details of Old Parts Back to the Factory", "new_srv_partsreturnline.new_oldpartid": "Old Part Code", "new_srv_partsreturnline.new_amount": "Applied Amount", "new_srv_partsreturnline.new_isreturn": "Back to Factory or Not", "new_srv_partsreturnline.new_isreturn0": "NO", "new_srv_partsreturnline.new_isreturn1": "YES", "new_srv_partsreturnline.createdby": "Created By", "new_srv_partsreturnline.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_partsreturnline.new_new_errorgroupid": "Spart Parts with Malfunction", "new_srv_partsreturnline.new_formstatus": "Part State", "new_srv_partsreturnline.new_formstatus1": "Normal", "new_srv_partsreturnline.new_formstatus2": "Unqualified", "new_srv_partsreturnline.ownerid": "Owner", "new_srv_partsreturnline.modifiedon": "Modified On", "new_srv_partsreturnline.importsequencenumber": "Import Sequence Number", "new_srv_partsreturnline.modifiedby": "Modified By", "new_srv_partsreturnline.new_price": "Part Price", "new_srv_partsreturnline.new_workorderid": "Work Order", "new_srv_partsreturnline.statuscode": "Status Reason", "new_srv_partsreturnline.statuscode1": "Active", "new_srv_partsreturnline.statuscode2": "Inactive", "new_srv_partsreturnline.new_receiveqty": "Received Quantity", "new_srv_partsreturnline.new_partline_id": "Parts Replacement Details", "new_srv_partsreturnline.new_partscost": "Amount", "new_srv_partsreturnline.createdonbehalfby": "Created By (Delegate)", "new_srv_partsreturnline.new_newno": "Factory Number of New Part", "new_srv_partsreturnline.new_pastsname": "Name of Purchased Part", "new_srv_partsreturnline.new_srv_error_id": "Phenomenon with Malfunction", "new_srv_partsreturnline.owninguser": "Owning User", "new_srv_partsreturnline.new_partsreturnid": "Document Number", "new_srv_partsreturnline.owningbusinessunit": "Owning Business Unit", "new_srv_partsreturnline.new_isappraisal": "How to Do with the Purchased Parts", "new_srv_partsreturnline.new_isappraisal0": "NO", "new_srv_partsreturnline.new_isappraisal1": "YES", "new_srv_partsreturnline.new_ispurchase": "Purchased or Not", "new_srv_partsreturnline.new_ispurchase0": "NO", "new_srv_partsreturnline.new_ispurchase1": "YES", "new_srv_partsreturnline.new_product_id": "Product Model", "new_srv_partsreturnline.new_meno": "Memo", "new_srv_partsreturnline.new_oldpartlable": "Label Number of Old Part", "new_srv_partsreturnline.new_vendor": "Supplier", "new_srv_partsreturnline.new_invqty": "Stock", "new_srv_partsreturn": "Old Parts Back to the Factory", "new_srv_partsreturn.new_shipconfirmdate": "Date of Delivery", "new_srv_partsreturn.versionnumber": null, "new_srv_partsreturn.createdon": "Created On", "new_srv_partsreturn.new_curr_approvestep_name": "Current Approval Step", "new_srv_partsreturn.createdonbehalfby": "Created By (Delegate)", "new_srv_partsreturn.new_srv_partsreturnid": "Old Parts Back to the Factory", "new_srv_partsreturn.new_printstatus": "Printing State", "new_srv_partsreturn.new_printstatus1": "Not Printed", "new_srv_partsreturn.new_printstatus2": "Printed", "new_srv_partsreturn.overriddencreatedon": "Record Created On", "new_srv_partsreturn.new_isfined": "Expenses Deducted or Not", "new_srv_partsreturn.new_isfined0": "NO", "new_srv_partsreturn.new_isfined1": "YES", "new_srv_partsreturn.new_stocksite_sendid": "Warehouse for Return", "new_srv_partsreturn.new_phone": "Telephone of Shipper", "new_srv_partsreturn.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_partsreturn.new_name": "Document Number", "new_srv_partsreturn.owningteam": "Owning Team", "new_srv_partsreturn.new_submit_time": "Submitted Time", "new_srv_partsreturn.new_totalamount": "Total Amount", "new_srv_partsreturn.statecode": "Status", "new_srv_partsreturn.statecode0": "Active", "new_srv_partsreturn.statecode1": "Inactive", "new_srv_partsreturn.new_oldno": "Factory Number of Old Part", "new_srv_partsreturn.new_maker": "Created By", "new_srv_partsreturn.owninguser": "Owning User", "new_srv_partsreturn.new_approvalstatus": "Approval State", "new_srv_partsreturn.new_approvalstatus1": "To be Submitted", "new_srv_partsreturn.new_approvalstatus2": "Under Review", "new_srv_partsreturn.new_approvalstatus3": "Approved", "new_srv_partsreturn.new_stocksite_receiveid": "Warehouse for Receipt", "new_srv_partsreturn.new_last_approvestep_user": "The Last Approval Person", "new_srv_partsreturn.new_sendon": "Delivery Date", "new_srv_partsreturn.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_partsreturn.new_formstatus": "Document State", "new_srv_partsreturn.new_formstatus1": "To be Submitted", "new_srv_partsreturn.new_formstatus2": "Delivered", "new_srv_partsreturn.new_formstatus3": "Semi Received", "new_srv_partsreturn.new_formstatus4": "Received", "new_srv_partsreturn.new_formstatus5": "Confirmed", "new_srv_partsreturn.ownerid": "Owner", "new_srv_partsreturn.modifiedon": "Modified On", "new_srv_partsreturn.importsequencenumber": "Import Sequence Number", "new_srv_partsreturn.new_approved_time": "Approval Tme", "new_srv_partsreturn.new_carryid": "Document Number of Parts Delivery", "new_srv_partsreturn.new_srv_stationid": "Service Provider", "new_srv_partsreturn.new_curr_approvestep_user": "Current Approver", "new_srv_partsreturn.new_receiveddate": "Received Date", "new_srv_partsreturn.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_partsreturn.new_systemuser_id": "Receiver", "new_srv_partsreturn.createdby": "Created By", "new_srv_partsreturn.modifiedby": "Modified By", "new_srv_partsreturn.new_newno": "Factory Number of New Part", "new_srv_partsreturn.new_srv_workorderid": "Work Order", "new_srv_partsreturn.new_carrycompany": "Delivery Provider", "new_srv_partsreturn.new_last_approve_time": "The Last Approval Time", "new_srv_partsreturn.new_confirmdate": "Confirmed Date of Old Part", "new_srv_partsreturn.new_sendby": "Shipper", "new_srv_partsreturn.new_sitecode": "Service Provider Number", "new_srv_partsreturn.owningbusinessunit": "Owning Business Unit", "new_srv_partsreturn.new_fee": "Transportation Expense", "new_srv_partsreturn.new_applyby": "Applied User", "new_srv_partsreturn.new_buid": "Department", "new_srv_partsreturn.statuscode": "Status Reason", "new_srv_partsreturn.statuscode1": "Active", "new_srv_partsreturn.statuscode2": "Inactive", "new_srv_partsreturn.new_last_approvestep_name": "The Last Approval Step", "new_srv_partsreturn.new_memo": "Memo", "new_stockoutorder": "Stock Delivery", "new_stockoutorder.versionnumber": "Version Number", "new_stockoutorder.createdon": "Created On", "new_stockoutorder.new_invintype": "Type of Stock Delivery", "new_stockoutorder.new_invintype1": "Parts Application", "new_stockoutorder.new_invintype2": "Transfer", "new_stockoutorder.new_invintype3": "Damaged", "new_stockoutorder.new_invintype4": "Faulty", "new_stockoutorder.new_invintype5": "Scrapped", "new_stockoutorder.new_srv_sendstocksite_id": "Delivery Warehouse", "new_stockoutorder.new_unusereason": "Reason for Scrap", "new_stockoutorder.new_unusereason1": "Unqualified", "new_stockoutorder.new_unusereason2": "Damaged", "new_stockoutorder.new_unusereason3": "Replaced", "new_stockoutorder.new_unusereason4": "No Value", "new_stockoutorder.new_srv_recstocksite_id": "Warehouse for Receipt", "new_stockoutorder.new_invoiceamount": "Invoice Amount", "new_stockoutorder.new_outuser": "Deliever", "new_stockoutorder.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_stockoutorder.modifiedonbehalfby": "Modified By (Delegate)", "new_stockoutorder.new_name": "Document Number", "new_stockoutorder.new_recivedate": "Received On", "new_stockoutorder.owningteam": "Owning Team", "new_stockoutorder.new_indate": "Delievered On", "new_stockoutorder.new_boxuser": "Packing Person", "new_stockoutorder.statecode": "Status", "new_stockoutorder.statecode0": "Active", "new_stockoutorder.statecode1": "Inactive", "new_stockoutorder.new_srv_partsapply_id": "Parts Application", "new_stockoutorder.overriddencreatedon": "Record Created On", "new_stockoutorder.new_boxdate": "Packed On", "new_stockoutorder.new_srv_parttransorder_id": "Parts Transfer", "new_stockoutorder.new_invoicedate": "Invoice Date", "new_stockoutorder.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_stockoutorder.new_recuser": "Receiver", "new_stockoutorder.ownerid": "Owner", "new_stockoutorder.modifiedon": "Modified On", "new_stockoutorder.importsequencenumber": "Import Sequence Number", "new_stockoutorder.new_unusedest": "After Scrap", "new_stockoutorder.new_unusedest1": "Materials Handling", "new_stockoutorder.new_unusedest2": "Quality Investigation", "new_stockoutorder.new_unusedest3": "Off-site Disposal", "new_stockoutorder.new_statuscode": "Stock Delivery State", "new_stockoutorder.new_statuscode1": "To be Submitted", "new_stockoutorder.new_statuscode2": "To Warehouse", "new_stockoutorder.new_statuscode3": "Picked", "new_stockoutorder.new_statuscode4": "Packed", "new_stockoutorder.new_statuscode5": "Stock Delivered", "new_stockoutorder.new_statuscode6": "Shipped", "new_stockoutorder.new_rectele": "Telephone of Receiver", "new_stockoutorder.createdby": "Created By", "new_stockoutorder.modifiedby": "Modified By", "new_stockoutorder.new_srv_station_id": "Service Station", "new_stockoutorder.new_pickuser": "Picking Person", "new_stockoutorder.owninguser": "Owning User", "new_stockoutorder.new_stockoutorderid": "Stock Delivery", "new_stockoutorder.owningbusinessunit": "Owning Business Unit", "new_stockoutorder.new_pickdate": "Picked Time", "new_stockoutorder.createdonbehalfby": "Created By (Delegate)", "new_stockoutorder.new_recstatuscode": "Receipt State", "new_stockoutorder.new_recstatuscode1": "To be Received", "new_stockoutorder.new_recstatuscode2": "Received", "new_stockoutorder.new_recstatuscode3": "Semi Received", "new_stockoutorder.new_unuseamount": "Scrap Amount", "new_stockoutorder.new_unusesalvage": "The Rest Value", "new_stockoutorder.new_invoiceno": "Invoice Number", "new_stockoutorder.new_srv_shipconfirm_id": "Document Number of Delievery", "new_stockoutorder.statuscode": "Status Reason", "new_stockoutorder.statuscode1": "Active", "new_stockoutorder.statuscode2": "Inactive", "new_order": "Parts Sales", "new_order.modifiedonbehalfby": "Modified By (Delegate)", "new_order.owningteam": "Owning Team", "new_order.statecode": "Status", "new_order.statecode0": "Active", "new_order.statecode1": "Inactive", "new_order.owninguser": "Owning User", "new_order.createdonbehalfby": "Created By (Delegate)", "new_order.importsequencenumber": "Import Sequence Number", "new_order.new_saletimes": "Sold On", "new_order.new_srv_station_id": "Service Station", "new_order.new_orderstatus": "Order State", "new_order.new_orderstatus1": "To be Submitted", "new_order.new_orderstatus2": "Sold", "new_order.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_order.owningbusinessunit": "Owning Business Unit", "new_order.new_name": "Order Number", "new_order.modifiedby": "Modified By", "new_order.createdby": "Created By", "new_order.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_order.new_submit_time": "Submitted On", "new_order.new_stocksite_id": "Delivered Warehouse", "new_order.modifiedon": "Modified On", "new_order.new_order_contact": "Service Provider", "new_order.statuscode": "Status Reason", "new_order.statuscode1": "Active", "new_order.statuscode2": "Inactive", "new_order.createdon": "Created On", "new_order.new_sitecode": "Service Station Code", "new_order.new_orderid": "Document Number of Parts Sales", "new_order.new_memo": "Memo", "new_order.versionnumber": null, "new_order.ownerid": "Owner", "new_order.overriddencreatedon": "Record Created On", "new_srv_sitereturn": "Parts Return Application", "new_srv_sitereturn.versionnumber": null, "new_srv_sitereturn.createdon": "Created On", "new_srv_sitereturn.new_returnorderstatus": "Document State", "new_srv_sitereturn.new_returnorderstatus1": "To be Submitted", "new_srv_sitereturn.new_returnorderstatus2": "Delivered", "new_srv_sitereturn.new_returnorderstatus3": "Semi Received", "new_srv_sitereturn.new_returnorderstatus4": "Received", "new_srv_sitereturn.new_senderphone": "Telephone of Shipper", "new_srv_sitereturn.new_curr_flowstepsid": "Current Approval Step", "new_srv_sitereturn.new_curr_approvestep_name": "Current Approval Step", "new_srv_sitereturn.new_senddepartment": "Delivery Provider", "new_srv_sitereturn.createdonbehalfby": "Created By (Delegate)", "new_srv_sitereturn.new_returntype": "Return Type", "new_srv_sitereturn.new_returntype1": "Transfer", "new_srv_sitereturn.new_returntype2": "Stocking", "new_srv_sitereturn.new_returntype3": "Purchasing", "new_srv_sitereturn.new_curr_flowsteps_seq": "Current Approval Step Number", "new_srv_sitereturn.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_sitereturn.new_srv_sitereturnid": "Parts Return Application", "new_srv_sitereturn.new_last_flowstepsid": "The Last Approval Step", "new_srv_sitereturn.new_stocksite_sendid": "Warehouse for Return", "new_srv_sitereturn.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_sitereturn.new_name": "Document Number", "new_srv_sitereturn.new_address": "Reveival Address", "new_srv_sitereturn.owningteam": "Owning Team", "new_srv_sitereturn.overriddencreatedon": "Record Created On", "new_srv_sitereturn.new_sender": "Shipper", "new_srv_sitereturn.statecode": "Status", "new_srv_sitereturn.statecode0": "Active", "new_srv_sitereturn.statecode1": "Inactive", "new_srv_sitereturn.new_sendnumber": "Delivery Number", "new_srv_sitereturn.new_last_flowsteps_seq": "The Last Approval Step Number", "new_srv_sitereturn.new_maker": "Created By", "new_srv_sitereturn.owninguser": "Owning User", "new_srv_sitereturn.new_approvalstatus": "Approval State", "new_srv_sitereturn.new_approvalstatus1": "To be Submitted", "new_srv_sitereturn.new_approvalstatus2": "Under Review", "new_srv_sitereturn.new_approvalstatus3": "Approved", "new_srv_sitereturn.new_approvalstatus4": "Rejected", "new_srv_sitereturn.new_approvalstatus5": "Veto", "new_srv_sitereturn.new_stocksite_receiveid": "Warehouse for Receipt", "new_srv_sitereturn.new_last_approvestep_user": "The Last Approval Person", "new_srv_sitereturn.createdby": "Created By", "new_srv_sitereturn.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_sitereturn.new_srv_station_id": "Service Station", "new_srv_sitereturn.new_returnreason": "Return Reason", "new_srv_sitereturn.ownerid": "Owner", "new_srv_sitereturn.modifiedon": "Modified On", "new_srv_sitereturn.importsequencenumber": "Import Sequence Number", "new_srv_sitereturn.new_addressee": "Receiver", "new_srv_sitereturn.new_returntime": "Return Time", "new_srv_sitereturn.new_curr_approvestep_user": "Current Approver", "new_srv_sitereturn.new_submit_time": "Submitted On", "new_srv_sitereturn.new_systemuser_id": "Receiver", "new_srv_sitereturn.new_approved_time": "Approval Tme", "new_srv_sitereturn.modifiedby": "Modified By", "new_srv_sitereturn.new_applyby": "Applied User", "new_srv_sitereturn.new_receiveddate": "Received Date", "new_srv_sitereturn.new_isclose": "Close or Not", "new_srv_sitereturn.new_isclose0": "Still Open", "new_srv_sitereturn.new_isclose1": "Closed", "new_srv_sitereturn.new_last_approve_time": "The Last Approval Time", "new_srv_sitereturn.new_addresseephone": "Tplephone of Receiver", "new_srv_sitereturn.owningbusinessunit": "Owning Business Unit", "new_srv_sitereturn.new_fee": "Transportation Expense", "new_srv_sitereturn.statuscode": "Status Reason", "new_srv_sitereturn.statuscode1": "Active", "new_srv_sitereturn.statuscode2": "Inactive", "new_srv_sitereturn.new_last_approvestep_name": "The Last Approval Step", "new_srv_sitereturn.new_sendtime": "Delivered On", "new_srv_sitereturn.new_businessunit_id": "Department", "new_srv_parttransorder": "Parts Transfer", "new_srv_parttransorder.versionnumber": "Version Number", "new_srv_parttransorder.createdon": "Created On", "new_srv_parttransorder.owninguser": "Owning User", "new_srv_parttransorder.new_transtype": "Transfer Type", "new_srv_parttransorder.new_transtype1": "Out", "new_srv_parttransorder.new_transtype2": "In", "new_srv_parttransorder.new_curr_approvestep_name": "Current Approval Step", "new_srv_parttransorder.createdonbehalfby": "Created By (Delegate)", "new_srv_parttransorder.new_receiveduser_id": "Receiver", "new_srv_parttransorder.new_receivecode": "Code of Receival Warehouse", "new_srv_parttransorder.new_transorderstatus": "Document State", "new_srv_parttransorder.new_transorderstatus1": "To be Delivered", "new_srv_parttransorder.new_transorderstatus2": "Semi Delivered", "new_srv_parttransorder.new_transorderstatus3": "Delivered", "new_srv_parttransorder.new_transorderstatus4": "Semi Received", "new_srv_parttransorder.new_transorderstatus5": "Received", "new_srv_parttransorder.overriddencreatedon": "Record Created On", "new_srv_parttransorder.new_stocksite_sendid": "Name of Delivery Warehouse", "new_srv_parttransorder.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_parttransorder.new_name": "Document Number of Parts Transfer", "new_srv_parttransorder.createdby": "Created By", "new_srv_parttransorder.new_transdate": "Parts Transfer Date", "new_srv_parttransorder.owningteam": "Owning Team", "new_srv_parttransorder.new_submit_time": "Sended Time", "new_srv_parttransorder.statecode": "Status", "new_srv_parttransorder.statecode0": "Active", "new_srv_parttransorder.statecode1": "Inactive", "new_srv_parttransorder.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_parttransorder.new_approvalstatus": "Approval State", "new_srv_parttransorder.new_approvalstatus1": "Making", "new_srv_parttransorder.new_approvalstatus2": "Approving", "new_srv_parttransorder.new_approvalstatus3": "Approved", "new_srv_parttransorder.new_approvalstatus4": "Rejected", "new_srv_parttransorder.new_approvalstatus5": "Vetoed", "new_srv_parttransorder.new_stocksite_receiveid": "Name of Receival Warehouse", "new_srv_parttransorder.new_last_approvestep_user": "The Last Approval Person", "new_srv_parttransorder.new_approvedby": "Approver", "new_srv_parttransorder.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_parttransorder.ownerid": "Owner", "new_srv_parttransorder.modifiedon": "Modified On", "new_srv_parttransorder.importsequencenumber": "Import Sequence Number", "new_srv_parttransorder.modifiedby": "Modified By", "new_srv_parttransorder.new_sentcode": "Code of Delivery Warehouse", "new_srv_parttransorder.new_curr_approvestep_user": "Current Approver", "new_srv_parttransorder.new_new_approvalstatus": "Approval State", "new_srv_parttransorder.new_new_approvalstatus1": "Making", "new_srv_parttransorder.new_new_approvalstatus2": "Approving", "new_srv_parttransorder.new_new_approvalstatus3": "Approved", "new_srv_parttransorder.new_new_approvalstatus4": "Rejected", "new_srv_parttransorder.new_new_approvalstatus5": "Vetoed", "new_srv_parttransorder.new_approved_time": "Approval Tme", "new_srv_parttransorder.new_srv_parttransorderid": "Parts Transfer", "new_srv_parttransorder.new_receiveddate": "Received Date", "new_srv_parttransorder.new_isclose": "Close or Not", "new_srv_parttransorder.new_isclose0": "NO", "new_srv_parttransorder.new_isclose1": "YES", "new_srv_parttransorder.new_last_approve_time": "The Last Approval Time", "new_srv_parttransorder.new_submitby": "Sent By", "new_srv_parttransorder.owningbusinessunit": "Owning Business Unit", "new_srv_parttransorder.statuscode": "Status Reason", "new_srv_parttransorder.statuscode100000000": "Undelivered", "new_srv_parttransorder.statuscode100000001": "On the Way", "new_srv_parttransorder.statuscode100000002": "Delivered", "new_srv_parttransorder.statuscode2": "Inactive", "new_srv_parttransorder.new_last_approvestep_name": "The Last Approval Step", "new_srv_parttransorder.new_memo": "Memo", "new_srv_parttransorder.new_businessunit_id": "Region", "annotation": "Note", "annotation.owninguser": "Owning User", "annotation.modifiedon": "Modified On", "annotation.isprivate": null, "annotation.isprivate0": "No", "annotation.isprivate1": "Yes", "annotation.createdonbehalfby": "Created By (Delegate)", "annotation.filename": "File Name", "annotation.filesize": "File Size (Bytes)", "annotation.importsequencenumber": "Import Sequence Number", "annotation.subject": "Title", "annotation.modifiedonbehalfby": "Modified By (Delegate)", "annotation.objectid": "Regarding", "annotation.owningbusinessunit": "Owning Business Unit", "annotation.owningteam": "Owning Team", "annotation.modifiedby": "Modified By", "annotation.mimetype": "Mime Type", "annotation.createdby": "Created By", "annotation.stepid": "Step Id", "annotation.documentbody": "Document", "annotation.notetext": "Description", "annotation.objecttypecode": "Object Type ", "annotation.langid": "Language ID", "annotation.createdon": "Created On", "annotation.isdocument": "Is Document", "annotation.isdocument0": "No", "annotation.isdocument1": "Yes", "annotation.versionnumber": "Version Number", "annotation.ownerid": "Owner", "annotation.overriddencreatedon": "Record Created On", "annotation.annotationid": "Note", "new_stockoutorderdetail": "Stock Delivery Details", "new_stockoutorderdetail.owninguser": "Owning User", "new_stockoutorderdetail.owningteam": "Owning Team", "new_stockoutorderdetail.statecode": "Status", "new_stockoutorderdetail.statecode0": "Active", "new_stockoutorderdetail.statecode1": "Inactive", "new_stockoutorderdetail.new_parttransorderline_id": "Parts Transfer Details", "new_stockoutorderdetail.new_planprice": "Planned Price", "new_stockoutorderdetail.statuscode": "Status Reason", "new_stockoutorderdetail.statuscode1": "Active", "new_stockoutorderdetail.statuscode2": "Inactive", "new_stockoutorderdetail.new_orderlineentityid": "Correlated Document ID", "new_stockoutorderdetail.new_uom_id": "Measurement Unit", "new_stockoutorderdetail.new_applyprice": "Applied Price", "new_stockoutorderdetail.new_stockoutorderdetailid": "Stock Delivery Details", "new_stockoutorderdetail.importsequencenumber": "Import Sequence Number", "new_stockoutorderdetail.new_recqty": "Received Quantity", "new_stockoutorderdetail.new_defaultuomid": "Measurement Unit Group", "new_stockoutorderdetail.new_tempcurrentinv": "Current Stock", "new_stockoutorderdetail.createdonbehalfby": "Created By (Delegate)", "new_stockoutorderdetail.new_product_id": "Part Name", "new_stockoutorderdetail.new_orderlineentitytype": "Type of Correlated Document", "new_stockoutorderdetail.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_stockoutorderdetail.owningbusinessunit": "Owning Business Unit", "new_stockoutorderdetail.new_name": "Name", "new_stockoutorderdetail.modifiedby": "Modified By", "new_stockoutorderdetail.new_srv_partsapplydetil_id": "Parts Application Details", "new_stockoutorderdetail.createdby": "Created By", "new_stockoutorderdetail.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_stockoutorderdetail.new_partscode": "Part Code", "new_stockoutorderdetail.new_sendqty": "Delivered Quantity", "new_stockoutorderdetail.new_stockoutorder_id": "Document Number of Stock Delivery", "new_stockoutorderdetail.modifiedon": "Modified On", "new_stockoutorderdetail.ownerid": "Owner", "new_stockoutorderdetail.createdon": "Created On", "new_stockoutorderdetail.new_shipqty": "Quantity to be Shipped", "new_stockoutorderdetail.new_applyqty": "Applied Quantity", "new_stockoutorderdetail.versionnumber": "Version Number", "new_stockoutorderdetail.modifiedonbehalfby": "Modified By (Delegate)", "new_stockoutorderdetail.overriddencreatedon": "Record Created On", "new_srv_partsapply": "Parts Application", "new_srv_partsapply.versionnumber": null, "new_srv_partsapply.createdon": "Created On", "new_srv_partsapply.new_requiredate": "Required Date", "new_srv_partsapply.new_type": "Application Type", "new_srv_partsapply.new_type1": "Normal Order", "new_srv_partsapply.new_type2": "Urgent Order", "new_srv_partsapply.new_type3": "Repair Application", "new_srv_partsapply.new_curr_flowstepsid": "Current Approval Step", "new_srv_partsapply.new_curr_approvestep_name": "Current Approval Step", "new_srv_partsapply.createdonbehalfby": "Created By (Delegate)", "new_srv_partsapply.new_workorder_id": "Work Order", "new_srv_partsapply.overriddencreatedon": "Record Created On", "new_srv_partsapply.new_last_flowstepsid": "The Last Approval Step", "new_srv_partsapply.new_stocksite_sendid": "Delivery Warehouse", "new_srv_partsapply.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_partsapply.new_name": "Parts Application Number", "new_srv_partsapply.new_address": "Receiving Warehouse", "new_srv_partsapply.owningteam": "Owning Team", "new_srv_partsapply.new_submit_time": "Submitted Time", "new_srv_partsapply.statecode": "Status", "new_srv_partsapply.statecode0": "Active", "new_srv_partsapply.statecode1": "Inactive", "new_srv_partsapply.new_stocksite_id": "Application Warehouse", "new_srv_partsapply.new_last_flowsteps_seq": "The Last Approval Step Number", "new_srv_partsapply.new_approvalstatus": "Approval State", "new_srv_partsapply.new_approvalstatus1": "To be Submitted", "new_srv_partsapply.new_approvalstatus2": "Under Review", "new_srv_partsapply.new_approvalstatus3": "Approved", "new_srv_partsapply.new_approvalstatus4": "Rejected", "new_srv_partsapply.new_approvalstatus5": "Veto", "new_srv_partsapply.new_last_approvestep_user": "The Last Approval Person", "new_srv_partsapply.traversedpath": "Traversed Path", "new_srv_partsapply.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_partsapply.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_partsapply.new_recipient": "Receiver", "new_srv_partsapply.ownerid": "Owner", "new_srv_partsapply.modifiedon": "Modified On", "new_srv_partsapply.new_srv_partsapplyid": "Parts Application", "new_srv_partsapply.new_approved_time": "Approval Tme", "new_srv_partsapply.processid": "Process ID", "new_srv_partsapply.new_curr_approvestep_user": "Current Approver", "new_srv_partsapply.stageid": "Stage ID", "new_srv_partsapply.new_curr_flowsteps_seq": "Current Approval Step Number", "new_srv_partsapply.new_station_id": "Service Station", "new_srv_partsapply.createdby": "Created By", "new_srv_partsapply.modifiedby": "Modified By", "new_srv_partsapply.new_isclose": "Close or Not", "new_srv_partsapply.new_isclose0": "Still Open", "new_srv_partsapply.new_isclose1": "Closed", "new_srv_partsapply.new_last_approve_time": "The Last Approval Time", "new_srv_partsapply.owninguser": "Owning User", "new_srv_partsapply.owningbusinessunit": "Owning Business Unit", "new_srv_partsapply.new_tatalamount": "Total Amount", "new_srv_partsapply.new_phonenumber": "Tplephone of Receiver", "new_srv_partsapply.statuscode": "Status Reason", "new_srv_partsapply.statuscode1": "To be Delivered", "new_srv_partsapply.statuscode100000000": "Semi Delivered", "new_srv_partsapply.statuscode100000001": "Delivered", "new_srv_partsapply.statuscode100000002": "Closed", "new_srv_partsapply.statuscode2": "Inactive", "new_srv_partsapply.new_last_approvestep_name": "The Last Approval Step", "new_srv_partsapply.new_incident_id": "Case", "new_srv_partsapply.importsequencenumber": "Import Sequence Number", "new_srv_partsapplydetil": "Parts Application Details", "new_srv_partsapplydetil.new_code": "Parts Code", "new_srv_partsapplydetil.owninguser": "Owning User", "new_srv_partsapplydetil.owningteam": "Owning Team", "new_srv_partsapplydetil.statecode": "Status", "new_srv_partsapplydetil.statecode0": "Active", "new_srv_partsapplydetil.statecode1": "Inactive", "new_srv_partsapplydetil.statuscode": "Status Reason", "new_srv_partsapplydetil.statuscode1": "To be Delivered", "new_srv_partsapplydetil.statuscode100000000": "Semi Delivered", "new_srv_partsapplydetil.statuscode100000001": "Delivered", "new_srv_partsapplydetil.statuscode2": "Inactive", "new_srv_partsapplydetil.new_uom_id": "Measurement Unit", "new_srv_partsapplydetil.createdonbehalfby": "Created By (Delegate)", "new_srv_partsapplydetil.new_price": "Price", "new_srv_partsapplydetil.new_qty": "Applied Quantity", "new_srv_partsapplydetil.new_currency_id": "Currency", "new_srv_partsapplydetil.importsequencenumber": "Import Sequence Number", "new_srv_partsapplydetil.new_partscost": "Amount", "new_srv_partsapplydetil.new_srv_workorder_id": "Work Order", "new_srv_partsapplydetil.new_tempcurrentinv": "Current Stock", "new_srv_partsapplydetil.new_desc": "Description", "new_srv_partsapplydetil.new_product_id": "Parts Name", "new_srv_partsapplydetil.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_partsapplydetil.new_srv_partsapply_id": "Parts Application", "new_srv_partsapplydetil.new_name": "Name", "new_srv_partsapplydetil.modifiedby": "Modified By", "new_srv_partsapplydetil.new_actualqty": "Approved Quantity", "new_srv_partsapplydetil.createdby": "Created By", "new_srv_partsapplydetil.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_partsapplydetil.ownerid": "Owner", "new_srv_partsapplydetil.new_stocksite_sendid": "Delivery Warehouse", "new_srv_partsapplydetil.modifiedon": "Modified On", "new_srv_partsapplydetil.createdon": "Created On", "new_srv_partsapplydetil.owningbusinessunit": "Owning Business Unit", "new_srv_partsapplydetil.new_srv_partsapplydetilid": "Parts Application Details", "new_srv_partsapplydetil.versionnumber": null, "new_srv_partsapplydetil.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_partsapplydetil.new_shippedqty": "Delivered Quantity", "new_srv_partsapplydetil.new_pendingqty": "To be Delivered Quantity", "new_srv_partsapplydetil.overriddencreatedon": "Record Created On", "new_orderline": "Details of Parts Sales", "new_orderline.owninguser": "Owning User", "new_orderline.owningteam": "Owning Team", "new_orderline.new_productmodel": "Parts Model", "new_orderline.new_sourcefrom": "Origin of Parts", "new_orderline.new_sourcefrom1": "For Storage", "new_orderline.new_sourcefrom2": "Purchased", "new_orderline.new_sourcefrom3": "Transfer", "new_orderline.new_uom_id": "Measurement Unit", "new_orderline.createdonbehalfby": "Created By (Delegate)", "new_orderline.new_qty": "Quantity of Sold Parts", "new_orderline.new_orderlineid": "Details of Parts Sales", "new_orderline.new_srv_expense_claimid": "Expense Settlement", "new_orderline.importsequencenumber": "Import Sequence Number", "new_orderline.new_productid": "Parts Name", "new_orderline.statecode": "Status", "new_orderline.statecode0": "Active", "new_orderline.statecode1": "Inactive", "new_orderline.new_productcode": "Parts Code", "new_orderline.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_orderline.statuscode": "Status Reason", "new_orderline.statuscode1": "Active", "new_orderline.statuscode2": "Inactive", "new_orderline.new_actualprice": "Actual Price", "new_orderline.new_name": "Name", "new_orderline.modifiedby": "Modified By", "new_orderline.createdby": "Created By", "new_orderline.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_orderline.new_seq": "Number", "new_orderline.modifiedon": "Modified On", "new_orderline.new_isclaim": "Expenses Settled or Not", "new_orderline.new_isclaim0": "NO", "new_orderline.new_isclaim1": "YES", "new_orderline.createdon": "Created On", "new_orderline.owningbusinessunit": "Owning Business Unit", "new_orderline.new_orderid": "Order", "new_orderline.new_amount": "Amount", "new_orderline.versionnumber": null, "new_orderline.modifiedonbehalfby": "Modified By (Delegate)", "new_orderline.ownerid": "Owner", "new_orderline.overriddencreatedon": "Record Created On", "new_orderline.new_vendorcode": "Supplier Code", "new_srv_amountadjustment": "Quota Adjustment", "new_srv_amountadjustment.owninguser": "Owning User", "new_srv_amountadjustment.owningteam": "Owning Team", "new_srv_amountadjustment.modifiedon": "Modified On", "new_srv_amountadjustment.new_adjustmenttype": "Type of Origin", "new_srv_amountadjustment.new_adjustmenttype2": "Parts Delievery", "new_srv_amountadjustment.new_adjustmenttype3": "Old Parts Back to Factory", "new_srv_amountadjustment.new_adjustmenttype4": "Parts Return", "new_srv_amountadjustment.new_adjustmenttype100": "Original Setting", "new_srv_amountadjustment.statuscode": "Status Reason", "new_srv_amountadjustment.statuscode1": "Active", "new_srv_amountadjustment.statuscode2": "Inactive", "new_srv_amountadjustment.new_curr_approvestep_name": "Current Approval Step", "new_srv_amountadjustment.overriddencreatedon": "Record Created On", "new_srv_amountadjustment.new_approvalstatus": "Approval State", "new_srv_amountadjustment.new_approvalstatus1": "To be Submitted", "new_srv_amountadjustment.new_approvalstatus2": "Under Review", "new_srv_amountadjustment.new_approvalstatus3": "Approved", "new_srv_amountadjustment.new_approvalstatus4": "Rejected", "new_srv_amountadjustment.new_approvalstatus5": "Veto", "new_srv_amountadjustment.createdonbehalfby": "Created By (Delegate)", "new_srv_amountadjustment.new_amounttype": "Quota Adjusted", "new_srv_amountadjustment.new_amounttype1": "Increase", "new_srv_amountadjustment.new_amounttype2": "Decrease", "new_srv_amountadjustment.importsequencenumber": "Import Sequence Number", "new_srv_amountadjustment.new_srv_amountadjustmentid": "Quota Adjustment", "new_srv_amountadjustment.new_status": "Valid or Not", "new_srv_amountadjustment.new_status0": "Invalid", "new_srv_amountadjustment.new_status1": "Valid", "new_srv_amountadjustment.new_stationid": "Service Station", "new_srv_amountadjustment.owningbusinessunit": "Owning Business Unit", "new_srv_amountadjustment.new_name": "Documentt Number", "new_srv_amountadjustment.modifiedby": "Modified By", "new_srv_amountadjustment.new_curr_approvestep_user": "Current Approver", "new_srv_amountadjustment.new_curr_flowsteps_seq": "Current Approval Step Number", "new_srv_amountadjustment.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_amountadjustment.new_submit_time": "Submitted Time", "new_srv_amountadjustment.new_memo": "Memo", "new_srv_amountadjustment.new_stationcode": "Service Station Number", "new_srv_amountadjustment.statecode": "Status", "new_srv_amountadjustment.statecode0": "Active", "new_srv_amountadjustment.statecode1": "Inactive", "new_srv_amountadjustment.new_curr_flowstepsid": "Current Approval Step", "new_srv_amountadjustment.createdon": "Created On", "new_srv_amountadjustment.new_last_approve_time": "The Last Approval Time", "new_srv_amountadjustment.createdby": "Created By", "new_srv_amountadjustment.new_last_approvestep_name": "The Last Approval Step", "new_srv_amountadjustment.new_amount": "Amount Adjusted", "new_srv_amountadjustment.new_last_flowsteps_seq": "The Last Approval Step Number", "new_srv_amountadjustment.versionnumber": null, "new_srv_amountadjustment.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_amountadjustment.new_last_approvestep_user": "The Last Approval Person", "new_srv_amountadjustment.new_last_flowstepsid": "The Last Approval Step", "new_srv_amountadjustment.ownerid": "Owner", "new_srv_amountadjustment.new_approved_time": "Approval Tme", "new_srv_amountadjustment.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_amountchangelog": "Quota Adjustment Record", "new_srv_amountchangelog.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_amountchangelog.new_adjustmenttype": "Type of Origin", "new_srv_amountchangelog.new_adjustmenttype1": "Quota Adjustment", "new_srv_amountchangelog.new_adjustmenttype2": "Parts Delivery", "new_srv_amountchangelog.new_adjustmenttype3": "Old Parts Back to the Factory", "new_srv_amountchangelog.new_adjustmenttype4": "Parts Return", "new_srv_amountchangelog.new_adjustmenttype100": "Original Setting", "new_srv_amountchangelog.new_srv_amountadjustment_id": "Quota Adjustment", "new_srv_amountchangelog.createdonbehalfby": "Created By (Delegate)", "new_srv_amountchangelog.new_formentityid": "Entity ID", "new_srv_amountchangelog.new_formentitytype": "Entity Type", "new_srv_amountchangelog.importsequencenumber": "Import Sequence Number", "new_srv_amountchangelog.statecode": "Status", "new_srv_amountchangelog.statecode0": "Active", "new_srv_amountchangelog.statecode1": "Inactive", "new_srv_amountchangelog.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_amountchangelog.new_name": "Number of Original Document", "new_srv_amountchangelog.modifiedby": "Modified By", "new_srv_amountchangelog.createdby": "Created By", "new_srv_amountchangelog.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_amountchangelog.new_srv_station_id": "Service Station", "new_srv_amountchangelog.modifiedon": "Modified On", "new_srv_amountchangelog.statuscode": "Status Reason", "new_srv_amountchangelog.statuscode1": "Active", "new_srv_amountchangelog.statuscode2": "Inactive", "new_srv_amountchangelog.createdon": "Created On", "new_srv_amountchangelog.organizationid": "Organization ID", "new_srv_amountchangelog.new_adjustamount": "Adjusted Amount", "new_srv_amountchangelog.new_memo": "Memo", "new_srv_amountchangelog.versionnumber": "Version Number", "new_srv_amountchangelog.new_srv_amountchangelogid": "Quota Adjustment Record", "new_srv_amountchangelog.overriddencreatedon": "Record Created On", "new_part_stocktransaction": "Stock Record", "new_part_stocktransaction.new_product_id": "Material Name", "new_part_stocktransaction.owninguser": "Owning User", "new_part_stocktransaction.owningteam": "Owning Team", "new_part_stocktransaction.new_transactiontype": "Usage", "new_part_stocktransaction.new_transactiontype1": "Parts Delivery Document for Transfer", "new_part_stocktransaction.new_transactiontype2": "Parts Delivery Document for Stocking", "new_part_stocktransaction.new_transactiontype3": "Parts Delivery Document for Purchasing", "new_part_stocktransaction.new_transactiontype4": "Parts Delivery Document for Replenishment", "new_part_stocktransaction.new_transactiontype5": "Parts Transfer", "new_part_stocktransaction.new_transactiontype6": "Parts Stocking", "new_part_stocktransaction.new_transactiontype7": "Parts Purchasing", "new_part_stocktransaction.new_transactiontype8": "Parts Sales", "new_part_stocktransaction.new_transactiontype9": "For Repair", "new_part_stocktransaction.new_transactiontype10": "Parts Storage Adjustment", "new_part_stocktransaction.new_transactiontype11": "With No Delivery Document", "new_part_stocktransaction.statecode": "Status", "new_part_stocktransaction.statecode0": "Active", "new_part_stocktransaction.statecode1": "Inactive", "new_part_stocktransaction.new_fromno": "Correlated Document", "new_part_stocktransaction.new_uom_id": "Measurement Unit", "new_part_stocktransaction.createdonbehalfby": "Created By (Delegate)", "new_part_stocktransaction.new_detialid": "Detailed ID", "new_part_stocktransaction.new_qty": "Quantity", "new_part_stocktransaction.new_formentitytype": "Entity Name", "new_part_stocktransaction.importsequencenumber": "Import Sequence Number", "new_part_stocktransaction.new_formid": "ID", "new_part_stocktransaction.new_transdirection": "#N/A", "new_part_stocktransaction.new_transdirection0": "Stock Entry", "new_part_stocktransaction.new_transdirection1": "Stock Delivery", "new_part_stocktransaction.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_part_stocktransaction.new_invtransdirection": "Stock Entry or Delivery", "new_part_stocktransaction.new_invtransdirection1": "Warehouse Entry", "new_part_stocktransaction.new_invtransdirection2": "Warehouse Delivery", "new_part_stocktransaction.owningbusinessunit": "Owning Business Unit", "new_part_stocktransaction.new_name": "Name", "new_part_stocktransaction.modifiedby": "Modified By", "new_part_stocktransaction.new_partprice": "Parts Price", "new_part_stocktransaction.createdby": "Created By", "new_part_stocktransaction.new_stocksite_id": "Stock Name", "new_part_stocktransaction.modifiedon": "Modified On", "new_part_stocktransaction.new_srv_stationid": "Stock Address", "new_part_stocktransaction.statuscode": "Status Reason", "new_part_stocktransaction.statuscode1": "Active", "new_part_stocktransaction.statuscode2": "Inactive", "new_part_stocktransaction.createdon": "Created On", "new_part_stocktransaction.new_part_stocktransactionid": "Stock Record", "new_part_stocktransaction.new_formtype": "Origin of Parts", "new_part_stocktransaction.new_formtype1": "Transfer", "new_part_stocktransaction.new_formtype2": "For Storage", "new_part_stocktransaction.new_formtype3": "Purchased", "new_part_stocktransaction.new_partcode": "Materail Code", "new_part_stocktransaction.versionnumber": null, "new_part_stocktransaction.modifiedonbehalfby": "Modified By (Delegate)", "new_part_stocktransaction.ownerid": "Owner", "new_part_stocktransaction.overriddencreatedon": "Record Created On", "new_part_stocktransaction.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_siteinv": "Parts Stock", "new_srv_siteinv.owninguser": "Owning User", "new_srv_siteinv.owningteam": "Owning Team", "new_srv_siteinv.statecode": "Status", "new_srv_siteinv.statecode0": "Active", "new_srv_siteinv.statecode1": "Inactive", "new_srv_siteinv.new_productclass": "Product State", "new_srv_siteinv.new_productclass1": "Qualified", "new_srv_siteinv.new_productclass2": "Unqualified", "new_srv_siteinv.new_uom_id": "Measurement Unit", "new_srv_siteinv.createdonbehalfby": "Created By (Delegate)", "new_srv_siteinv.new_qty": "Quantity", "new_srv_siteinv.importsequencenumber": "Import Sequence Number", "new_srv_siteinv.versionnumber": "Version Number", "new_srv_siteinv.new_srv_siteinvid": "Parts Stock", "new_srv_siteinv.new_productcode": "Parts Code", "new_srv_siteinv.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_siteinv.owningbusinessunit": "Owning Business Unit", "new_srv_siteinv.new_product_id": "Parts Name", "new_srv_siteinv.new_name": "Name", "new_srv_siteinv.modifiedby": "Modified By", "new_srv_siteinv.createdby": "Created By", "new_srv_siteinv.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_siteinv.new_stocksite_id": "Warehouse Name", "new_srv_siteinv.modifiedon": "Modified On", "new_srv_siteinv.statuscode": "Status Reason", "new_srv_siteinv.statuscode1": "Active", "new_srv_siteinv.statuscode2": "Inactive", "new_srv_siteinv.createdon": "Created On", "new_srv_siteinv.new_stockcode": "Warehouse Code", "new_srv_siteinv.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_siteinv.ownerid": "Owner", "new_srv_siteinv.overriddencreatedon": "Record Created On", "new_srv_sitereturnline": "Parts Return Details", "new_srv_sitereturnline.new_uomid": "Measurement Unit", "new_srv_sitereturnline.new_receiveqty": "Received Quantity", "new_srv_sitereturnline.owningteam": "Owning Team", "new_srv_sitereturnline.statecode": "Status", "new_srv_sitereturnline.statecode0": "Active", "new_srv_sitereturnline.statecode1": "Inactive", "new_srv_sitereturnline.createdon": "Created On", "new_srv_sitereturnline.statuscode": "Status Reason", "new_srv_sitereturnline.statuscode1": "Active", "new_srv_sitereturnline.statuscode2": "Inactive", "new_srv_sitereturnline.new_partcode": "Parts Code", "new_srv_sitereturnline.createdonbehalfby": "Created By (Delegate)", "new_srv_sitereturnline.new_price": "Parts Price", "new_srv_sitereturnline.new_productmodel": "Parts Model", "new_srv_sitereturnline.new_reason": "Veto Reason", "new_srv_sitereturnline.new_sitereturnid": "Parts Return Application", "new_srv_sitereturnline.importsequencenumber": "Import Sequence Number", "new_srv_sitereturnline.owninguser": "Owning User", "new_srv_sitereturnline.new_identresults": "Identification Result", "new_srv_sitereturnline.new_identresults1": "Pass", "new_srv_sitereturnline.new_identresults2": "Fail", "new_srv_sitereturnline.new_appraisaler": "Identified By", "new_srv_sitereturnline.new_product_id": "Parts Name", "new_srv_sitereturnline.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_sitereturnline.new_sitestockqty": "Service Station Stock", "new_srv_sitereturnline.new_returnqty": "Returned Quantity", "new_srv_sitereturnline.new_name": "Name", "new_srv_sitereturnline.modifiedby": "Modified By", "new_srv_sitereturnline.createdby": "Created By", "new_srv_sitereturnline.new_shipproperty": "Parts Attribute", "new_srv_sitereturnline.new_shipproperty1": "For Stocking", "new_srv_sitereturnline.new_shipproperty2": "Purchased", "new_srv_sitereturnline.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_sitereturnline.new_receivedqty2": "Quantity of Parts to be Picked up", "new_srv_sitereturnline.owningbusinessunit": "Owning Business Unit", "new_srv_sitereturnline.modifiedon": "Modified On", "new_srv_sitereturnline.new_receivedqty": "Quantity of Parts Received", "new_srv_sitereturnline.new_srv_sitereturnlineid": "Parts Return Details", "new_srv_sitereturnline.new_new_receivedqty2": "Quantity of Parts to be Picked up", "new_srv_sitereturnline.new_receiveowner": "Receiver", "new_srv_sitereturnline.new_transqty": "Delivered Quantity", "new_srv_sitereturnline.new_amount": "Amount of Returned Parts", "new_srv_sitereturnline.new_receivetime": "Received On", "new_srv_sitereturnline.versionnumber": null, "new_srv_sitereturnline.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_sitereturnline.ownerid": "Owner", "new_srv_sitereturnline.overriddencreatedon": "Record Created On", "new_srv_sitereturnline.new_approvedqty": "Approved Quantity", "new_srv_workorder": "Work Order", "new_srv_workorder.new_subject": "Maintainance Item", "new_srv_workorder.new_samplestatus": "Sample State", "new_srv_workorder.new_samplestatus1": "Unpicked", "new_srv_workorder.new_samplestatus2": "Picked", "new_srv_workorder.new_samplestatus3": "Surveyed", "new_srv_workorder.new_fixtype": "Service Type", "new_srv_workorder.new_fixtype1": "On-site Service", "new_srv_workorder.new_fixtype2": "Back to Site", "new_srv_workorder.modifiedon": "Modified On", "new_srv_workorder.overriddencreatedon": "Record Created On", "new_srv_workorder.new_city_id": "City", "new_srv_workorder.new_istwodispatch": "Redispatch or Not", "new_srv_workorder.new_istwodispatch0": "NO", "new_srv_workorder.new_istwodispatch1": "YES", "new_srv_workorder.new_changereason": "Reason for Date Change", "new_srv_workorder.new_changereason2": "Customer changed", "new_srv_workorder.new_changereason3": "Service Station Delayed", "new_srv_workorder.new_changereason4": "Insufficient Parts", "new_srv_workorder.new_changereason6": "Commissioning Failed", "new_srv_workorder.new_trueamount": "Actual Fee", "new_srv_workorder.new_last_approve_time": "The Last Approval Time", "new_srv_workorder.new_servicetimes": "Service Times", "new_srv_workorder.owningbusinessunit": "Owning Business Unit", "new_srv_workorder.new_incident_id": "Case", "new_srv_workorder.new_canceltime": "Canceled time", "new_srv_workorder.new_county_id": "County", "new_srv_workorder.new_appointmentstatus": "Reservation State", "new_srv_workorder.new_appointmentstatus1": "Reservation Done", "new_srv_workorder.new_appointmentstatus2": "Date Change", "new_srv_workorder.new_appointmentstatus3": "Another Reservation", "new_srv_workorder.new_appointmentstatus4": "Couldn't Get in Touch", "new_srv_workorder.new_appointmentstatus5": "Service Canceled", "new_srv_workorder.new_appointmentstatus6": "Assisstant Intervened", "new_srv_workorder.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_workorder.statuscode": "Status Reason", "new_srv_workorder.statuscode1": "Active", "new_srv_workorder.statuscode2": "Inactive", "new_srv_workorder.new_contact": "Claim Person", "new_srv_workorder.new_last_flowsteps_seq": "The Last Verification Step Number", "new_srv_workorder.new_station_id": "Service Station", "new_srv_workorder.new_completiontime": "Completion Time", "new_srv_workorder.new_isdwelltime": "Extend Warranty or Not", "new_srv_workorder.new_isdwelltime0": "NO", "new_srv_workorder.new_isdwelltime1": "YES", "new_srv_workorder.new_deliverydate": "Deliver Time", "new_srv_workorder.new_dealstatus": "Service State", "new_srv_workorder.new_dealstatus1": "To be Assigned", "new_srv_workorder.new_dealstatus2": "Assiged", "new_srv_workorder.new_dealstatus3": "Reservation Done", "new_srv_workorder.new_dealstatus4": "Departed", "new_srv_workorder.new_dealstatus5": "set out", "new_srv_workorder.new_dealstatus6": "Photos Taken", "new_srv_workorder.new_dealstatus7": "Accomplished", "new_srv_workorder.new_dealstatus8": "Evaluated", "new_srv_workorder.new_bespeakendtime": "Reservation Deadline", "new_srv_workorder.new_bespeakendtime1": "5:00", "new_srv_workorder.new_bespeakendtime2": "5:30", "new_srv_workorder.new_bespeakendtime3": "6:00", "new_srv_workorder.new_bespeakendtime4": "6:30", "new_srv_workorder.new_bespeakendtime5": "7:00", "new_srv_workorder.new_bespeakendtime6": "7:30", "new_srv_workorder.new_bespeakendtime7": "8:00", "new_srv_workorder.new_bespeakendtime8": "8:30", "new_srv_workorder.new_bespeakendtime9": "9:00", "new_srv_workorder.new_bespeakendtime10": "9:30", "new_srv_workorder.new_bespeakendtime11": "10:00", "new_srv_workorder.new_bespeakendtime12": "10:30", "new_srv_workorder.new_bespeakendtime13": "11:00", "new_srv_workorder.new_bespeakendtime14": "11:30", "new_srv_workorder.new_bespeakendtime15": "12:00", "new_srv_workorder.new_bespeakendtime16": "12:30", "new_srv_workorder.new_bespeakendtime17": "13:00", "new_srv_workorder.new_bespeakendtime18": "13:30", "new_srv_workorder.new_bespeakendtime19": "14:00", "new_srv_workorder.new_bespeakendtime20": "14:30", "new_srv_workorder.new_bespeakendtime21": "15:00", "new_srv_workorder.new_bespeakendtime22": "15:30", "new_srv_workorder.new_bespeakendtime23": "16:00", "new_srv_workorder.new_bespeakendtime24": "16:30", "new_srv_workorder.new_bespeakendtime25": "17:00", "new_srv_workorder.new_bespeakendtime26": "17:30", "new_srv_workorder.new_bespeakendtime27": "18:00", "new_srv_workorder.new_bespeakendtime28": "18:30", "new_srv_workorder.new_bespeakendtime29": "19:00", "new_srv_workorder.new_bespeakendtime30": "19:30", "new_srv_workorder.new_bespeakendtime31": "20:00", "new_srv_workorder.new_bespeakendtime32": "20:30", "new_srv_workorder.new_bespeakendtime33": "21:00", "new_srv_workorder.new_bespeakendtime34": "21:30", "new_srv_workorder.new_bespeakendtime35": "22:00", "new_srv_workorder.new_memo": "Claim Content", "new_srv_workorder.new_produceddate": "Production Date", "new_srv_workorder.new_address": "Address",
  "new_srv_workorder.new_equipmentnumber": "Equipment number",
  "new_srv_workorder.new_product_idName": "Product Name",
  "new_srv_workorder.new_productgroup_idName": "Product Line",
  "new_srv_workorder.new_accepttime": "Claim Accepted Date", "new_srv_workorder.new_outsidecost": "Total Travel Expenses", "new_srv_workorder.new_fault_type_id": "Malfunction Type", "new_srv_workorder.new_result": "Survey Result", "new_srv_workorder.createdon": "Created On", "new_srv_workorder.new_name": "Work Order Number", "new_srv_workorder.new_type": "Service Type", "new_srv_workorder.new_type1": "Repair", "new_srv_workorder.new_type2": "Installation", "new_srv_workorder.new_type3": "Maintainance", "new_srv_workorder.createdonbehalfby": "Created By (Delegate)", "new_srv_workorder.new_istransfered": "Reassigned or Not", "new_srv_workorder.new_istransfered0": "NO", "new_srv_workorder.new_istransfered1": "YES", "new_srv_workorder.new_othercost": "Other Expenses", "new_srv_workorder.new_isservice": "Provide Service or Not", "new_srv_workorder.new_isservice0": "NO", "new_srv_workorder.new_isservice1": "YES", "new_srv_workorder.new_analyze": "Malfunction Analysis", "new_srv_workorder.new_departuretime": "Departure Time", "new_srv_workorder.new_station_tel": "Telephone of Service Station", "new_srv_workorder.new_warranty": "Warranty", "new_srv_workorder.new_warranty1": "Under Warranty", "new_srv_workorder.new_warranty2": "Out of Warranty", "new_srv_workorder.new_otherfeedesc": "Other Expenses Description", "new_srv_workorder.modifiedby": "Modified By", "new_srv_workorder.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_workorder.new_systemuser_tel": "Telephone of Service Personal", "new_srv_workorder.owninguser": "Owning User", "new_srv_workorder.new_phone": "Telephone", "new_srv_workorder.new_totalcost": "Total Expenses", "new_srv_workorder.createdby": "Created By", "new_srv_workorder.new_productgroup_id": "Product Line", "new_srv_workorder.new_last_flowstepsid": "The Last Verification Step", "new_srv_workorder.new_submit_time": "Submitted Time", "new_srv_workorder.new_userprofile_id": "Equipment Name", "new_srv_workorder.new_bespeakbegintime": "Appointment Start Time", "new_srv_workorder.new_bespeakbegintime1": "5:00", "new_srv_workorder.new_bespeakbegintime2": "5:30", "new_srv_workorder.new_bespeakbegintime3": "6:00", "new_srv_workorder.new_bespeakbegintime4": "6:30", "new_srv_workorder.new_bespeakbegintime5": "7:00", "new_srv_workorder.new_bespeakbegintime6": "7:30", "new_srv_workorder.new_bespeakbegintime7": "8:00", "new_srv_workorder.new_bespeakbegintime8": "8:30", "new_srv_workorder.new_bespeakbegintime9": "9:00", "new_srv_workorder.new_bespeakbegintime10": "9:30", "new_srv_workorder.new_bespeakbegintime11": "10:00", "new_srv_workorder.new_bespeakbegintime12": "10:30", "new_srv_workorder.new_bespeakbegintime13": "11:00", "new_srv_workorder.new_bespeakbegintime14": "11:30", "new_srv_workorder.new_bespeakbegintime15": "12:00", "new_srv_workorder.new_bespeakbegintime16": "12:30", "new_srv_workorder.new_bespeakbegintime17": "13:00", "new_srv_workorder.new_bespeakbegintime18": "13:30", "new_srv_workorder.new_bespeakbegintime19": "14:00", "new_srv_workorder.new_bespeakbegintime20": "14:30", "new_srv_workorder.new_bespeakbegintime21": "15:00", "new_srv_workorder.new_bespeakbegintime22": "15:30", "new_srv_workorder.new_bespeakbegintime23": "16:00", "new_srv_workorder.new_bespeakbegintime24": "16:30", "new_srv_workorder.new_bespeakbegintime25": "17:00", "new_srv_workorder.new_bespeakbegintime26": "17:30", "new_srv_workorder.new_bespeakbegintime27": "18:00", "new_srv_workorder.new_bespeakbegintime28": "18:30", "new_srv_workorder.new_bespeakbegintime29": "19:00", "new_srv_workorder.new_bespeakbegintime30": "19:30", "new_srv_workorder.new_bespeakbegintime31": "20:00", "new_srv_workorder.new_bespeakbegintime32": "20:30", "new_srv_workorder.new_bespeakbegintime33": "21:00", "new_srv_workorder.new_bespeakbegintime34": "21:30", "new_srv_workorder.new_bespeakbegintime35": "22:00", "new_srv_workorder.new_servermemo": "Memo from Service Station", "new_srv_workorder.new_curr_flowsteps_seq": "Current Approval Step Number", "new_srv_workorder.new_supervisereason": "Impeled Reason", "new_srv_workorder.new_userprofile_name": "Equipment Name", "new_srv_workorder.new_installdate": "Equipment Installed Time", "new_srv_workorder.new_curr_flowstepsid": "Current Approval Step", "new_srv_workorder.new_complateaddress": "Service Address ", "new_srv_workorder.owningteam": "Owning Team", "new_srv_workorder.new_appointmenttime": "Appointment Time", "new_srv_workorder.new_last_approvestep_user": "The Last Verified Person", "new_srv_workorder.new_originalorderid": "Original Work Order", "new_srv_workorder.exchangerate": "Exchange Rate", "new_srv_workorder.new_supervisiontime": "Impeled On", "new_srv_workorder.new_begintime": "Service Start Time", "new_srv_workorder.transactioncurrencyid": "Currency", "new_srv_workorder.new_userprofile_number": "Equipment Serial Number", "new_srv_workorder.new_solution": "Memo for Service Accomplishment", "new_srv_workorder.new_approvalstatus": "Approval State", "new_srv_workorder.new_approvalstatus1": "To be Submitted", "new_srv_workorder.new_approvalstatus2": "To be Approved", "new_srv_workorder.new_approvalstatus3": "Approved", "new_srv_workorder.new_approvalstatus4": "Rejected", "new_srv_workorder.new_approvalstatus5": "Veto", "new_srv_workorder.new_status": "Survey State", "new_srv_workorder.new_status1": "To be Surveyed", "new_srv_workorder.new_status2": "Surveyed", "new_srv_workorder.new_curr_approvestep_name": "Current Approval Step", "new_srv_workorder.new_expenseclaimid": "Expense Settlement Number", "new_srv_workorder.new_srv_worker_id": "Service Personal", "new_srv_workorder.new_endtime": "Service End Time", "new_srv_workorder.new_productmodel_id": "Product Model", "new_srv_workorder.ownerid": "Owner", "new_srv_workorder.new_enddate": "Warranty Deadline", "new_srv_workorder.new_curr_approvestep_user": "Current Approver", "new_srv_workorder.new_workhourcost": "Total Work hour Expenses", "new_srv_workorder.new_ownstation_id": "Service Station", "new_srv_workorder.new_placetime": "Arrival Time", "new_srv_workorder.statecode": "Status", "new_srv_workorder.statecode0": "Active", "new_srv_workorder.statecode1": "Inactive", "new_srv_workorder.new_contact_id": "Contact", "new_srv_workorder.new_approved_time": "Approved On", "new_srv_workorder.new_last_approvestep_name": "The Last Approval Step", "new_srv_workorder.new_faultmsg": "Malfunction Information", "new_srv_workorder.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "new_srv_workorder.new_openid": "openid", "new_srv_workorder.new_dispatchtime": "Assigned Time", "new_srv_workorder.importsequencenumber": "Import Sequence Number", "new_srv_workorder.new_longitude": "Longitude", "new_srv_workorder.new_otherphone": "Other Phonenumber", "new_srv_workorder.new_account_id": "Customer Name", "new_srv_workorder.new_feedbacktel": "Claim Telephone", "new_srv_workorder.versionnumber": null, "new_srv_workorder.new_responsetime": "Reservation Time", "new_srv_workorder.new_partcost": "Total Parts Expenses", "new_srv_workorder.new_province_id": "Province", "new_srv_workorder.new_latitude": "Latitude", "new_srv_workorder.new_srv_workorderid": "Work Order", "new_srv_partline": "Parts Replacement Details", "new_srv_partline.owninguser": "Owning User", "new_srv_partline.new_productcodenew": "Code of New Part", "new_srv_partline.createdonbehalfby": "Created By (Delegate)", "new_srv_partline.transactioncurrencyid": "Currency", "new_srv_partline.new_supplier_id": "Supplier", "new_srv_partline.new_price": "Price", "new_srv_partline.new_qty": "Quantity", "new_srv_partline.new_model": "Part Model", "new_srv_partline.importsequencenumber": "Import Sequence Number", "new_srv_partline.new_srv_workorder_id": "Work Order Number", "new_srv_partline.new_serialnonew": "Serial Number of New Part", "new_srv_partline.new_product_id": "Parts Name", "new_srv_partline.new_productcode": "Code of Old Part", "new_srv_partline.owningbusinessunit": "Owning Business Unit", "new_srv_partline.new_name": "Parts Code", "new_srv_partline.modifiedby": "Modified By", "new_srv_partline.createdby": "Created By", "new_srv_partline.timezoneruleversionnumber": "Time Zone Rule Version Number", "new_srv_partline.new_srv_station_id": "Service Station", "new_srv_partline.new_serialno": "Serial Number of Old Part", "new_srv_partline.new_srv_partlineid": "Parts Details", "new_srv_partline.owningteam": "Owning Team", "new_srv_partline.modifiedon": "Modified On", "new_srv_partline.exchangerate": "Exchange Rate", "new_srv_partline.statecode": "Status", "new_srv_partline.statecode0": "Active", "new_srv_partline.statecode1": "Inactive", "new_srv_partline.statuscode": "Status Reason", "new_srv_partline.statuscode1": "Active", "new_srv_partline.statuscode2": "Inactive", "new_srv_partline.createdon": "Created On", "new_srv_partline.new_productnew_id": "Name of New Part", "new_srv_partline.new_returnstate": "Returned to the Factory or Not", "new_srv_partline.new_returnstate0": "Not Return", "new_srv_partline.new_returnstate100": "Returned", "new_srv_partline.new_partscost": "Amount", "new_srv_partline.versionnumber": null, "new_srv_partline.modifiedonbehalfby": "Modified By (Delegate)", "new_srv_partline.ownerid": "Owner", "new_srv_partline.overriddencreatedon": "Record Created On", "new_srv_partline.utcconversiontimezonecode": "UTC Conversion Time Zone Code", "Not Back to Factory": "NO", "Back to Factory": "Yes" });

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _new_srv_claimfine$ne;

/* harmony default export */ __webpack_exports__["a"] = (_new_srv_claimfine$ne = { "new_srv_claimfine": "结算奖惩单", "new_srv_claimfine.versionnumber": null, "new_srv_claimfine.createdon": "创建时间", "new_srv_claimfine.new_findate": "奖罚日期", "new_srv_claimfine.new_type": "业务项目", "new_srv_claimfine.new_curr_flowstepsid": "当前等待签核的步骤", "new_srv_claimfine.new_curr_approvestep_name": "当前审批步骤", "new_srv_claimfine.new_last_approve_time": "上一次审批时间", "new_srv_claimfine.new_checkmonth": "月份", "new_srv_claimfine.new_curr_flowsteps_seq": "当前等待签核的步骤顺序号", "new_srv_claimfine.timezoneruleversionnumber": "时区规则版本号", "new_srv_claimfine.new_last_flowstepsid": "上一个签核步骤", "new_srv_claimfine.modifiedonbehalfby": "修改者(代理)", "new_srv_claimfine.new_name": "单号", "new_srv_claimfine.owningteam": "负责团队", "new_srv_claimfine.overriddencreatedon": "创建记录的时间", "new_srv_claimfine.new_submit_time": "提交时间", "new_srv_claimfine.statecode": "状态", "new_srv_claimfine.statecode0": "可用", "new_srv_claimfine.statecode1": "停用", "new_srv_claimfine.new_checkitem": "奖罚事项", "new_srv_claimfine.new_last_flowsteps_seq": "上一个签核步骤顺序号", "new_srv_claimfine.new_approvalstatus": "审核状态", "new_srv_claimfine.new_approvalstatus1": "制单", "new_srv_claimfine.new_approvalstatus2": "审核中", "new_srv_claimfine.new_approvalstatus3": "已审核", "new_srv_claimfine.new_approvalstatus4": "已驳回", "new_srv_claimfine.new_approvalstatus5": "已否决", "new_srv_claimfine.new_amount": "奖罚金额", "new_srv_claimfine.new_last_approvestep_user": "上一个审批人", "new_srv_claimfine.new_finetype": "奖罚类型", "new_srv_claimfine.new_finetype1": "奖励", "new_srv_claimfine.new_finetype2": "处罚", "new_srv_claimfine.createdonbehalfby": "创建者(代理)", "new_srv_claimfine.createdby": "创建者", "new_srv_claimfine.utcconversiontimezonecode": "UTC 转换时区代码", "new_srv_claimfine.new_year": "年度", "new_srv_claimfine.new_srv_station_id": "服务网点", "new_srv_claimfine.ownerid": "负责人", "new_srv_claimfine.modifiedon": "修改时间", "new_srv_claimfine.importsequencenumber": "导入序列号", "new_srv_claimfine.new_curr_approvestep_user": "当前审批人", "new_srv_claimfine.new_approved_time": "审核时间", "new_srv_claimfine.modifiedby": "修改者", "new_srv_claimfine.new_expenseclaimid": "结算单号", "new_srv_claimfine.new_srv_workorderid": "服务单", "new_srv_claimfine.new_srv_claimfineid": "费用调整单", "new_srv_claimfine.owninguser": "负责人用户", "new_srv_claimfine.new_iscommit": "事务控制", "new_srv_claimfine.new_iscommit0": "否", "new_srv_claimfine.new_iscommit1": "是", "new_srv_claimfine.statuscode": "状态描述", "new_srv_claimfine.statuscode1": "可用", "new_srv_claimfine.statuscode2": "停用", "new_srv_claimfine.new_last_approvestep_name": "上一个审批步骤", "new_srv_claimfine.new_memo": "备注", "new_srv_claimfine.owningbusinessunit": "负责的业务部门", "new_srv_trouble": "故障模式及责任判定", "new_srv_trouble.new_memo": "备注", "new_srv_trouble.owningteam": "负责团队", "new_srv_trouble.statecode": "状态", "new_srv_trouble.statecode0": "可用", "new_srv_trouble.statecode1": "停用", "new_srv_trouble.new_srv_errorgroup_id": "故障零件", "new_srv_trouble.new_solution": "维修措施", "new_srv_trouble.owninguser": "负责人用户", "new_srv_trouble.createdonbehalfby": "创建者(代理)", "new_srv_trouble.new_srv_troubleid": "故障模式及责任判定", "new_srv_trouble.importsequencenumber": "导入序列号", "new_srv_trouble.new_srv_workorder_id": "服务报告单号", "new_srv_trouble.new_srv_errorassembly_id": "故障系统", "new_srv_trouble.utcconversiontimezonecode": "UTC 转换时区代码", "new_srv_trouble.owningbusinessunit": "负责的业务部门", "new_srv_trouble.new_name": "名称", "new_srv_trouble.modifiedby": "修改者", "new_srv_trouble.createdby": "创建者", "new_srv_trouble.timezoneruleversionnumber": "时区规则版本号", "new_srv_trouble.new_description": "故障现象描述", "new_srv_trouble.modifiedon": "修改时间", "new_srv_trouble.statuscode": "状态描述", "new_srv_trouble.statuscode1": "可用", "new_srv_trouble.statuscode2": "停用", "new_srv_trouble.createdon": "创建时间", "new_srv_trouble.new_srv_workhours_id": "维修项目工时说明", "new_srv_trouble.new_errormodule_id": "故障部件", "new_srv_trouble.new_srv_error_id": "故障现象", "new_srv_trouble.versionnumber": null, "new_srv_trouble.modifiedonbehalfby": "修改者(代理)", "new_srv_trouble.ownerid": "负责人", "new_srv_trouble.overriddencreatedon": "创建记录的时间", "kbarticle": "文章", "kbarticle.modifiedonbehalfby": "修改者(代理)", "kbarticle.statecode": "状态 ", "kbarticle.statecode1": "草稿", "kbarticle.statecode2": "未审批", "kbarticle.statecode3": "已发布", "kbarticle.languagecode": "语言", "kbarticle.createdon": "创建时间", "kbarticle.createdonbehalfby": "创建者(代理)", "kbarticle.transactioncurrencyid": "货币", "kbarticle.entityimageid": "实体图像 ID", "kbarticle.importsequencenumber": "导入序列号", "kbarticle.organizationid": "组织", "kbarticle.kbarticletemplateid": "基本模板", "kbarticle.subjectid": "主题", "kbarticle.comments": "注释", "kbarticle.statuscode": "状态描述", "kbarticle.statuscode1": "草稿", "kbarticle.statuscode2": "未审批", "kbarticle.statuscode3": "已发布", "kbarticle.keywords": "关键字", "kbarticle.versionnumber": "标题", "kbarticle.modifiedby": "修改者", "kbarticle.createdby": "创建者", "kbarticle.articlexml": "文章 XML", "kbarticle.exchangerate": "汇率", "kbarticle.kbarticleid": "文章", "kbarticle.modifiedon": "修改时间", "kbarticle.title": "标题", "kbarticle.content": "内容", "kbarticle.number": "编号", "kbarticle.description": "说明", "kbarticle.overriddencreatedon": "创建记录的时间", "new_srv_station": "服务站档案", "new_srv_station.owninguser": "负责人用户", "new_srv_station.statecode": "状态", "new_srv_station.statecode0": "可用", "new_srv_station.statecode1": "停用", "new_srv_station.new_province_id": "所属省份", "new_srv_station.new_city_id": "所属城市", "new_srv_station.new_email": "电子邮箱", "new_srv_station.new_siteowner": "服务站负责人", "new_srv_station.versionnumber": null, "new_srv_station.new_county_id": "所属县区", "new_srv_station.createdonbehalfby": "创建者(代理)", "new_srv_station.new_fax": "传真", "new_srv_station.importsequencenumber": "导入序列号", "new_srv_station.new_name": "服务站名称", "new_srv_station.new_type": "服务站类型", "new_srv_station.new_type1": "自营", "new_srv_station.new_type2": "第三方", "new_srv_station.new_type3": "中心库", "new_srv_station.new_region_id": "所属大区", "new_srv_station.timezoneruleversionnumber": "时区规则版本号", "new_srv_station.utcconversiontimezonecode": "UTC 转换时区代码", "new_srv_station.statuscode": "状态描述", "new_srv_station.statuscode1": "可用", "new_srv_station.statuscode2": "停用", "new_srv_station.owningbusinessunit": "负责的业务部门", "new_srv_station.new_phone": "负责人电话", "new_srv_station.owningteam": "负责团队", "new_srv_station.modifiedby": "修改者", "new_srv_station.new_code": "服务站编码", "new_srv_station.new_address": "地址", "new_srv_station.new_level": "服务站级别", "new_srv_station.new_level1": "一级", "new_srv_station.new_level2": "二级", "new_srv_station.new_level3": "三级", "new_srv_station.new_areacode_id": "区域代码", "new_srv_station.new_currentamount": "当前额度", "new_srv_station.modifiedon": "修改时间", "new_srv_station.new_region": "负责区域", "new_srv_station.modifiedonbehalfby": "修改者(代理)", "new_srv_station.new_srv_stationid": "服务站档案", "new_srv_station.createdon": "创建时间", "new_srv_station.createdby": "创建者", "new_srv_station.new_limitamount": "是否控制额度", "new_srv_station.new_limitamount0": "否", "new_srv_station.new_limitamount1": "是", "new_srv_station.new_postalcode": "邮政编码", "new_srv_station.new_beginamount": "期初额度", "new_srv_station.ownerid": "负责人", "new_srv_station.overriddencreatedon": "创建记录的时间", "new_srv_outsideline": "外出明细", "new_srv_outsideline.new_memo": "费用说明", "new_srv_outsideline.owningteam": "负责团队", "new_srv_outsideline.new_endstate": "完工情况", "new_srv_outsideline.new_endstate1": "已完工", "new_srv_outsideline.new_endstate2": "再次上门", "new_srv_outsideline.new_endstate3": "无法完工", "new_srv_outsideline.statecode": "状态", "new_srv_outsideline.statecode0": "可用", "new_srv_outsideline.statecode1": "停用", "new_srv_outsideline.statuscode": "状态描述", "new_srv_outsideline.statuscode1": "可用", "new_srv_outsideline.statuscode2": "停用", "new_srv_outsideline.new_begintime": "出发时间", "new_srv_outsideline.new_foodcost": "餐饮费", "new_srv_outsideline.createdonbehalfby": "创建者(代理)", "new_srv_outsideline.transactioncurrencyid": "货币", "new_srv_outsideline.new_end": "外出终点", "new_srv_outsideline.new_endmemo": "外出终点信息", "new_srv_outsideline.new_statecode": "服务状态", "new_srv_outsideline.new_statecode1": "待预约", "new_srv_outsideline.new_statecode2": "待出发", "new_srv_outsideline.new_statecode3": "已出发", "new_srv_outsideline.new_statecode4": "已到位", "new_srv_outsideline.new_statecode10": "已结束", "new_srv_outsideline.new_appointmenttime": "预约时间", "new_srv_outsideline.importsequencenumber": "导入序列号", "new_srv_outsideline.createdon": "创建时间", "new_srv_outsideline.owninguser": "负责人用户", "new_srv_outsideline.new_srv_workorder_id": "服务单号", "new_srv_outsideline.versionnumber": null, "new_srv_outsideline.modifiedon": "修改时间", "new_srv_outsideline.new_stationid": "所属服务站", "new_srv_outsideline.new_otherfee": "其他费用", "new_srv_outsideline.new_name": "名称", "new_srv_outsideline.modifiedby": "修改者", "new_srv_outsideline.createdby": "创建者", "new_srv_outsideline.timezoneruleversionnumber": "时区规则版本号", "new_srv_outsideline.overriddencreatedon": "创建记录的时间", "new_srv_outsideline.new_srv_worker_id": "服务人员", "new_srv_outsideline.owningbusinessunit": "负责的业务部门", "new_srv_outsideline.new_arrivetime": "到达时间", "new_srv_outsideline.new_arrivepoint": "到达经纬度", "new_srv_outsideline.utcconversiontimezonecode": "UTC 转换时区代码", "new_srv_outsideline.exchangerate": "汇率", "new_srv_outsideline.new_appointmentcreatetime": "预约创建时间", "new_srv_outsideline.ownerid": "负责人", "new_srv_outsideline.new_travelcost": "交通费", "new_srv_outsideline.new_solution": "完工备注" }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.new_arrivetime", "到达时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.new_start", "外出起点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.new_startmemo", "外出信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.new_boardcost", "住宿费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.new_srv_outsidelineid", "外出明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_outsideline.new_startpoint", "起点经纬度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker", "服务人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_trainnumber", "培训次数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_skill", "技能"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_srv_workerid", "服务人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_phone", "手机"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_name", "姓名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_code", "服务人员编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_workyear", "工作年限"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_srv_station_id", "服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_sex", "性别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_sex1", "男"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_sex2", "女"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_region", "负责区域"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_job", "岗位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_job1", "初级工程师"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_job2", "中级工程师"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_job3", "高级工程师"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_wechat", "微信账号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_password", "xmobile密码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_postalcode", "邮政编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel", "文化程度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel1", "小学"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel2", "初中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel3", "中专"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel4", "高中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel5", "技校"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel6", "大专"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.new_educationlevel7", "本科"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_worker.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim", "费用结算单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_settleway", "结算方式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_settleway1", "工时制"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_settleway2", "承包制"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_srv_expense_claimid", "费用结算单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_bankname", "账户名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_totalcost", "总费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_branchamount", "代表处核准金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_name", "结算单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month", "结算月份"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month1", "1"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month2", "2"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month3", "3"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month4", "4"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month5", "5"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month6", "6"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month7", "7"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month8", "8"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month9", "9"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month10", "10"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month11", "11"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_month12", "12"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_workhourcost", "工时费合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_manexpense", "工时费总额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_expressname", "快递名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_othercost", "其他费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_sendnumber", "寄件单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_decreasecarriage", "扣减运费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_maker", "制单人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_performance", "考核结果"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_fineamount", "调整费用总额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approvaltime", "总部核准时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_partcost", "配件费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_invoicedate", "发票接收日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_otherfeeremark", "其他费用说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus", "结算单状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus2", "待旧件返回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus3", "待旧件签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus4", "待费用计算"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus5", "待费用确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus6", "费用已确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus7", "发票已接受"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_formstatus8", "费用已付款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year", "结算年度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2013", "2013"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2014", "2014"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2015", "2015"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2016", "2016"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2017", "2017"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2018", "2018"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2019", "2019"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_year2020", "2020"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_bank", "开户银行"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_branchcomment", "审核意见"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_siteconfirmstatus", "网点确认状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_siteconfirmstatus1", "未开始"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_siteconfirmstatus2", "确认中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_siteconfirmstatus3", "已确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_siteconfirmstatus4", "被驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_cityid", "银行城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_outsidecost", "外出费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_addcarriage", "补助运费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_approvalamount", "总部核准金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_srv_station_id", "服务网点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_confirmdate", "费用确认时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_adjustamount", "服务商调整后金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_section", "结算区间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_section1", "上半年"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_section2", "下半年"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_sitecode", "销售服务商编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_ispayed", "是否已收款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_ispayed0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_ispayed1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_returnamount", "退货及调拨运费总额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_payeddate", "财务支付时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_oldpartamount", "旧件运费总额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_iscommit", "是否提交"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_iscommit0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_iscommit1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_provinceid", "银行省份"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_bankcode", "账号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claim.new_invoiceno", "发票号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread", "公告阅读及回复"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_replystatus", "回复状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_replystatus1", "未回复"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_replystatus2", "已回复"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_replydate", "回复时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_readercode", "阅读人帐号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_noticereadid", "公告阅读及回复"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_readstatus", "阅读状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_readstatus1", "未读"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_readstatus2", "已读"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_replycontent", "回复内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_isreply", "是否需要回复"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_isreply0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_isreply1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_noticeid", "公告单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_publishdate", "发布时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.new_readername", "阅读人名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_noticeread.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline", "费用结算单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_workhourcost", "工时费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_othercost", "其他费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_totalcost", "总费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_srv_expense_claim_id", "结算单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_otherfeedesc", "其他费用说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_name", "结算明细单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_srv_station_id", "服务网点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_srv_expense_claimlineid", "费用结算单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_outsidecost", "外出费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_srv_workorderid", "服务单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.new_partcost", "配件费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_expense_claimline.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice", "公告"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_ispublish", "是否已发布"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_ispublish0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_ispublish1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_isurgent", "是否紧急"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_isurgent0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_isurgent1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_buid", "发布部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_publishdate", "发布时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type", "公告类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type100000000", "营销政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type100000001", "管理政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type100000002", "产品公告"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type1", "行政公告"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type2", "销售政策"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type3", "促销公告"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type4", "新品发布"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_type5", "其它"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_noticetypeid", "公告类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_isreply", "是否需要回复"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_isreply0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_isreply1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_noticeid", "公告通知"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_name", "单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_content", "内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.new_title", "公告标题"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.ownerid", "发布人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_notice.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product", "产品物料"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.iskit", "为配套件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.iskit0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.iskit1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.productid", "产品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.currentcost", "当前成本"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.standardcost_base", "标准成本(基础货币)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productmodel", "产品型号（废弃）"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.productstructure", "产品结构"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.productstructure1", "产品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.productstructure2", "产品系列"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.productstructure3", "产品捆绑销售"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productgroupid", "产品线"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.validfromdate", "有效期的开始日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productgroup", "产品类别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productgroup1", "成品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productgroup2", "配件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.price_base", "定价(基础货币)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.exchangerate", "汇率"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.producturl", "URL"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statecode1", "已停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statecode2", "草稿"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statecode3", "正在修订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.price", "定价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.defaultuomscheduleid", "计价单位组"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productin", "产品中类"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.size", "大小"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.pricelevelid", "默认价目表"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_is_barcodemanagement", "条码管理方式"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_is_barcodemanagement1", "单品管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_is_barcodemanagement2", "非单品管理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.traversedpath", "遍历的路径"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_isreturn", "是否返厂"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_isreturn0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_isreturn1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.modifiedbyexternalparty", "修改者(外部参与方)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_fouryards", "四位码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.entityimageid", "实体图像 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_userprofile_id", "所属设备"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.vendorname", "供应商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.producttypecode", "产品类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.producttypecode1", "销售存货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.producttypecode2", "杂项费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.producttypecode3", "服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.producttypecode4", "固定费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.vendorpartnumber", "供应商名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productmodule_id", "产品型号(型号表)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.processid", "流程"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.description", "说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.parentproductid", "父"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.subjectid", "主题"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.stageid", "流程阶段"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_productcategories", "产品大类"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_parstypeid", "部件类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.defaultuomid", "默认计价单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.stockvolume", "库存容量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.quantitydecimal", "支持小数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.transactioncurrencyid", "货币"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.isstockitem", "库存项"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.isstockitem0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.isstockitem1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.quantityonhand", "现存数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.vendorid", "供应商 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.currentcost_base", "当前成本(基础货币)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.createdbyexternalparty", "创建者(外部参与方)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.hierarchypath", "层次结构路径"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.suppliername", "提供商名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.validtodate", "有效期的结束日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.stockweight", "库存重量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statuscode2", "已停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statuscode0", "草稿"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.statuscode3", "正在修订"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.dmtimportstate", "仅供内部使用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.organizationid", "组织"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.productnumber", "编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_desc", "说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.standardcost", "标准成本"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_seriescategory", "系列类别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_seriescategory1", "大类"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_seriescategory2", "中类"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_seriescategory3", "型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "product.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair", "维修内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_workhourcost", "工时金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_standardhour", "标准工时"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.transactioncurrencyid", "货币"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_project_id", "维修项目"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_srv_workorder_id", "服务报告单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_srv_repairid", "维修内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.exchangerate", "汇率"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_workhourprice", "工时单价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_srv_workhours_id", "维修工时说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_repair.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline", "旧件返厂明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_modal", "型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_approvalqty", "实际返回数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_partsid", "配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_errorqty", "不良数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_errorassemblyid", "故障系统"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_fault_desc", "故障原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_appraiser", "鉴定人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_deliverydate", "交车日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_notbyreason", "不通过原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_errormoduleid", "故障部件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_vendorcode", "供应商编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_appraisalresult", "旧件鉴定结果"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_appraisalresult0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_appraisalresult1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_appqty", "申请数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_repairdate", "维修日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_unit", "单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_partscode", "配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_oldno", "旧件出厂编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_srv_partsreturnlineid", "旧件返厂明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_oldpartid", "旧配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_amount", "申请金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_isreturn", "是否返厂"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_isreturn0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_isreturn1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_new_errorgroupid", "故障零件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_formstatus", "配件状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_formstatus1", "正常"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_formstatus2", "不良"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_price", "配件价格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_workorderid", "服务单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_receiveqty", "签收数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_partline_id", "换件明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_partscost", "金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_newno", "新件出厂编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_pastsname", "外购配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_srv_error_id", "故障现象"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_partsreturnid", "返厂单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_isappraisal", "采购件处理"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_isappraisal0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_isappraisal1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_ispurchase", "是否采购件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_ispurchase0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_ispurchase1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_product_id", "产品型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_meno", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_oldpartlable", "旧件标签号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_vendor", "供应商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturnline.new_invqty", "库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn", "旧件返厂单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_shipconfirmdate", "发运确认日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_curr_approvestep_name", "当前审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_srv_partsreturnid", "旧件返厂单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_printstatus", "打印状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_printstatus1", "未打印"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_printstatus2", "已打印"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_isfined", "是否扣款"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_isfined0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_isfined1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_stocksite_sendid", "退货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_phone", "发运人电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_name", "返厂单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_totalamount", "总金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_oldno", "旧件出厂编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_maker", "制单人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_stocksite_receiveid", "收货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_last_approvestep_user", "上一个审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_sendon", "发运日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_formstatus", "表单状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_formstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_formstatus2", "已发运"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_formstatus3", "部分签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_formstatus4", "全部签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_formstatus5", "已确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_carryid", "发运单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_srv_stationid", "销售服务商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_curr_approvestep_user", "当前审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_receiveddate", "签收日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_systemuser_id", "签收人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_newno", "新件出厂编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_srv_workorderid", "服务单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_carrycompany", "运输单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_last_approve_time", "上一次审批时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_confirmdate", "旧件确认时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_sendby", "发运人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_sitecode", "销售服务商编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_fee", "运费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_applyby", "网点申请人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_buid", "事业部"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_last_approvestep_name", "上一个审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsreturn.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder", "出库单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invintype", "出库类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invintype1", "部品申请"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invintype2", "调拨"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invintype3", "报损出库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invintype4", "报缺出库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invintype5", "报废出库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_srv_sendstocksite_id", "发货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusereason", "报废原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusereason1", "新件不良"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusereason2", "仓储报损"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusereason3", "保内旧返"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusereason4", "滞纳无价值"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_srv_recstocksite_id", "收货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invoiceamount", "发票金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_outuser", "出库人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_name", "出库单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_recivedate", "签收时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_indate", "出库时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_boxuser", "装箱人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_srv_partsapply_id", "部品申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_boxdate", "装箱时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_srv_parttransorder_id", "部品调拨单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invoicedate", "发票日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_recuser", "收货人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusedest", "报废去向"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusedest1", "物资处置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusedest2", "品管调研"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusedest3", "异地处置"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode", "出库状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode2", "下发仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode3", "拣货完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode4", "装箱完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode5", "出库完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_statuscode6", "已托运"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_rectele", "收货电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_srv_station_id", "服务店"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_pickuser", "拣货人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_stockoutorderid", "出库单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_pickdate", "拣货时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_recstatuscode", "服务站签收状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_recstatuscode1", "未签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_recstatuscode2", "已签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_recstatuscode3", "部分签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unuseamount", "报废金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_unusesalvage", "报废残值"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_invoiceno", "发票号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.new_srv_shipconfirm_id", "托运单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorder.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order", "服务站配件销售单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_saletimes", "销售时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_srv_station_id", "服务网点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_orderstatus", "订单状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_orderstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_orderstatus2", "已发售"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_name", "订单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_stocksite_id", "出货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_order_contact", "服务人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_sitecode", "网点编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_orderid", "服务网点配件销售单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_order.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn", "配件退货申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returnorderstatus", "退库单状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returnorderstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returnorderstatus2", "已发运"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returnorderstatus3", "部分签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returnorderstatus4", "已签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_senderphone", "发运人电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_curr_flowstepsid", "当前等待签核的步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_curr_approvestep_name", "当前审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_senddepartment", "发运单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returntype", "退库类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returntype1", "调拨退货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returntype2", "备货退货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returntype3", "采购退货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_curr_flowsteps_seq", "当前等待签核的步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_srv_sitereturnid", "配件退货申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_last_flowstepsid", "上一个签核步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_stocksite_sendid", "退货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_name", "申请单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_address", "收货人地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_sender", "发运人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_sendnumber", "发运单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_last_flowsteps_seq", "上一个签核步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_maker", "制单人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approvalstatus4", "已驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approvalstatus5", "已否决"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_stocksite_receiveid", "收货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_last_approvestep_user", "上一个审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_srv_station_id", "服务网点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returnreason", "退货原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_addressee", "收货人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_returntime", "退货时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_curr_approvestep_user", "当前审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_systemuser_id", "签收人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_applyby", "网点申请人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_receiveddate", "签收日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_isclose", "是否关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_isclose0", "未关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_isclose1", "已关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_last_approve_time", "上一次审批时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_addresseephone", "收货人电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_fee", "运费"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_last_approvestep_name", "上一个审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_sendtime", "发运时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturn.new_businessunit_id", "事业部"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder", "调拨单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transtype", "调拨类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transtype1", "调出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transtype2", "调入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_curr_approvestep_name", "当前审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_receiveduser_id", "签收人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_receivecode", "收货仓库编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transorderstatus", "单据状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transorderstatus1", "待发送"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transorderstatus2", "部分发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transorderstatus3", "已发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transorderstatus4", "部分签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transorderstatus5", "已签收"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_stocksite_sendid", "发货仓库名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_name", "调拨单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_transdate", "调拨日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_submit_time", "发送时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvalstatus4", "已驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvalstatus5", "已否决"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_stocksite_receiveid", "收货仓库名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_last_approvestep_user", "上一个审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approvedby", "审核人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_sentcode", "发货仓库编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_curr_approvestep_user", "当前审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_new_approvalstatus", "审核状态(X)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_new_approvalstatus4", "已驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_new_approvalstatus5", "已否决"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_srv_parttransorderid", "调拨单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_receiveddate", "签收日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_isclose", "是否关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_isclose0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_isclose1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_last_approve_time", "上一次审批时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_submitby", "发送人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statuscode100000000", "未发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statuscode100000001", "发货中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statuscode100000002", "已发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_last_approvestep_name", "上一个审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_parttransorder.new_businessunit_id", "地区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation", "注释"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.isprivate", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.isprivate0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.isprivate1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.filename", "文件名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.filesize", "文件大小(字节)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.subject", "标题"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.objectid", "关于"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.mimetype", "MIME 类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.stepid", "阶段 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.documentbody", "文档"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.notetext", "说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.objecttypecode", "对象类型 "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.langid", "语言 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.isdocument", "是文档"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.isdocument0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.isdocument1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "annotation.annotationid", "注释"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail", "出库单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_parttransorderline_id", "调拔单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_planprice", "计划价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_orderlineentityid", "前置单明细id"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_uom_id", "计量单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_applyprice", "申请价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_stockoutorderdetailid", "出库单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_recqty", "签收数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_defaultuomid", "计量单位组"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_tempcurrentinv", "当前库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_product_id", "部品名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_orderlineentitytype", "前置单明细类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_srv_partsapplydetil_id", "配件申请单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_partscode", "部品编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_sendqty", "发货数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_stockoutorder_id", "出库单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_shipqty", "待发运数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.new_applyqty", "申请数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_stockoutorderdetail.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply", "配件申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_requiredate", "需求日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_type", "申请类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_type1", "正常订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_type2", "紧急订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_type3", "维修申请"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_curr_flowstepsid", " 当前等待签核的步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_curr_approvestep_name", "当前审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_workorder_id", "服务单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_last_flowstepsid", "上一个签核步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_stocksite_sendid", "发货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_name", "配件申请单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_address", "收货地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_stocksite_id", "申请仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_last_flowsteps_seq", "上一个签核步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approvalstatus2", "签核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approvalstatus3", "已签核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approvalstatus4", "已驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approvalstatus5", "已否决"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_last_approvestep_user", "上一个审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.traversedpath", "遍历的路径"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_recipient", "收货人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_srv_partsapplyid", "配件申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.processid", "流程 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_curr_approvestep_user", "当前审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.stageid", "阶段 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_curr_flowsteps_seq", " 当前等待签核步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_station_id", "服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_isclose", "是否关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_isclose0", "未关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_isclose1", "已关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_last_approve_time", "上一次审批时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_tatalamount", "总金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_phonenumber", "收货人电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statuscode1", "待发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statuscode100000000", "部分发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statuscode100000001", "已发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statuscode100000002", "已关闭"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_last_approvestep_name", "上一个审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.new_incident_id", "案例"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapply.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil", "配件申请明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_code", "配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statuscode1", "待发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statuscode100000000", "部分发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statuscode100000001", "已发货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_uom_id", "计量单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_price", "单价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_qty", "申请数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_currency_id", "币别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_partscost", "金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_srv_workorder_id", "服务单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_tempcurrentinv", "当前库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_desc", "说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_product_id", "配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_srv_partsapply_id", "配件申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_actualqty", "核准数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_stocksite_sendid", "发货仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_srv_partsapplydetilid", "配件申请明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_shippedqty", "已发货数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.new_pendingqty", "待发货数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partsapplydetil.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline", "服务站配件销售单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_productmodel", "配件型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_sourcefrom", "配件来源"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_sourcefrom1", "备货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_sourcefrom2", "采购"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_sourcefrom3", "三包调拨"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_uom_id", "单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_qty", "销售数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_orderlineid", "服务网点配件销售单明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_srv_expense_claimid", "费用结算单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_productid", "配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_productcode", "配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_actualprice", "实际售价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_seq", "序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_isclaim", "是否结算"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_isclaim0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_isclaim1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_orderid", "销售订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_amount", "金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_orderline.new_vendorcode", "供应商编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment", "服务站额度调整单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_adjustmenttype", "来源类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_adjustmenttype2", "配件发运"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_adjustmenttype3", "旧件返厂"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_adjustmenttype4", "配件退货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_adjustmenttype100", "期初设定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_curr_approvestep_name", "当前审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approvalstatus4", "已驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approvalstatus5", "已否决"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_amounttype", "额度变更"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_amounttype1", "增加"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_amounttype2", "减少"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_srv_amountadjustmentid", "服务站额度调整单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_status", "生效状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_status0", "未生效"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_status1", "已生效"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_stationid", "服务网点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_name", "申请单编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_curr_approvestep_user", "当前审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_curr_flowsteps_seq", "当前等待签核的步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_stationcode", "服务站编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_curr_flowstepsid", "当前等待签核的步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_last_approve_time", "上一次审批时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_last_approvestep_name", "上一个审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_amount", "调整额度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_last_flowsteps_seq", "上一个签核步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_last_approvestep_user", "上一个审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_last_flowstepsid", "上一签核步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountadjustment.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog", "服务站额度调整流水"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustmenttype", "来源类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustmenttype1", "额度调整"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustmenttype2", "配件发运"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustmenttype3", "旧件返厂"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustmenttype4", "配件退货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustmenttype100", "期初设定"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_srv_amountadjustment_id", "额度调整单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_formentityid", "单据实体ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_formentitytype", "单据实体类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_name", "来源单据编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_srv_station_id", "服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.organizationid", "组织 ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_adjustamount", "调整金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_memo", "备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.new_srv_amountchangelogid", "服务网点额度调整流水"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_amountchangelog.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction", "库存事务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_product_id", "物料名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype", "交易类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype1", "配件调拨发运单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype2", "配件备货发运单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype3", "配件采购发运单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype4", "配件补货发运单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype5", "配件调拨退货订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype6", "配件备货退货订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype7", "配件采购退货订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype8", "配件销售订单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype9", "服务维修"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype10", "配件库存调整单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transactiontype11", "无单据发运"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_fromno", "关联单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_uom_id", "计量单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_detialid", "单号明细id"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_qty", "数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_formentitytype", "单据实体名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_formid", "单据id"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transdirection", "交易方向(废弃)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transdirection0", "入库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_transdirection1", "出库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_invtransdirection", "交易方向"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_invtransdirection1", "入库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_invtransdirection2", "出库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_partprice", "配件价格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_stocksite_id", "服务仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_srv_stationid", "库存地点"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_part_stocktransactionid", "库存事务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_formtype", "配件来源"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_formtype1", "调拨"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_formtype2", "备货"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_formtype3", "采购"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.new_partcode", "物料编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_part_stocktransaction.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv", "配件库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_productclass", "产品状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_productclass1", "良品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_productclass2", "不良品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_uom_id", "单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_qty", "数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.versionnumber", "版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_srv_siteinvid", "配件库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_productcode", "配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_product_id", "配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_stocksite_id", "仓库名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.new_stockcode", "仓库编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_siteinv.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline", "配件退货明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_uomid", "单位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_receiveqty", "签收数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_partcode", "配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_price", "配件价格"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_productmodel", "配件型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_reason", "不通过原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_sitereturnid", "退货申请单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_identresults", "旧件鉴定结果"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_identresults1", "通过"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_identresults2", "不通过"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_appraisaler", "鉴定人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_product_id", "配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_sitestockqty", "网点库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_returnqty", "退货数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_name", "名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_shipproperty", "配件属性"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_shipproperty1", "备货件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_shipproperty2", "采购件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_receivedqty2", "入待领库数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_receivedqty", "签收数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_srv_sitereturnlineid", "配件退货明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_new_receivedqty2", "入待领库数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_receiveowner", "签收人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_transqty", "发运数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_amount", "退货金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_receivetime", "签收时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_sitereturnline.new_approvedqty", "核准数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder", "服务单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_subject", "保养项目"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_samplestatus", "抽样状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_samplestatus1", "未抽中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_samplestatus2", "已抽中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_samplestatus3", "已回访"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_fixtype", "维修类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_fixtype1", "上门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_fixtype2", "送修"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_city_id", "所属城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_istwodispatch", "是否为二次派工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_istwodispatch0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_istwodispatch1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_changereason", "改约原因"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_changereason2", "用户调整上门时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_changereason3", "服务队推迟上门时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_changereason4", "缺配件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_changereason6", "调试未通气"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_trueamount", "实收金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_last_approve_time", "上一次审批时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_servicetimes", "服务次数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_incident_id", "案例"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_canceltime", "取消时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_county_id", "所属县区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus", "服务预约情况"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus1", "预约成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus2", "改约"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus3", "另约"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus4", "联系不上"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus5", "服务取消"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmentstatus6", "内勤已干预"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_contact", "反馈人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_last_flowsteps_seq", "上一个签核步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_station_id", "服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_completiontime", "完工时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_isdwelltime", "是否延保期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_isdwelltime0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_isdwelltime1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_deliverydate", "送货时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus", "处理状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus1", "未派工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus2", "已派工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus3", "已响应"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus4", "已出发"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus5", "已到位"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus6", "已拍照"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus7", "已完工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dealstatus8", "已评价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime", "预约截止时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime1", "5:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime2", "5:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime3", "6:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime4", "6:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime5", "7:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime6", "7:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime7", "8:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime8", "8:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime9", "9:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime10", "9:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime11", "10:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime12", "10:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime13", "11:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime14", "11:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime15", "12:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime16", "12:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime17", "13:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime18", "13:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime19", "14:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime20", "14:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime21", "15:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime22", "15:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime23", "16:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime24", "16:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime25", "17:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime26", "17:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime27", "18:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime28", "18:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime29", "19:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime30", "19:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime31", "20:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime32", "20:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime33", "21:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime34", "21:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakendtime35", "22:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_memo", "反馈内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_produceddate", "生产日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_address", "联系地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_product_idName", "产品名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_productgroup_idName", "产品线"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_accepttime", "受理时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_outsidecost", "外出费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_fault_type_id", "故障类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_result", "回访结果"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_name", "服务单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_type", "服务类型"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_type1", "维修"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_type2", "安装"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_type3", "保养"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_istransfered", "是否已转派单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_istransfered0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_istransfered1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_othercost", "其他费用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_isservice", "是否服务"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_isservice0", "否"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_isservice1", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_analyze", "故障分析"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_departuretime", "出发时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_station_tel", "服务站电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_warranty", "保内保外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_warranty1", "保内"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_warranty2", "保外"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_otherfeedesc", "其他费用说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_systemuser_tel", "服务人员电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_phone", "联系电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_totalcost", "费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_productgroup_id", "产品线"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_last_flowstepsid", "上一个签核步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_submit_time", "提交时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_userprofile_id", "设备名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime", "预约开始时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime1", "5:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime2", "5:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime3", "6:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime4", "6:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime5", "7:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime6", "7:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime7", "8:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime8", "8:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime9", "9:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime10", "9:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime11", "10:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime12", "10:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime13", "11:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime14", "11:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime15", "12:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime16", "12:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime17", "13:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime18", "13:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime19", "14:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime20", "14:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime21", "15:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime22", "15:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime23", "16:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime24", "16:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime25", "17:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime26", "17:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime27", "18:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime28", "18:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime29", "19:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime30", "19:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime31", "20:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime32", "20:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime33", "21:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime34", "21:30"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_bespeakbegintime35", "22:00"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_servermemo", "服务队备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_curr_flowsteps_seq", "当前等待签核步骤顺序号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_supervisereason", "督办事由"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_userprofile_name", "设备名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_installdate", "设备安装时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_curr_flowstepsid", "当前等待签核的步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_complateaddress", "服务完工地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_appointmenttime", "预约时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_last_approvestep_user", "上一个审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_originalorderid", "转派来源单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.exchangerate", "汇率"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_supervisiontime", "督办时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_begintime", "服务开始时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.transactioncurrencyid", "货币"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_userprofile_number", "设备序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_installdate", "安装时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_solution", "完工备注"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approvalstatus", "审核状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approvalstatus1", "制单"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approvalstatus2", "审核中"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approvalstatus3", "已审核"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approvalstatus4", "已驳回"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approvalstatus5", "已否决"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_status", "回访状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_status1", "未回访"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_status2", "已回访"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_curr_approvestep_name", "当前审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_expenseclaimid", "结算单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_srv_worker_id", "服务人员"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_endtime", "服务结束时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_productmodel_id", "产品型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_enddate", "保修截止日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_begindate", "保修开始日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_curr_approvestep_user", "当前审批人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_workhourcost", "工时费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_ownstation_id", "所属服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_placetime", "到位时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_contact_id", "联系人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_approved_time", "审核时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_last_approvestep_name", "上一个审批步骤"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_faultmsg", "故障信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_openid", "openid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_dispatchtime", "派工时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_longitude", "经度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_otherphone", "其他号码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_account_id", "客户名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_feedbacktel", "反馈电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_responsetime", "响应时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_partcost", "配件费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_province_id", "所属省份"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_latitude", "纬度"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_workorder.new_srv_workorderid", "服务报告"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline", "服务单更换件明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.owninguser", "负责人用户"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_productcodenew", "新件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.createdonbehalfby", "创建者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.transactioncurrencyid", "货币"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_supplier_id", "供应商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_price", "定价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_qty", "数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_model", "配件型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.importsequencenumber", "导入序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_srv_workorder_id", "服务报告单号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_serialnonew", "新件序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_product_id", "配件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_productcode", "旧件编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.owningbusinessunit", "负责的业务部门"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_name", "配件编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.modifiedby", "修改者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.createdby", "创建者"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.timezoneruleversionnumber", "时区规则版本号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_srv_station_id", "服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_serialno", "旧件序列号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_srv_partlineid", "配件明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.owningteam", "负责团队"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.modifiedon", "修改时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.exchangerate", "汇率"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.statecode", "状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.statecode0", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.statecode1", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.statuscode", "状态描述"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.statuscode1", "可用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.statuscode2", "停用"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.createdon", "创建时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_productnew_id", "新件名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_returnstate", "返厂状态"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_returnstate0", "未返厂"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_returnstate100", "已返厂"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.new_partscost", "金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.versionnumber", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.modifiedonbehalfby", "修改者(代理)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.ownerid", "负责人"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.overriddencreatedon", "创建记录的时间"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "new_srv_partline.utcconversiontimezonecode", "UTC 转换时区代码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "ProductGroupName", "产品线名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "ProductName", "产品名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "ProductNumber", "产品编号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "SelectProdutGroup", "请选择产品线"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "SelectProdutModel", "请选择产品型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "SelectProdut", "请选择产品"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "ProductType", "产品类别"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "Not Back to Factory", "是"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_new_srv_claimfine$ne, "Back to Factory", "否"), _new_srv_claimfine$ne);

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _partapplyname$servic;

/* harmony default export */ __webpack_exports__["a"] = (_partapplyname$servic = {
    partapplyname: 'PartApply Code',
    servicename: 'Service Code',
    applytype: 'Apply Code',
    approvalstatus: 'Approval Status',
    From: ' From',
    To: ' To',
    Year: 'Year',
    Month: 'Month',

    startDate: 'StartDate code',
    endDate: 'EndDate code',
    noticeType: 'Notice Type',
    noticeTitle: 'Notice Title',
    noticeState: 'Notice State',

    PARTS: "Parts Management",
    PARTSAPPLY: "Parts Application",
    NEWORDER: "Parts Sales",
    PARTSSIGN: "Parts Receipt",
    SITERETURN: "Parts Return",
    PARTSRETURNLIST: "Old Parts Back to the Factory",
    SITEINV: "Parts Stock",
    PARTSTOCKTRANSACTION: "Parts Stocking Record",
    WORKORDER: "Service Management",
    AMOUNTADJUSTMENT: "Quota Adjustment",
    AMOUNTCHANGELOG: "Quota Adjustment Record",
    WORKORDERLIST: "Work Order",
    CLAIMFINE: "Bonus and Punishment",
    EXPENSECLAIM: "Expense Settlement",
    BASEDATA: "Basic Data",
    BASICDATA: "Service Station Profile",

    HasCancelledForDeleting: "Deletion Canceled",
    PleaseChooseAtLeastOne: "Please select an item at least!",
    ResetCanOnlySelectOne: "One item only!",
    PleaseInputRequiredFields: "Please enter the required fields!",
    PleaseChooseOneLine: "Please select an item!",
    PleaseChooseProvince: "Please select the province!",
    PleaseChooseCity: "Please select the city!",
    PleaseChoosePart: "Please select the part!",
    PleaseOneLine: "Please select an item!",
    PleaseChooseStationWarehouse: "Please select the warehouse!",
    ResetPassAndDeterminPass: "Password cannot be blank!",
    PassIsToLong: "The password is too long!",
    WhetherDeterminAndSendInvoice: "Confirmed and sent the invoice or not?",
    Tip: "Tips",
    HasCancelled: "Canceled",
    ThisPartLineHasExisted: "Existed Parts Details",
    PleaseSaveAndAdd: "Please save first and then add details!",
    NewOrderNotSaveSureQuit: "Data has not been saved! Are you sure to quit?",
    BeginNeedLessThanEnd: "The start time must be earlier than the end time!",
    CanNotDelete: "The submitted application cannot be deleted!",
    ThisActionDeletePerpetually: "Deleted data cannot be recovered, are you sure to continue?",
    EndNeedMoreThanBegin: "The end time must be later than the start time!",
    OnlyInt: "Integer is allowed only!",
    PleaseInputLessThan100000: "Please enter a number less than 100,000!",
    ModifySuccess: "Successfully modified!",
    RequiredIncludeOneLine: "A detailed item is necessary!",
    DeterminClose: "Close confirmation",
    PhoneFormatNotSuit: "Incorrect phone format! ",
    FreightAmountNeedInNormal: "Transportation costs must be in the normal range!",
    WhetherSendDetermin: "Confirm the delivery or not?",
    WhetherDeterminSign: "Receive or not?",
    ExistSameFile: "Please donot upload the same document!",
    FileIn10M: "Attachment must be less than 10M!",
    PleaseSave: "Please donot add details to submitted document!",
    NotSingleAndRejectCanNotAdd: "Please donot add details to submitted document!",
    NotSingleAndRejectCanNotDel: "Please donot delete details from submitted document!",
    NotSingleAndRejectCanNotModify: "Please donot modify details in submitted document!",
    PleaseInputBeginTime: "Please enter the departure time!",
    PleaseInputBeginPlace: "Please enter the departure address!",
    PleaseInputArriveTime: "Please enter the arrival time!",
    PleaseInputArrivePlace: "Please enter the arrival address!",
    PleaseUpLoadPicture: "Please upload photos!",
    PleaseInputFinishTime: "Please enter the completion time!",
    ExitNotRepeat: "Repeated Part!",
    PleaseChooseWorker: "Please choose a service person!",
    WhetherDispatchAuto: "Dispatch automatically or not?",
    SendLessThanBack: "The number of delivered parts cannot be larger than the returned!",
    SendLessThanZero: "The number of shipments should be more than 0",
    BackLessThan100000: "The number of returned parts cannot be larger than 100,000!",
    SendLessThan100000: "The number of delivered parts cannot be larger than 100,001!",
    SendLessThanCheck: "The number of delivered parts cannot be larger than the approved!",
    BackReasonLessThan100: "The length of deliver's address must be less than 100!",
    AddressLessThan100: "The length of return reason must be less than 101!",
    RequiredMoeThanOneLine: "At least one item of returned parts is required!",
    AppliedquantityREQUIRED: "Applied quantity is required!",
    DeliveryinformationREQUIRED: "Delivery information is required!",
    DocumentdetailREQUIRED: "Document detail is required!",
    ResetpasswordREQUIRED: "Reset password is required!",
    DeliveredquantityREQUIRED: "Delivered quantity is required!",
    ConfirmpasswordREQUIRED: "Confirm password is required!",
    NumberRequired: "Document number is required!",
    ProductRequired: "Product ID is required!",
    IDREQUIRED: "ID is required!",
    PartsDetailsIDREQUIRED: "Parts Details ID is required!",
    ServiceStaffIDREQUIRED: " Service Staff ID is required!",
    PartsIDREQUIRED: "Parts ID is required!",
    WarehouseIDREQUIRED: "Warehouse ID is required!",
    SoldquantityREQUIRED: "Sold quantity is required!",

    DcoumentInfoRequired: "Document information is required!",
    RetrieveInfoRequired: "Relative information could not be found!",
    ServiceStationRequired: "Service station is required!",
    ArticleNotFound: "This article coud not be found!",
    InfoNotFound: "Relative information could not be found!",
    ServiceStationNotFound: "This service station does not exist!",
    PleaseAddAndSave: "Please add details!",
    DoucmentNotBelongWareHouse: "Incorrect service station! Please check!",
    OnlySingleDetermin: "Confirmation is not allowed!",
    DocumentNotWarehouse: "Incorrect warehouse! Please check!",
    NotAchieveExportData: "No Imported data!",
    UserNotSetStation: "Please assign a service station to this user!",
    ThisStationQuotaNotEnough: "Insufficient quota!",
    ModifyNotAllowed: "Modification is not allowed for submitted document!",
    CountMoreThanZero: "Quantity should be larger than 0!",
    TheParamError: "Incorrect parameter!",
    UserNotSetDepart: "This user has no business unit!",
    UserNotSetPrincipal: "This business unit has no owner!",
    UserNotSetMechanism: "This owner has no organization!",
    SentStateRquired: "Delivery state must be Delivered or Partially Received!",
    Successfullyreceived: "Successfully received!",
    Successfullysent: "Successfully sent!",
    Successfullydeactivated: "Successfully deactivated!",
    Successfullydispatched: "Successfully dispatched!",
    Successfullyreassigned: "Successfully reassigned!",
    Successfullyadded: "Successfully added!",
    Successfullycreated: "Successfully created!",
    Successfullyresetted: "Successfully resetted!",
    Successfullydealt: "Successfully dealt!",
    Successfullysaved: "Successfully saved!"
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullycreated', "Successfully created!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullydeleted', "Successfully deleted!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullyconfirmed', "Successfully confirmed!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullydelivered', "Successfully delivered!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullyreceived', "Successfully received!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DocumentNotBelongStation', "Incorrect service station! Please check!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OnlyModifyNotAdd', "Modification only!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'PleaseChoose', "Please choose the year first!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BackCountMoreThanNotBackCount', "The number of parts back to factory could not be larger than the one to be back to factory!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MemoLessThan100', "The length of memo should not be longer than 100!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Insufficientquantity', "Insufficient quantity! Current quantity of parts to be back to factory is "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CanNotAdd', "Details could not be created!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'PleaseMaintainSysParam', "Please enter system parameter in CRM!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OnlyDispatch', "Dispatch is not allowed for this work order!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ThisStationNotExitWarehouse', "This service station has no warehouse!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'NotFoundUserStation', "This user has no service station!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BelongStationAddressNotFound', "This warehouse has no address!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'NotAchieveOutParam', "Export parameter could not be found!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OutParamNotExitAvailableQuota', "Export parameter has no available quota value!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Input', "Please input"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BaseInfo', "Basic Information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ReplaceDate', "Replaced Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BTFAmount', "Number of Parts Back to Factory"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TOBTFAmount', "Number of Parts to be Back to Factory"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CostOutRange', "Transportation costs must be in the normal range!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DeliveryConfirm', "Delivery Confirm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ResetPSW', "Password Reset"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'UserName', "User's name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OriginPSW', "Origin Password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'NewPSW', "New Password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ConfirmPSW', "Confirm Password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Upload', "Drop file here or click to upload"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ACT', "Action"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'COMMON', "Common Information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'SERVICE', "Service Information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Dispatch', "Dispatch Information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TotalCost', "Total Cost"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Inquery', "Inquery"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'InqueryCon', "Inquery Content"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ServiceAmountLess', "Service Amount Less Than"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TheCurrentAmount', "The Current Amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DeliveryDetail', "Delivery Detail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Amounts', "Amounts"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TotalAmounts', "Total Amounts"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CostMustBeInNormal', "Transportation costs must be in the normal range!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'AppliedQuantity', "Apply Quantity"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BranchStock', "Branch Stock"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DownLoad', "DownLoad"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ReplyContent', "Reply Content"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Province', "Province"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'City', "City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'County', "County"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Code', "Code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Address', "Address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DocumentDownload', "Document Download"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Address', "Address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MaintenanceProjectName', "Maintenance Project Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MaintenanceTimeDes', "Maintenance Time Description"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'LaborHourUnitPrice', "Unit Price"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultSys', "Fault System"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultPhen', "Fault Phenomenon"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultUnit', "Fault Unit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultPart', "Fault Part"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CustomerName', "Customer Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ProductModel', "Product Model"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ProductType', "Product Type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'PleaseDispatchFir', "Please Dispatch Firstly"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ApplyCountNotEmpty', "Apply cannot be Empty"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Supplier', "Supplier Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'All', "All"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Today', "Today"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Tomorrow', "Tomorrow"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MapLoad', "Map Loading..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ToBeAssigned', "To be assigned:"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'EnterName', "Please Enter Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ServiceCalendar', "Service Calendar"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CalenderLoading', "Calender Loading..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Warehouse', "Warehouse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'SiteInvNowQty', "SiteInvNowQty"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'SeeRealInv', "ShowRealInv"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OnlySeeNowInv', "OnlyShowInv"), _partapplyname$servic);

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _partapplyname$servic;

/* harmony default export */ __webpack_exports__["a"] = (_partapplyname$servic = {
  partapplyname: '配件申请单号',
  servicename: '服务单号',
  applytype: '申请类型',
  approvalstatus: '审批状态',
  From: ' 从',
  To: ' 到',
  Year: '年份',
  Month: '月份',

  startDate: '开始日期',
  endDate: '结束日期',
  noticeType: '公告类型',
  noticeTitle: '公告标题',
  noticeState: '阅读状态',

  PARTS: "配件管理",
  PARTSAPPLY: "配件申请单",
  NEWORDER: "配件销售单",
  PARTSSIGN: "配件签收单",
  SITERETURN: "配件退货单",
  PARTSRETURNLIST: "旧件返厂",
  SITEINV: "配件库存",
  PARTSTOCKTRANSACTION: "配件库存流水",
  WORKORDER: "服务管理",
  AMOUNTADJUSTMENT: "额度调整单",
  AMOUNTCHANGELOG: "额度调整流水",
  WORKORDERLIST: "服务单",
  CLAIMFINE: "结算奖惩单",
  EXPENSECLAIM: "费用结算单",
  BASEDATA: "基础数据",
  BASICDATA: "服务站档案",
  COMPLAINTS: "客户投诉",
  PREPROJECTSUPPORT: "项目售前支持",
  TICKETSUM: "经销商开票汇总",
  FWZ: "服务站",
  FWRY: "人员档案",
  ZHDA: "账号档案",

  HasCancelledForDeleting: "已取消消除",
  PleaseChooseAtLeastOne: "请至少选中一行",
  ResetCanOnlySelectOne: "重置密码只能选择一条数据",
  PleaseInputRequiredFields: "请输入必填项",
  PleaseChooseOneLine: "请选中一行数据",
  PleaseChooseProvince: "请先选择省份",
  PleaseChooseCity: "请先选择城市",
  PleaseChoosePart: "请选择配件",
  PleaseOneLine: "请选择一条明细",
  PleaseChooseStationWarehouse: "请选择仓库",
  ResetPassAndDeterminPass: "重置密码和确认密码皆不能为空",
  PassIsToLong: "密码长度过长",
  WhetherDeterminAndSendInvoice: "是否进行确认并寄送发票",
  Tip: "提示",
  HasCancelled: "已取消",
  ThisPartLineHasExisted: "该配件明细已存在",
  PleaseSaveAndAdd: "请先保存并添加明细",
  NewOrderNotSaveSureQuit: "新增单据尚未保存，是否确定退出",
  BeginNeedLessThanEnd: "开始时间必须小于等于结束时间",
  CanNotDelete: "无法删除非制单状态的申请单",
  ThisActionDeletePerpetually: "此操作将永久删除记录，是否继续",
  EndNeedMoreThanBegin: "结束时间必须大于等于开始时间",
  OnlyInt: "只能输入整数",
  PleaseInputLessThan100000: "请输入小于100000的数量",
  ModifySuccess: "修改成功",
  RequiredIncludeOneLine: "必须包含一条明细",
  DeterminClose: "确认关闭",
  PhoneFormatNotSuit: "电话格式不正确",
  FreightAmountNeedInNormal: "运费金额不能超正常范围",
  WhetherSendDetermin: "是否进行发运确认",
  WhetherDeterminSign: "是否确认签收",
  ExistSameFile: "存在同名文件，请勿重复上传",
  FileIn10M: "附件请控制在10M以内",
  PleaseSave: "请先保存主档",
  NotSingleAndRejectCanNotAdd: "非制单、驳回状态下不可以添加明细",
  NotSingleAndRejectCanNotDel: "非制单、驳回状态下不可以删除明细",
  NotSingleAndRejectCanNotModify: "非制单、驳回状态下不可以修改明细",
  PleaseInputBeginTime: "请填写出发时间",
  PleaseInputBeginPlace: "请填写出发地点",
  PleaseInputArriveTime: "请填写到位时间",
  PleaseInputArrivePlace: "请填写到位地点",
  PleaseUpLoadPicture: "请上传图片",
  PleaseInputFinishTime: "请填写完工时间",
  ExitNotRepeat: "所选配件已存在，请勿重复添加",
  PleaseChooseWorker: "请选择服务人员",
  WhetherDispatchAuto: "是否自动派工",
  SendLessThanBack: "发货数量不能大于退货数量",
  SendLessThanZero: "发货数量应大于0",
  BackLessThan100000: "退货数量不能大于100000",
  SendLessThan100000: "发货数量不能大于100000",
  SendLessThanCheck: "发货数量不能大于核准数量",
  BackReasonLessThan100: "退货原因长度需要小于100",
  AddressLessThan100: "收货人地址长度需要小于100",
  RequiredMoeThanOneLine: "必须包含一条以上的退货明细",
  AppliedquantityREQUIRED: "申请数量不能为空",
  DeliveryinformationREQUIRED: "发运不能为空",
  DocumentdetailREQUIRED: "明细不能为空",
  ResetpasswordREQUIRED: "重置密码不能为空",
  DeliveredquantityREQUIRED: "发运数量不能为空",
  ConfirmpasswordREQUIRED: "确认密码不能为空",
  NumberRequired: "单号不能为空！",
  ProductRequired: "产品ID不能为空",
  IDREQUIRED: "id不能为空！",
  PartsDetailsIDREQUIRED: "配件明细ID不能为空",
  ServiceStaffIDREQUIRED: "服务人员id为空",
  PartsIDREQUIRED: "配件ID不能为空！",
  WarehouseIDREQUIRED: "仓库标识丢失",
  SoldquantityREQUIRED: "销售数量不能为空！",

  DcoumentInfoRequired: "单据信息不能为空",
  RetrieveInfoRequired: "未获取到单据信息",
  ServiceStationRequired: "服务站信息不能为空",
  ArticleNotFound: "未找到当前文章",
  InfoNotFound: "查询信息不存在",
  ServiceStationNotFound: "当前服务站不存在",
  PleaseAddAndSave: "请添加明细",
  DoucmentNotBelongWareHouse: "当前单据不属于该服务站，请核实",
  OnlySingleDetermin: "只有制单状态的单据才可以进行确认",
  DocumentNotWarehouse: "单据仓库未分配，请核实",
  NotAchieveExportData: "未获得导入数据",
  UserNotSetStation: "当前用户未设置归属服务站",
  ThisStationQuotaNotEnough: "当前服务站额度不足，差额",
  ModifyNotAllowed: "只有制单状态下的配件申请单可以修改",
  CountMoreThanZero: "数量必须大于0",
  TheParamError: "调用的参数错误，无法认定区间起始",
  UserNotSetDepart: "当前用户暂未分配业务部门",
  UserNotSetPrincipal: "当前用户组织未分配负责人",
  UserNotSetMechanism: "当前用户组织负责人未分配归属机构",
  SentStateRquired: "发运状态必须为<已发运或部分签收>",
  Successfullyreceived: "签收成功",
  Successfullysent: "寄送成功",
  Successfullydeactivated: "停用成功",
  Successfullydispatched: "派工完成",
  Successfullyreassigned: "改派成功",
  Successfullyadded: "添加成功",
  Successfullycreated: "新建旧件明细成功！",
  Successfullyresetted: "重置成功",
  Successfullydealt: "处理成功",
  Successfullysaved: "保存成功",
  Successfullysubmit: "提交成功"
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullycreated', "新增成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullydeleted', "删除成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullyconfirmed', "确认成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullydelivered', "发运成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Successfullyreceived', "签收确认成功"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DocumentNotBelongStation', "该单据不属于当前服务站！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OnlyModifyNotAdd', "费用结算单只能修改不能新增！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'PleaseChoose', "请先选择年份"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BackCountMoreThanNotBackCount', "返厂数量不得大于待返厂数量，请重新查询获取！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MemoLessThan100', "备注字数不能超过100!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Insufficientquantity', "返厂数量不足,当前剩余返厂数量为"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CanNotAdd', "旧件返厂明细无法直接新增"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'PleaseMaintainSysParam', "请在CRM系统中维护系统参数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OnlyDispatch', "只有[未派工]、[已派工]或者[已派工且无法服务]的单据才可以派工！"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ThisStationNotExitWarehouse', "当前服务站不存在仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'NotFoundUserStation', "未查找到该用户负责的服务站"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BelongStationAddressNotFound', "所属仓库下不存在地址信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'NotAchieveOutParam', "未获取到输出参数"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OutParamNotExitAvailableQuota', "输出参数中不存在可用额度值"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Input', "请输入"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BaseInfo', "基本信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ReplaceDate', "更换日期"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BTFAmount', "已返厂数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TOBTFAmount', "待返厂数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CostOutRange', "运费金额不能超正常范围"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DeliveryConfirm', "发运确认"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ResetPSW', "修改密码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'UserName', "用户名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OriginPSW', "原密码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'NewPSW', "新密码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ConfirmPSW', "重复密码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Upload', "点击或拖动图片至此处"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ACT', "操作"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'COMMON', "常规"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'SERVICE', "服务内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Dispatch', "派工信息"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TotalCost', "费用合计"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Basic', '基本信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Customer', '客户信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Repair', '维修信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Inquery', "查询"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'InqueryCon', "查询内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ServiceAmountLess', "服务单量小于"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TheCurrentAmount', "当前服务单量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DeliveryDetail', "发运明细"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Amounts', "金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'TotalAmounts', "总金额"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CostMustBeInNormal', "运费金额不能超出正常范围"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'AppliedQuantity', "申请数量"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'BranchStock', "网点库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DownLoad', "下载"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ReplyContent', "回复内容"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Province', "省份"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'City', "城市"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'County', "县区"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Code', "编码"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Address', "地址"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'DocumentDownload', "资料下载"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MaintenanceProjectName', "维修项目名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MaintenanceTimeDes', "维修工时说明"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'LaborHourUnitPrice', "工时单价"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultSys', "故障系统"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultPhen', "故障现象"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultUnit', "故障部件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'FaultPart', "故障零件"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CustomerName', "客户名称"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ProductModel', "产品型号"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ProductType', "Product Type"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'PleaseDispatchFir', "请先进行派工"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ApplyCountNotEmpty', "申请数量不能为空"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Supplier', "供应商"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'All', "全部"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Today', "预约今日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Tomorrow', "预约明日"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'MapLoad', "正在加载地图..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ToBeAssigned', "待派数:"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'EnterName', "请输入姓名"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'ServiceCalendar', "服务日历"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'CalenderLoading', "正在加载日历..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'Warehouse', "仓库"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'SiteInvNowQty', "可用库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'SeeRealInv', "查看可用库存"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_partapplyname$servic, 'OnlySeeNowInv', "只看当前库存"), _partapplyname$servic);

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Main = function Main(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var PartApplyList = function PartApplyList(resolve) {
  return __webpack_require__.e/* require */(128).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(854)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartApplyEdit = function PartApplyEdit(resolve) {
  return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(853)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartApplyDetail = function PartApplyDetail(resolve) {
  return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(719)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var BasicDataEdit = function BasicDataEdit(resolve) {
  return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(771)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var NoticeList = function NoticeList(resolve) {
  return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(842)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NoticeView = function NoticeView(resolve) {
  return __webpack_require__.e/* require */(133).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(843)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var DatumList = function DatumList(resolve) {
  return __webpack_require__.e/* require */(212).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(792)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var kbarticleDetail = function kbarticleDetail(resolve) {
  return __webpack_require__.e/* require */(157).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(793)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var FlowRoleList = function FlowRoleList(resolve) {
  return __webpack_require__.e/* require */(207).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(818)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var FlowRoleEdit = function FlowRoleEdit(resolve) {
  return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(817)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var FlowRoleCreateDetail = function FlowRoleCreateDetail(resolve) {
  return __webpack_require__.e/* require */(208).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(816)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var FlowList = function FlowList(resolve) {
  return __webpack_require__.e/* require */(209).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var FlowCreateDetail = function FlowCreateDetail(resolve) {
  return __webpack_require__.e/* require */(210).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(813)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var FlowDetail = function FlowDetail(resolve) {
  return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(814)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var PartsDispatchList = function PartsDispatchList(resolve) {
  return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(860)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartsDispatchEdit = function PartsDispatchEdit(resolve) {
  return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(859)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartsDispatchDetail = function PartsDispatchDetail(resolve) {
  return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(858)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var PartsSignList = function PartsSignList(resolve) {
  return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(864)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartsSignEdit = function PartsSignEdit(resolve) {
  return __webpack_require__.e/* require */(202).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(863)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var NewOrderList = function NewOrderList(resolve) {
  return __webpack_require__.e/* require */(138).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(836)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewOrderEdit = function NewOrderEdit(resolve) {
  return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(835)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewOrderDetail = function NewOrderDetail(resolve) {
  return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(718)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var SiteReturnList = function SiteReturnList(resolve) {
  return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(911)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SiteReturnEdit = function SiteReturnEdit(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(910)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var PartsReturnList = function PartsReturnList(resolve) {
  return __webpack_require__.e/* require */(125).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(862)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartsReturnEdit = function PartsReturnEdit(resolve) {
  return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(861)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var AmountAdjustList = function AmountAdjustList(resolve) {
  return __webpack_require__.e/* require */(177).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(764)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AmountAdjustEdit = function AmountAdjustEdit(resolve) {
  return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(763)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var ExpenseClaimList = function ExpenseClaimList(resolve) {
  return __webpack_require__.e/* require */(149).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(809)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ExpenseClaimEdit = function ExpenseClaimEdit(resolve) {
  return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(808)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var WorkorderList = function WorkorderList(resolve) {
  return __webpack_require__.e/* require */(196).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(903)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var WorkorderEdit = function WorkorderEdit(resolve) {
  return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(902)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var WorkorderAssign = function WorkorderAssign(resolve) {
  return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(901)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var claimFineList = function claimFineList(resolve) {
  return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(775)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var claimFineDetail = function claimFineDetail(resolve) {
  return __webpack_require__.e/* require */(214).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(774)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var AmountChangeLog = function AmountChangeLog(resolve) {
  return __webpack_require__.e/* require */(176).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(765)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AmountChangeLogLine = function AmountChangeLogLine(resolve) {
  return __webpack_require__.e/* require */(215).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(766)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var SiteInvlist = function SiteInvlist(resolve) {
  return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(908)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SiteInvLine = function SiteInvLine(resolve) {
  return __webpack_require__.e/* require */(194).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(909)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var partStockTransactionlist = function partStockTransactionlist(resolve) {
  return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(851)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var partStockTransactionline = function partStockTransactionline(resolve) {
  return __webpack_require__.e/* require */(203).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(852)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var projectcreditList = function projectcreditList(resolve) {
  return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(880)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var projectcreditEdit = function projectcreditEdit(resolve) {
  return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(879)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var PartsBorrowList = function PartsBorrowList(resolve) {
  return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(857)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartsBorrowEdit = function PartsBorrowEdit(resolve) {
  return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(856)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var PartsBorrowDetail = function PartsBorrowDetail(resolve) {
  return __webpack_require__.e/* require */(127).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(855)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var LeadList = function LeadList(resolve) {
  return __webpack_require__.e/* require */(141).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(829)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var leadCreateOrEdit = function leadCreateOrEdit(resolve) {
  return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(828)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var LeadReginsterList = function LeadReginsterList(resolve) {
  return __webpack_require__.e/* require */(142).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(827)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var LeadReginsterEdit = function LeadReginsterEdit(resolve) {
  return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(826)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var pageFind = function pageFind(resolve) {
  return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(917)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var edit = function edit(resolve) {
  return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(916)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var exhibitionSupport = function exhibitionSupport(resolve) {
  return __webpack_require__.e/* require */(151).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(805)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var exedit = function exedit(resolve) {
  return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(804)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var preprojectsupportList = function preprojectsupportList(resolve) {
  return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(919)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var preprojectsupportEdit = function preprojectsupportEdit(resolve) {
  return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(918)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var OpportunityList = function OpportunityList(resolve) {
  return __webpack_require__.e/* require */(132).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(845)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OpportunityEdit = function OpportunityEdit(resolve) {
  return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(844)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var schemetypeEdit = function schemetypeEdit(resolve) {
  return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(846)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var ShipmentList = function ShipmentList(resolve) {
  return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(907)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ShipmentEdit = function ShipmentEdit(resolve) {
  return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(906)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ShipmentLineEdit = function ShipmentLineEdit(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ShipmentLineCreate = function ShipmentLineCreate(resolve) {
  return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var ContactList = function ContactList(resolve) {
  return __webpack_require__.e/* require */(170).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(715)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ContactEdit = function ContactEdit(resolve) {
  return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(776)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var nonstandardauditList = function nonstandardauditList(resolve) {
  return __webpack_require__.e/* require */(137).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(838)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var nonstandardauditEdit = function nonstandardauditEdit(resolve) {
  return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(837)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var nonstandardauditNewEdit = function nonstandardauditNewEdit(resolve) {
  return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(839)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var nonstandardauditPrint = function nonstandardauditPrint(resolve) {
  return __webpack_require__.e/* require */(136).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(840)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var nonstandardSoftwareList = function nonstandardSoftwareList(resolve) {
  return __webpack_require__.e/* require */(135).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(841)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var OrderorShipmentList = function OrderorShipmentList(resolve) {
  return __webpack_require__.e/* require */(191).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(731)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OrderorShipmentEdit = function OrderorShipmentEdit(resolve) {
  return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var OrderorEdit = function OrderorEdit(resolve) {
  return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var shipmentEdit = function shipmentEdit(resolve) {
  return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(732)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var productD1List = function productD1List(resolve) {
  return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(878)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var productD1Edit = function productD1Edit(resolve) {
  return __webpack_require__.e/* require */(198).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(877)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var applicationList = function applicationList(resolve) {
  return __webpack_require__.e/* require */(174).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(769)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var applicationEdit = function applicationEdit(resolve) {
  return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(768)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var applicationEditDetail = function applicationEditDetail(resolve) {
  return __webpack_require__.e/* require */(175).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(767)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var deliverynoteList = function deliverynoteList(resolve) {
  return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(819)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invoiceEdit = function invoiceEdit(resolve) {
  return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invoiceApplicationList = function invoiceApplicationList(resolve) {
  return __webpack_require__.e/* require */(146).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(822)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var deliverynotelineList = function deliverynotelineList(resolve) {
  return __webpack_require__.e/* require */(147).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(820)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invoiceDeliveryList = function invoiceDeliveryList(resolve) {
  return __webpack_require__.e/* require */(143).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(825)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invoiceDealerList = function invoiceDealerList(resolve) {
  return __webpack_require__.e/* require */(144).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(824)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var invoiceDealerDetailListView = function invoiceDealerDetailListView(resolve) {
  return __webpack_require__.e/* require */(145).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(823)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var maintenceorderList = function maintenceorderList(resolve) {
  return __webpack_require__.e/* require */(140).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(833)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var maintenceorderEdit = function maintenceorderEdit(resolve) {
  return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(830)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var maintenceorderitemEdit = function maintenceorderitemEdit(resolve) {
  return __webpack_require__.e/* require */(206).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(831)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var maintenceorderlineView = function maintenceorderlineView(resolve) {
  return __webpack_require__.e/* require */(205).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(832)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var QueryList = function QueryList(resolve) {
  return __webpack_require__.e/* require */(139).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(834)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var qualityList = function qualityList(resolve) {
  return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(888)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var qualityEdit = function qualityEdit(resolve) {
  return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(887)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var complaintsList = function complaintsList(resolve) {
  return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(900)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var complaintsEdit = function complaintsEdit(resolve) {
  return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(899)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var ticketsumList = function ticketsumList(resolve) {
  return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(922)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ticketsumEdit = function ticketsumEdit(resolve) {
  return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(921)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ticketsumDetails = function ticketsumDetails(resolve) {
  return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(920)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var receptionList = function receptionList(resolve) {
  return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(893)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var receptionEdit = function receptionEdit(resolve) {
  return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(891)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var receptionLineEdit = function receptionLineEdit(resolve) {
  return __webpack_require__.e/* require */(197).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(892)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var applymaintainorderList = function applymaintainorderList(resolve) {
  return __webpack_require__.e/* require */(129).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(849)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var applymaintainorderEdit = function applymaintainorderEdit(resolve) {
  return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(848)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var maintainMaterialChose = function maintainMaterialChose(resolve) {
  return __webpack_require__.e/* require */(130).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(847)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var maintainMakeOrderEdit = function maintainMakeOrderEdit(resolve) {
  return __webpack_require__.e/* require */(204).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(850)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var applyserviceList = function applyserviceList(resolve) {
  return __webpack_require__.e/* require */(172).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(714)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var afterServiceList = function afterServiceList(resolve) {
  return __webpack_require__.e/* require */(173).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var applyserviceEdit = function applyserviceEdit(resolve) {
  return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(770)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var crossprojectitemList = function crossprojectitemList(resolve) {
  return __webpack_require__.e/* require */(158).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var crossprojectitemEdit = function crossprojectitemEdit(resolve) {
  return __webpack_require__.e/* require */(161).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(789)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var feedetailEdit = function feedetailEdit(resolve) {
  return __webpack_require__.e/* require */(160).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(790)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var clientprojectEdit = function clientprojectEdit(resolve) {
  return __webpack_require__.e/* require */(166).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(782)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var changeEdit = function changeEdit(resolve) {
  return __webpack_require__.e/* require */(162).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(786)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var feecountEdit = function feecountEdit(resolve) {
  return __webpack_require__.e/* require */(164).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(784)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var checkreceiveEdit = function checkreceiveEdit(resolve) {
  return __webpack_require__.e/* require */(167).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var deliverEdit = function deliverEdit(resolve) {
  return __webpack_require__.e/* require */(165).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(783)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var settleEdit = function settleEdit(resolve) {
  return __webpack_require__.e/* require */(163).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(785)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var handoverEdit = function handoverEdit(resolve) {
  return __webpack_require__.e/* require */(159).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(791)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var cooperationApplicationList = function cooperationApplicationList(resolve) {
  return __webpack_require__.e/* require */(213).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(788)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var cooperationApplicationEdit = function cooperationApplicationEdit(resolve) {
  return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(787)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var SalesmanList = function SalesmanList(resolve) {
  return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(896)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SalesmanView = function SalesmanView(resolve) {
  return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(895)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SalesmanEdit = function SalesmanEdit(resolve) {
  return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(894)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var accountList = function accountList(resolve) {
  return __webpack_require__.e/* require */(186).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(745)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var accountEdit = function accountEdit(resolve) {
  return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(744)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var accountSearch = function accountSearch(resolve) {
  return __webpack_require__.e/* require */(217).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(709)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var achievementapplyList = function achievementapplyList(resolve) {
  return __webpack_require__.e/* require */(179).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(760)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var achievementapplyEdit = function achievementapplyEdit(resolve) {
  return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(759)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var projectsupportlineEdit = function projectsupportlineEdit(resolve) {
  return __webpack_require__.e/* require */(216).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(761)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var paymentapplyList = function paymentapplyList(resolve) {
  return __webpack_require__.e/* require */(119).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(874)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var paymentapplyEdit = function paymentapplyEdit(resolve) {
  return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(870)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var servicecostEdit = function servicecostEdit(resolve) {
  return __webpack_require__.e/* require */(200).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(872)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var technicalcostEdit = function technicalcostEdit(resolve) {
  return __webpack_require__.e/* require */(199).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(873)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var pointcostEdit = function pointcostEdit(resolve) {
  return __webpack_require__.e/* require */(201).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(871)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var dealerCharge = function dealerCharge(resolve) {
  return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(796)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var dealerLetter = function dealerLetter(resolve) {
  return __webpack_require__.e/* require */(155).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(797)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var projectsupportbox = function projectsupportbox(resolve) {
  return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(885)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var technicalSupportList = function technicalSupportList(resolve) {
  return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var technicalSupportDetails = function technicalSupportDetails(resolve) {
  return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(915)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var projectsupportList = function projectsupportList(resolve) {
  return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(708)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var projectsupportEdit = function projectsupportEdit(resolve) {
  return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(884)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var details = function details(resolve) {
  return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(883)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var noprojectsupportList = function noprojectsupportList(resolve) {
  return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var noprojectsupportEdit = function noprojectsupportEdit(resolve) {
  return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(882)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var nodetails = function nodetails(resolve) {
  return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(881)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var expachievementapplytList = function expachievementapplytList(resolve) {
  return __webpack_require__.e/* require */(150).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(807)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var expachievementapplytEdit = function expachievementapplytEdit(resolve) {
  return __webpack_require__.e/* require */(211).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(806)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var servicesupportList = function servicesupportList(resolve) {
  return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(905)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var servicesupportEdit = function servicesupportEdit(resolve) {
  return __webpack_require__.e/* require */(195).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(904)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var standardorderlist = function standardorderlist(resolve) {
  return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(913)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var standardorderedit = function standardorderedit(resolve) {
  return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(912)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var standardorderdetails = function standardorderdetails(resolve) {
  return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(914)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var partsorderlist = function partsorderlist(resolve) {
  return __webpack_require__.e/* require */(121).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(867)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var partsorderedit = function partsorderedit(resolve) {
  return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(866)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var partsorderdetails = function partsorderdetails(resolve) {
  return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(865)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var businessmessagelist = function businessmessagelist(resolve) {
  return __webpack_require__.e/* require */(192).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(728)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var businessmessageedit = function businessmessageedit(resolve) {
  return __webpack_require__.e/* require */(218).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(727)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var OrderStandardQueryList = function OrderStandardQueryList(resolve) {
  return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(869)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var OrderStatusQuery = function OrderStatusQuery(resolve) {
  return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(868)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var dealerorderList = function dealerorderList(resolve) {
  return __webpack_require__.e/* require */(152).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(802)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerorderEdit = function dealerorderEdit(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(801)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerorderCertification = function dealerorderCertification(resolve) {
  return __webpack_require__.e/* require */(153).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(800)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerorderPreAudit = function dealerorderPreAudit(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(803)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var accountprojectEdit = function accountprojectEdit(resolve) {
  return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(756)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var accountprojectEquipmentReceive = function accountprojectEquipmentReceive(resolve) {
  return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(757)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var accountprojectList = function accountprojectList(resolve) {
  return __webpack_require__.e/* require */(180).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(758)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var pjtItemList = function pjtItemList(resolve) {
  return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(875)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var pjtItemView = function pjtItemView(resolve) {
  return __webpack_require__.e/* require */(117).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(876)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var creditInfoList = function creditInfoList(resolve) {
  return __webpack_require__.e/* require */(168).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(780)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var creditApply = function creditApply(resolve) {
  return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(779)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var dealerBillList = function dealerBillList(resolve) {
  return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(799)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerBillDetails = function dealerBillDetails(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerBillDelay = function dealerBillDelay(resolve) {
  return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(798)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerBillPreview = function dealerBillPreview(resolve) {
  return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var dealerBillDelayList = function dealerBillDelayList(resolve) {
  return __webpack_require__.e/* require */(154).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(717)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var quoteProductDetails = function quoteProductDetails(resolve) {
  return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(889)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var quoteProductList = function quoteProductList(resolve) {
  return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(890)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var AccountInfoAccount = function AccountInfoAccount(resolve) {
  return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoBillDetail = function AccountInfoBillDetail(resolve) {
  return __webpack_require__.e/* require */(183).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(710)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoTransAccount = function AccountInfoTransAccount(resolve) {
  return __webpack_require__.e/* require */(181).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoCashDepositAccount = function AccountInfoCashDepositAccount(resolve) {
  return __webpack_require__.e/* require */(182).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoYearCreditAccount = function AccountInfoYearCreditAccount(resolve) {
  return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(755)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoTempCreditAccount = function AccountInfoTempCreditAccount(resolve) {
  return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(754)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoPersonalGuaranteeAccount = function AccountInfoPersonalGuaranteeAccount(resolve) {
  return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(753)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoDedicatedAccount = function AccountInfoDedicatedAccount(resolve) {
  return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(752)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoComplexCreditAccount = function AccountInfoComplexCreditAccount(resolve) {
  return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoAccountRecharge = function AccountInfoAccountRecharge(resolve) {
  return __webpack_require__.e/* require */(184).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(748)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoAccountRepayment = function AccountInfoAccountRepayment(resolve) {
  return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(749)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoAccountPayment = function AccountInfoAccountPayment(resolve) {
  return __webpack_require__.e/* require */(185).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(747)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AccountInfoAccountRepaymentCredit = function AccountInfoAccountRepaymentCredit(resolve) {
  return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(750)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var CheckBillDealerCheckBill = function CheckBillDealerCheckBill(resolve) {
  return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(773)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var billDetails = function billDetails(resolve) {
  return __webpack_require__.e/* require */(171).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(772)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var AccountProperty = function AccountProperty(resolve) {
  return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var comeAndGo = function comeAndGo(resolve) {
  return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var creditExtension = function creditExtension(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var cashDeposit = function cashDeposit(resolve) {
  return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var shipmentAccount = function shipmentAccount(resolve) {
  return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var shipmentAccountPayDetail = function shipmentAccountPayDetail(resolve) {
  return __webpack_require__.e/* require */(189).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var shipmentAccountShipmentDetail = function shipmentAccountShipmentDetail(resolve) {
  return __webpack_require__.e/* require */(188).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(741)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var shipmentAccountUnshipmentDetail = function shipmentAccountUnshipmentDetail(resolve) {
  return __webpack_require__.e/* require */(187).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(742)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var dealerMonthBillDetail = function dealerMonthBillDetail(resolve) {
  return __webpack_require__.e/* require */(190).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var refundCashierDesk = function refundCashierDesk(resolve) {
  return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var voucherCenter = function voucherCenter(resolve) {
  return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(743)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var serviceOrderForm = function serviceOrderForm(resolve) {
  return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(898)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var afterSaleServiceEdit = function afterSaleServiceEdit(resolve) {
  return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(897)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var purchaseOrderForm = function purchaseOrderForm(resolve) {
  return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(886)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var appliedHistory = function appliedHistory(resolve) {
  return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(795)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var appliedShareProfit = function appliedShareProfit(resolve) {
  return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(811)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var appliedEdit = function appliedEdit(resolve) {
  return __webpack_require__.e/* require */(156).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(794)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var addressBook = function addressBook(resolve) {
  return __webpack_require__.e/* require */(178).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(762)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var fenrunqingkuan = function fenrunqingkuan(resolve) {
  return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(812)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var appliedChoose = function appliedChoose(resolve) {
  return __webpack_require__.e/* require */(148).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(810)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var Contract = function Contract(resolve) {
  return __webpack_require__.e/* require */(169).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(778)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ContractDetail = function ContractDetail(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(777)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/salesman',
  component: Main,
  children: [{
    path: 'list',
    name: 'SalesmanList',
    component: SalesmanList
  }, {
    path: 'Edit/:id',
    name: 'SalesmanEdit',
    component: SalesmanEdit
  }, {
    path: 'view',
    name: 'SalesmanView',
    component: SalesmanView
  }]
}, {
  path: "/flow",
  component: Main,
  children: [{
    path: "role",
    name: "FlowRoleList",
    component: FlowRoleList
  }, {
    path: "createRoleDetail",
    name: "FlowRoleCreateDetail",
    component: FlowRoleCreateDetail
  }, {
    path: "list",
    name: "FlowList",
    component: FlowList
  }, {
    path: "createDetail",
    name: "FlowCreateDetail",
    component: FlowCreateDetail
  }, {
    path: "roleedit/:id",
    name: "FlowRoleEdit",
    component: FlowRoleEdit
  }, {
    path: "edit/:id",
    name: "FlowDetail",
    component: FlowDetail
  }]
}, {
  path: '/workorder',
  component: Main,
  children: [{
    path: 'list',
    name: 'workorderlist',
    meta: {
      keepAlive: true },
    component: WorkorderList
  }, {
    path: 'create/',
    name: 'workordercreate',
    component: WorkorderEdit
  }, {
    path: 'edit/:id',
    name: 'workorderedit',
    component: WorkorderEdit
  }, {
    path: 'mapassign',
    name: 'mapassign',
    component: WorkorderAssign
  }]
}, {
  path: '/claimFine',
  component: Main,
  children: [{
    path: 'list',
    name: 'claimfine',
    component: claimFineList
  }, {
    path: 'detail/:id',
    name: 'claimfinedetail',
    component: claimFineDetail
  }]
}, {
  path: '/partsApply',
  component: Main,
  children: [{
    path: 'list',
    name: 'partlist',
    component: PartApplyList
  }, {
    path: 'create/',
    name: 'partcreate',
    component: PartApplyEdit
  }, {
    path: 'edit/:id',
    name: 'partedit',
    component: PartApplyEdit
  }]
}, {
  path: "/projectcredit",
  component: Main,
  children: [{
    path: "list",
    name: "projectcreditList",
    component: projectcreditList
  }, {
    path: "edit/:id",
    name: "projectcreditEdit",
    component: projectcreditEdit
  }, {
    path: "create",
    name: "projectcreditCreate",
    component: projectcreditEdit
  }]
}, {
  path: "/partsBorrow",
  component: Main,
  children: [{
    path: "list",
    name: "partsBorrowList",
    component: PartsBorrowList
  }, {
    path: "create",
    name: "partsBorrowcreate",
    component: PartsBorrowEdit
  }, {
    path: "edit/:id",
    name: "partsBorrowedit",
    component: PartsBorrowEdit
  }, {
    path: 'detailcreate/:id/:name/:type',
    name: 'partsBorrowdetailcreate',
    component: PartsBorrowDetail
  }, {
    path: 'detailedit/:id/:type/:istrue',
    name: 'partsBorrowdetailedit',
    component: PartsBorrowDetail
  }]
}, {
  path: '/partsSign',
  component: Main,
  children: [{
    path: 'list',
    name: 'partssignlist',
    component: PartsSignList
  }, {
    path: 'edit/:id',
    name: 'partssignedit',
    component: PartsSignEdit
  }]
}, {
  path: '/siteInv',
  component: Main,
  children: [{
    path: 'list',
    name: 'siteInvlist',
    component: SiteInvlist
  }, {
    path: 'line/:row',
    name: 'siteInvLine',
    component: SiteInvLine
  }]

}, {
  path: '/partStockTransaction',
  component: Main,
  children: [{
    path: 'list',
    name: 'partStockTransactionlist',
    component: partStockTransactionlist
  }, {
    path: 'line/:row',
    name: 'partStockTransactionline',
    component: partStockTransactionline
  }]
}, {
  path: '/newOrder',
  component: Main,
  children: [{
    path: 'list/',
    name: 'neworderlist',
    component: NewOrderList
  }, {
    path: 'edit/:id',
    name: 'neworderedit',
    component: NewOrderEdit
  }, {
    path: 'edit/',
    name: 'newordercreate',
    component: NewOrderEdit
  }]
}, {
  path: '/siteReturn',
  component: Main,
  children: [{
    path: 'list/',
    name: 'sitereturnlist',
    component: SiteReturnList
  }, {
    path: 'edit/:id',
    name: 'sitereturnedit',
    component: SiteReturnEdit
  }, {
    path: 'edit/',
    name: 'sitereturncreate',
    component: SiteReturnEdit
  }]
}, {
  path: '/basicData',
  component: Main,
  children: [{
    path: 'edit/',
    name: 'basiclist',
    component: BasicDataEdit
  }]
}, {
  path: '/partsDispatch',
  component: Main,
  children: [{
    path: 'list',
    name: 'dispatchlist',
    component: PartsDispatchList
  }, {
    path: 'create/',
    name: 'dispatchcreate',
    component: PartsDispatchEdit
  }, {
    path: 'edit/:id',
    name: 'dispatchedit',
    component: PartsDispatchEdit
  }, {
    path: 'detailcreate/:id',
    name: 'dispatchdetailcreate',
    component: PartsDispatchDetail
  }, {
    path: 'detailedit/:id',
    name: 'dispatchdetailedit',
    meta: {
      keepAlive: true
    },
    component: PartsDispatchDetail
  }]
}, {
  path: "/partsReturn",
  component: Main,
  children: [{
    path: "list",
    name: "PartsReturnList",
    component: PartsReturnList
  }, {
    path: "edit/:id",
    name: "PartsReturnEdit",
    component: PartsReturnEdit
  }, {
    path: "create/",
    name: "PartsReturnCreate",
    component: PartsReturnEdit
  }]
}, {
  path: "/amountAdjust",
  component: Main,
  children: [{
    path: "list",
    name: "AmountAdjustList",
    component: AmountAdjustList
  }, {
    path: "create/",
    name: "AmountAdjustCreate",
    component: AmountAdjustEdit
  }, {
    path: "edit/:id",
    name: "AmountAdjustEdit",
    component: AmountAdjustEdit
  }]
}, {
  path: "/amountChangeLog",
  component: Main,
  children: [{
    path: "list",
    name: "AmountChangeLog",
    component: AmountChangeLog
  }, {
    path: "Line/:row",
    name: "AmountChangeLogLine",
    component: AmountChangeLogLine
  }]
}, {
  path: "/expenseClaim",
  component: Main,
  children: [{
    path: "list",
    name: "ExpenseClaimList",
    component: ExpenseClaimList
  }, {
    path: "edit/:id",
    name: "ExpenseClaimEdit",
    component: ExpenseClaimEdit
  }]

}, {
  path: "/notice",
  component: Main,
  children: [{
    path: "list",
    name: "NoticeList",
    component: NoticeList
  }, {
    path: "view/:id",
    name: "NoticeView",
    component: NoticeView
  }]
}, {
  path: "/file",
  component: Main,
  children: [{
    path: "list",
    name: "DatumList",
    component: DatumList
  }, {
    path: "view/:id",
    name: "kbarticleDetail",
    component: kbarticleDetail
  }]
}, {
  path: "/lead",
  component: Main,
  children: [{
    path: "list",
    name: "LeadList",
    component: LeadList
  }, {
    path: "create",
    name: "leadCreate",
    component: leadCreateOrEdit
  }, {
    path: "edit/:id",
    name: "leadEdit",
    component: leadCreateOrEdit
  }, {
    path: "createFromLeadReginster/:leadReginsterId",
    name: "createFromLeadReginster",
    component: leadCreateOrEdit
  }]
}, {
  path: "/leadReginster",
  component: Main,
  children: [{
    path: "list",
    name: "LeadReginsterList",
    component: LeadReginsterList
  }, {
    path: "edit/:id",
    name: "LeadReginsterEdit",
    component: LeadReginsterEdit
  }]
}, {
  path: '/expatriate',
  component: Main,
  children: [{
    path: "list",
    name: "pageFind",
    component: pageFind
  }, {
    path: "edit/:id",
    name: "edit",
    component: edit
  }, {
    path: "create",
    name: "expatriateCreate",
    component: edit
  }, {
    path: "edit/:id/:type",
    name: "expatriateEdit",
    component: edit
  }]
}, {
  path: '/exhibitionsupport',
  component: Main,
  children: [{
    path: "list",
    name: "exhibitionSupport",
    component: exhibitionSupport
  }, {
    path: "exeditcreate",
    name: "exedit",
    component: exedit
  }, {
    path: "edit/:id",
    name: "exhibitionSupportEdit",
    component: exedit
  }]
}, {
  path: '/contact',
  component: Main,
  children: [{
    path: 'list',
    name: 'ContactList',
    component: ContactList
  }, {
    path: "create/:val",
    name: "ContactCreate",
    component: ContactEdit
  }, {
    path: "edit/:id",
    name: "ContactEdit",
    component: ContactEdit
  }]
}, {
  path: '/OrderorShipment',
  component: Main,
  children: [{
    path: 'list',
    name: 'OrderorShipmentList',
    component: OrderorShipmentList
  }, {
    path: "OrderorShipmenteditcreate",
    name: "OrderorShipmentCreate",
    component: OrderorShipmentEdit
  }, {
    path: "OrderorShipmentedit/:id",
    name: "OrderorShipmentEdit",
    component: OrderorShipmentEdit
  }, {
    path: "Ordercreate/:id/:type/:name",
    name: "OrderCreate",
    component: OrderorEdit
  }, {
    path: "Orderedit/:id/:type",
    name: "OrderEdit",
    component: OrderorEdit
  }, {
    path: "Shipmentcreate/:id/:type/:name",
    name: "ShipmentCreate",
    component: shipmentEdit
  }, {
    path: "Shipmentedit/:id/:type",
    name: "ShipmentEdit",
    component: shipmentEdit
  }]
}, {
  path: '/opportunity',
  component: Main,
  children: [{
    path: 'list',
    name: 'opportunityList',
    component: OpportunityList
  }, {
    path: 'edit/:id',
    name: 'OpportunityEdit',
    component: OpportunityEdit
  }, {
    path: 'schemetypeCreate/:id/:name',
    name: 'schemetypeCreate',
    component: schemetypeEdit
  }, {
    path: 'schemetypeEdit/:schemetypeid/:status',
    name: 'schemetypeEdit',
    component: schemetypeEdit
  }]
}, {
  path: '/shipment',
  component: Main,
  children: [{
    path: 'list',
    name: 'shipmentList',
    component: ShipmentList
  }, {
    path: 'edit/:id',
    name: 'shipmentEdit',
    component: ShipmentEdit
  }, {
    path: 'create',
    name: 'shipmentCreate',
    component: ShipmentEdit
  }, {
    path: 'shipmentLineEdit/:lineid/:edittype/:istrue',
    name: 'shipmentLineEdit',
    component: ShipmentLineEdit
  }, {
    path: 'shipmentLineCreate/:shipmentid/:shipmentname/:type/:ordername/:orderid/:value',
    name: 'shipmentLineCreate',
    component: ShipmentLineCreate,
    meta: { keepAlive: false }
  }]
}, {
  path: 'shipmentLine',
  component: Main,
  children: [{
    path: 'edit/:id',
    name: 'shipmentLineEdit',
    component: ShipmentLineEdit
  }]
}, {
  path: "/nonstandardaudit",
  component: Main,
  children: [{
    path: "list",
    name: "nonstandardauditList",
    component: nonstandardauditList,
    meta: {
      keepAlive: true }
  }, {
    path: "edit/:id",
    name: "nonstandardauditEdit",
    component: nonstandardauditEdit
  }, {
    path: "create",
    name: "nonstandardauditCreate",
    component: nonstandardauditEdit
  }, {
    path: "newCreate",
    name: "nonstandardauditNewCreate",
    component: nonstandardauditNewEdit
  }, {
    path: "newEdit/:id",
    name: "nonstandardauditNewEdit",
    component: nonstandardauditNewEdit
  }, {
    path: "print/:id",
    name: "nonstandardauditPrint",
    component: nonstandardauditPrint
  }, {
    path: "software",
    name: "nonstandardSoftwareList",
    component: nonstandardSoftwareList,
    meta: {
      keepAlive: false
    }
  }]
}, {
  path: '/productD1',
  component: Main,
  children: [{
    path: 'list',
    name: 'productD1List',
    component: productD1List
  }, {
    path: "productList",
    name: "quoteProductList",
    component: quoteProductList
  }, {
    path: 'edit/:id',
    name: 'productD1Edit',
    component: productD1Edit
  }]
}, {
  path: '/application',
  component: Main,
  children: [{
    path: 'list',
    name: 'applicationList',
    component: applicationList
  }, {
    path: "create/",
    name: "applicationCreate",
    component: applicationEdit
  }, {
    path: "edit/:id",
    name: "applicationEdit",
    component: applicationEdit
  }]
}, {
  path: '/invoice',
  component: Main,
  children: [{
    path: 'deliverynoteList',
    name: 'deliverynoteList',
    component: deliverynoteList
  }, {
    path: "create",
    name: "invoiceCreate",
    component: invoiceEdit
  }, {
    path: "edit/:id/:type",
    name: "invoiceEdit",
    component: invoiceEdit
  }, {
    path: "invoiceApplicationList",
    name: "invoiceApplicationList",
    component: invoiceApplicationList
  }, {
    path: "deliverynotelineList/:id",
    name: "deliverynotelineList",
    component: deliverynotelineList
  }, {
    path: "invoiceDeliveryList",
    name: "invoiceDeliveryList",
    component: invoiceDeliveryList
  }, {
    path: "invoiceDealerList",
    name: "invoiceDealerList",
    component: invoiceDealerList
  }, {
    path: "invoiceDealerDetailListView/:invoiceMonth/:type",
    name: "invoiceDealerDetailListView",
    component: invoiceDealerDetailListView
  }]
}, {
  path: '/applicationdetail',
  component: Main,
  children: [{
    path: "create/:id/:name/:type",
    name: "CreateapplicationDetail",
    component: applicationEditDetail
  }, {
    path: "edit/:id/:type/:istrue",
    name: "EditapplicationDetail",
    component: applicationEditDetail
  }]
}, {
  path: "/maintenceorder",
  component: Main,
  children: [{
    path: "list",
    name: "maintenceorderList",
    component: maintenceorderList
  }, {
    path: "edit/:id",
    name: "maintenceorderEdit",
    component: maintenceorderEdit
  }, {
    path: "create",
    name: "maintenceorderCreate",
    component: maintenceorderEdit
  }, {
    path: "editItem/:id/:type/:istrue",
    name: "maintenceorderitemEdit",
    component: maintenceorderitemEdit
  }, {
    path: "createItem/:id/:name/:type",
    name: "maintenceorderitemCreate",
    component: maintenceorderitemEdit
  }, {
    path: "viewLine/:id",
    name: "maintenceorderlineView",
    component: maintenceorderlineView
  }]
}, {
  path: "/maintenceorderquerylist",
  component: Main,
  children: [{
    path: "list",
    name: "QueryList",
    component: QueryList
  }]
}, {
  path: '/quality',
  component: Main,
  children: [{
    path: "list",
    name: "qualityList",
    component: qualityList
  }, {
    path: "edit/:id",
    name: "qualityEdit",
    component: qualityEdit
  }, {
    path: "create",
    name: "qualitycreate",
    component: qualityEdit
  }]
}, {
  path: '/complaints',
  component: Main,
  children: [{
    path: "list",
    name: "complaintsList",
    component: complaintsList,
    meta: {
      keepAlive: true }
  }, {
    path: "edit/:id",
    name: "complaintsEdit",
    component: complaintsEdit
  }, {
    path: "create",
    name: "complaintsCreate",
    component: complaintsEdit
  }]
}, {
  path: '/preprojectsupport',
  component: Main,
  children: [{
    path: "list",
    name: "preprojectsupportList",
    component: preprojectsupportList
  }, {
    path: "edit/:id",
    name: "preprojectsupportEdit",
    component: preprojectsupportEdit
  }, {
    path: "create",
    name: "preprojectsupportCreate",
    component: preprojectsupportEdit
  }]
}, {
  path: "/ticketsum",
  component: Main,
  children: [{
    path: "list",
    name: "ticketsumList",
    component: ticketsumList
  }, {
    path: "edit/:id",
    name: "ticketsumEdit",
    component: ticketsumEdit
  }, {
    path: "ticketsumDetails/:id",
    name: "ticketsumDetails",
    component: ticketsumDetails
  }]
}, {
  path: '/reception',
  component: Main,
  children: [{
    path: "list",
    name: "receptionList",
    component: receptionList
  }, {
    path: "edit/:id",
    name: "receptionEdit",
    component: receptionEdit
  }, {
    path: "create",
    name: "receptionCreate",
    component: receptionEdit
  }, {
    path: "editLine/:id/:type/:istrue",
    name: "receptionLineEdit",
    component: receptionLineEdit
  }, {
    path: "createLine/:id/:name/:type",
    name: "receptionLineCreate",
    component: receptionLineEdit
  }]
}, {
  path: '/ordermaintain',
  component: Main,
  children: [{
    path: "list",
    name: "applymaintainorderList",
    component: applymaintainorderList
  }, {
    path: "newList",
    name: "newApplymaintainorderList",
    component: applymaintainorderList
  }, {
    path: "edit/:id",
    name: "applymaintainorderEdit",
    component: applymaintainorderEdit
  }, {
    path: "create",
    name: "applymaintainorderCreate",
    component: applymaintainorderEdit
  }, {
    path: "createMaterial/:id",
    name: "maintainMaterialChose",
    component: maintainMaterialChose
  }, {
    path: "makeOrderEdit/:id",
    name: "maintainMakeOrderEdit",
    component: maintainMakeOrderEdit
  }]
}, {
  path: '/applyservice',
  component: Main,
  children: [{
    path: "list",
    name: "applyserviceList",
    component: applyserviceList
  }, {
    path: "afterServiceList",
    name: "afterServiceList",
    component: afterServiceList
  }, {
    path: "edit/:id/:type",
    name: "applyserviceEdit",
    component: applyserviceEdit
  }, {
    path: "create/:type",
    name: "applyserviceCreate",
    component: applyserviceEdit
  }]
}, {
  path: '/crossprojectitem',
  component: Main,
  children: [{
    path: "list",
    name: "crossprojectitemList",
    component: crossprojectitemList
  }, {
    path: "edit/:id",
    name: "crossprojectitemEdit",
    component: crossprojectitemEdit
  }, {
    path: "feedetailcreate/:itemid/:itemname/:blankcoefficient/:declaretravelamount",
    name: "feedetailCreate",
    component: feedetailEdit
  }, {
    path: "feedetailedit/:id",
    name: "feedetailEdit",
    component: feedetailEdit
  }, {
    path: "feecountedit/:id",
    name: "feecountEdit",
    component: feecountEdit
  }, {
    path: "changecreate/:blankcoefficient/:itemid/:itemname",
    name: "changeCreate",
    component: changeEdit
  }, {
    path: "changeedit/:id",
    name: "changeEdit",
    component: changeEdit
  }, {
    path: "deliveredit/:id",
    name: "deliverEdit",
    component: deliverEdit
  }, {
    path: "delivercreate",
    name: "deliverCreate",
    component: deliverEdit
  }, {
    path: "checkreceiveedit/:id",
    name: "checkreceiveEdit",
    component: checkreceiveEdit
  }, {
    path: "checkreceivecreate",
    name: "checkreceiveCreate",
    component: checkreceiveEdit
  }, {
    path: "settleedit/:id",
    name: "settleEdit",
    component: settleEdit
  }, {
    path: "settlecreate",
    name: "settleCreate",
    component: settleEdit
  }, {
    path: "handoveredit/:id",
    name: "handoverEdit",
    component: handoverEdit
  }, {
    path: "handovercreate",
    name: "handoverCreate",
    component: handoverEdit
  }, {
    path: "clientprojectedit/:id",
    name: "clientprojectEdit",
    component: clientprojectEdit
  }, {
    path: "cooperationApplicationList",
    name: "cooperationApplicationList",
    component: cooperationApplicationList
  }, {
    path: "cooperationApplication/:id",
    name: "cooperationApplicationEdit",
    component: cooperationApplicationEdit
  }]
}, {
  path: "/account",
  component: Main,
  children: [{
    path: "list",
    name: "accountList",
    component: accountList
  }, {
    path: "edit/:id",
    name: "accountEdit",
    component: accountEdit
  }, {
    path: "create",
    name: "accountCreate",
    component: accountEdit
  }]
}, {
  path: "/achievementapply",
  component: Main,
  children: [{
    path: "list",
    name: "achievementapplyList",
    component: achievementapplyList
  }, {
    path: "edit/:id",
    name: "achievementapplyEdit",
    component: achievementapplyEdit
  }, {
    path: "create",
    name: "achievementapplyCreate",
    component: achievementapplyEdit
  }, {
    path: "editLine/:id",
    name: "projectsupportlineEdit",
    component: projectsupportlineEdit
  }]
}, {
  path: "/paymentapply",
  component: Main,
  children: [{
    path: "list",
    name: "paymentapplyList",
    component: paymentapplyList
  }, {
    path: "edit/:id",
    name: "paymentapplyEdit",
    component: paymentapplyEdit
  }, {
    path: "create",
    name: "paymentapplyCreate",
    component: paymentapplyEdit
  }, {
    path: "editService/:id/:type/:istrue",
    name: "servicecostEdit",
    component: servicecostEdit
  }, {
    path: "createService/:id/:name/:type",
    name: "servicecostCreate",
    component: servicecostEdit
  }, {
    path: "editTechnicalcost/:id/:type/:istrue",
    name: "technicalcostEdit",
    component: technicalcostEdit
  }, {
    path: "createTechnicalcost/:id/:name/:type",
    name: "technicalcostCreate",
    component: technicalcostEdit
  }, {
    path: "editPointcost/:id/:type/:istrue",
    name: "pointcostEdit",
    component: pointcostEdit
  }, {
    path: "createPointcost/:id/:name/:type",
    name: "pointcostCreate",
    component: pointcostEdit
  }]
}, {
  path: "/dealerCharge",
  component: Main,
  children: [{
    path: "main",
    name: "dealerCharge",
    component: dealerCharge,
    meta: {
      keepAlive: true }
  }, {
    path: 'appliedHistory/:id',
    name: 'appliedHistory',
    component: appliedHistory
  }, {
    path: 'appliedEdit/:id/:new_ordertype',
    name: 'appliedEdit',
    component: appliedEdit
  }]
}, {
  path: "/dealerLetter",
  component: Main,
  children: [{
    path: "list",
    name: "dealerLetter",
    component: dealerLetter
  }]
}, {
  path: "/standardorder",
  component: Main,
  children: [{
    path: "list",
    name: "standardorderlist",
    component: standardorderlist
  }, {
    path: "edit/:id",
    name: "standardorderedit",
    component: standardorderedit
  }, {
    path: "details/:mainid/:id",
    name: "standardorderdetails",
    component: standardorderdetails
  }]
}, {
  path: "/partsorder",
  component: Main,
  children: [{
    path: "list",
    name: "partsorderlist",
    component: partsorderlist
  }, {
    path: "edit/:id",
    name: "partsorderedit",
    component: partsorderedit
  }, {
    path: "details/:mainid/:id",
    name: "partsorderdetails",
    component: partsorderdetails
  }]
}, {
  path: "/businessmessage",
  component: Main,
  children: [{
    path: "list",
    name: "businessmessagelist",
    component: businessmessagelist
  }, {
    path: "edit/:id",
    name: "businessmessageedit",
    component: businessmessageedit
  }]
}, {
  path: "/partsstandard",
  component: Main,
  children: [{
    path: "list",
    name: "OrderStandardQueryList",
    component: OrderStandardQueryList
  }, {
    path: "queryOrderStatus",
    name: "OrderStatusQuery",
    component: OrderStatusQuery
  }]
}, {
  path: "/projectsupportbox",
  component: Main,
  children: [{
    path: "list",
    name: "projectsupportbox",
    component: projectsupportbox,
    meta: {
      keepAlive: true }
  }]
}, {
  path: "/projectsupport",
  component: Main,
  children: [{
    path: "list",
    name: "technicalSupportList",
    component: technicalSupportList
  }, {
    path: "technicalSupportDetails/:id",
    name: "technicalSupportDetails",
    component: technicalSupportDetails
  }, {
    path: "edit/:id",
    name: "projectsupportEdit",
    component: projectsupportEdit
  }, {
    path: "details/:id/:supporttype",
    name: "details",
    component: details
  }, {
    path: "detailscreate/:id/:type/:supporttype/:oppid",
    name: "detailscreate",
    component: details
  }, {
    path: "create",
    name: "projectsupportCreate",
    component: projectsupportEdit
  }]
}, {
  path: "/projectsupport2",
  component: Main,
  children: [{
    path: "list",
    name: "noprojectsupportList",
    component: noprojectsupportList
  }, {
    path: "edit/:id",
    name: "noprojectsupportEdit",
    component: noprojectsupportEdit
  }, {
    path: "details/:id/:supporttype",
    name: "nodetails",
    component: nodetails
  }, {
    path: "detailscreate/:id/:type/:supporttype",
    name: "nodetailscreate",
    component: nodetails
  }, {
    path: "create",
    name: "noprojectsupportCreate",
    component: noprojectsupportEdit
  }]
}, {
  path: "/expachievementapply",
  component: Main,
  children: [{
    path: "list",
    name: "expachievementapplytList",
    component: expachievementapplytList
  }, {
    path: "edit/:id",
    name: "expachievementapplytEdit",
    component: expachievementapplytEdit
  }, {
    path: "create",
    name: "expachievementapplytCreate",
    component: expachievementapplytEdit
  }]
}, {
  path: "/servicesupport",
  component: Main,
  children: [{
    path: "list",
    name: "servicesupportList",
    component: servicesupportList
  }, {
    path: "edit/:id",
    name: "servicesupportEdit",
    component: servicesupportEdit
  }]
}, {
  path: "/dealerorder",
  component: Main,
  children: [{
    path: "list",
    name: "dealerorderList",
    component: dealerorderList,
    meta: {
      keepAlive: true }
  }, {
    path: "create",
    name: "dealerorderCreate",
    component: dealerorderEdit
  }, {
    path: "edit/:id",
    name: "dealerorderEdit",
    component: dealerorderEdit
  }, {
    path: "certification/:id",
    name: "dealerorderCertification",
    component: dealerorderCertification
  }, {
    path: "preaudit/:id",
    name: "dealerorderPreAudit",
    component: dealerorderPreAudit
  }]
}, {
  path: "/accountproject",
  component: Main,
  children: [{
    path: "create/:opportunityid",
    name: "accountprojectCreate",
    component: accountprojectEdit
  }, {
    path: "edit/:new_pjt_accountprojectid",
    name: "accountprojectEdit",
    component: accountprojectEdit
  }, {
    path: "equipmentReceive",
    name: "accountprojectEquipmentReceive",
    component: accountprojectEquipmentReceive
  }, {
    path: "list",
    name: "accountprojectList",
    component: accountprojectList
  }]
}, {
  path: "/pjtItem",
  component: Main,
  children: [{
    path: "list",
    name: "pjtItemList",
    component: pjtItemList
  }, {
    path: "view/:id",
    name: "pjtItemView",
    component: pjtItemView
  }]
}, {
  path: "/creditinfo",
  component: Main,
  children: [{
    path: "list",
    name: "creditInfoList",
    component: creditInfoList
  }, {
    path: "apply/:id",
    name: "creditApply",
    component: creditApply
  }]
}, {
  path: "/dealerbill",
  component: Main,
  children: [{
    path: "list",
    name: "dealerBillList",
    component: dealerBillList
  }, {
    path: "details/:id",
    name: "dealerBillDetails",
    component: dealerBillDetails
  }, {
    path: "delaylist",
    name: "dealerBillDelayList",
    component: dealerBillDelayList
  }, {
    path: "delay/:id/:billid",
    name: "dealerBillDelay",
    component: dealerBillDelay
  }, {
    path: "details",
    name: "dealerBillPreview",
    component: dealerBillPreview
  }]
}, {
  path: "/accountinfo",
  component: Main,
  children: [{
    path: "account",
    name: "AccountInfoAccount",
    component: AccountInfoAccount
  }, {
    path: "billDetail/:tradetype",
    name: "AccountInfoBillDetail",
    component: AccountInfoBillDetail
  }, {
    path: "transAccount",
    name: "AccountInfoTransAccount",
    component: AccountInfoTransAccount
  }, {
    path: "cashDepositAccount",
    name: "AccountInfoCashDepositAccount",
    component: AccountInfoCashDepositAccount
  }, {
    path: "yearCreditAccount",
    name: "AccountInfoYearCreditAccount",
    component: AccountInfoYearCreditAccount
  }, {
    path: "tempCreditAccount",
    name: "AccountInfoTempCreditAccount",
    component: AccountInfoTempCreditAccount
  }, {
    path: "personalGuaranteeAccount",
    name: "AccountInfoPersonalGuaranteeAccount",
    component: AccountInfoPersonalGuaranteeAccount
  }, {
    path: "dedicatedAccount",
    name: "AccountInfoDedicatedAccount",
    component: AccountInfoDedicatedAccount
  }, {
    path: "complexCreditAccount",
    name: "AccountInfoComplexCreditAccount",
    component: AccountInfoComplexCreditAccount
  }, {
    path: "accountRecharge",
    name: "AccountInfoAccountRecharge",
    component: AccountInfoAccountRecharge
  }, {
    path: "accountRepayment/:paytype",
    name: "AccountInfoAccountRepayment",
    component: AccountInfoAccountRepayment
  }, {
    path: "accountRepaymentCredit",
    name: "AccountInfoAccountRepaymentCredit",
    component: AccountInfoAccountRepaymentCredit
  }]
}, {
  path: "/checkbill",
  component: Main,
  children: [{
    path: "dealerCheckBill",
    name: "CheckBillDealerCheckBill",
    component: CheckBillDealerCheckBill
  }, {
    path: "Details/:billid",
    name: "billDetails",
    component: billDetails
  }]
}, {
  path: "/accountProperty",
  component: Main,
  children: [{
    path: "list",
    name: "AccountProperty",
    component: AccountProperty
  }, {
    path: "comeAndGo",
    name: "comeAndGo",
    component: comeAndGo
  }, {
    path: "creditExtension",
    name: "creditExtension",
    component: creditExtension
  }, {
    path: "cashDeposit",
    name: "cashDeposit",
    component: cashDeposit
  }, {
    path: "shipmentAccount",
    name: "shipmentAccount",
    component: shipmentAccount,
    meta: {
      keepAlive: true }
  }, {
    path: "shipmentAccountPayDetail/:orderid",
    name: "shipmentAccountPayDetail",
    component: shipmentAccountPayDetail
  }, {
    path: "shipmentAccountShipmentDetail/:orderid",
    name: "shipmentAccountShipmentDetail",
    component: shipmentAccountShipmentDetail
  }, {
    path: "shipmentAccountUnshipmentDetail/:orderid",
    name: "shipmentAccountUnshipmentDetail",
    component: shipmentAccountUnshipmentDetail
  }, {
    path: "dealerMonthBillDetail/:orderid",
    name: "dealerMonthBillDetail",
    component: dealerMonthBillDetail
  }, {
    path: "refundCashierDesk",
    name: "AccountInfoAccountPayment",
    component: refundCashierDesk
  }, {
    path: "voucherCenter",
    name: "voucherCenter",
    component: voucherCenter
  }]
}, {
  path: "/quoteproduct",
  component: Main,
  children: [{
    path: "details/:id",
    name: "quoteProductDetails",
    component: quoteProductDetails
  }]
}, {
  path: '/serviceOrderForm',
  component: Main,
  children: [{
    path: 'list',
    name: "serviceOrderForm",
    component: serviceOrderForm
  }, {
    path: 'afterSaleServiceEdit/:id',
    name: "afterSaleServiceEdit",
    component: afterSaleServiceEdit
  }]
}, {
  path: '/purchaseOrderForm',
  component: Main,
  children: [{
    path: 'list',
    name: "purchaseOrderForm",
    component: purchaseOrderForm
  }]
}, {
  path: '/addressBook',
  component: Main,
  children: [{
    path: 'list',
    name: "addressBook",
    component: addressBook
  }]
}, {
  path: '/fenrunqingkuan',
  component: Main,
  children: [{
    path: 'main',
    name: 'fenrunqingkuan',
    component: fenrunqingkuan
  }, {
    path: 'appliedShareProfit/:id',
    name: 'appliedShareProfit',
    component: appliedShareProfit
  }, {
    path: 'appliedChoose/:id/:new_ordertype',
    name: 'appliedChoose',
    component: appliedChoose
  }]
}, {
  path: "/contract",
  component: Main,
  children: [{
    path: "list",
    name: "optionService",
    component: Contract,
    meta: {
      keepAlive: true }
  }, {
    path: "detail",
    name: "optionService-detail",
    component: ContractDetail
  }]
}]);

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(116);



var HEARTBEAT_INTERVAL = 60;

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {},
    keepAlive: function keepAlive() {
        localStorage.heartbeat = new Date();
        setInterval(function () {
            localStorage.heartbeat = new Date();
        }, 60 * 1000);
    },
    isAlive: function isAlive() {
        var lastHeartbeat = localStorage.heartbeat;

        if (lastHeartbeat === null || new Date(lastHeartbeat).dateDiff('s', new Date()) > HEARTBEAT_INTERVAL + 30) {
            return false;
        }
        return true;
    }
});

/***/ }),

/***/ 371:
/***/ (function(module, exports) {



/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dealer", function() { return dealer; });
var auth = function auth(state) {
  return state.auth;
};
var user = function user(state) {
  return state.user;
};
var dealer = function dealer(state) {
  return state.dealer;
};

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_AUTH", function() { return UPDATE_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_DEALER", function() { return UPDATE_DEALER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER_AVATAR", function() { return UPDATE_USER_AVATAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ALL_DATA", function() { return CLEAR_ALL_DATA; });
var UPDATE_AUTH = function UPDATE_AUTH(state, auth) {
    state.auth = auth;
};

var UPDATE_USER = function UPDATE_USER(state, user) {
    state.user = user;
};

var UPDATE_DEALER = function UPDATE_DEALER(state, dealer) {
    debugger;
    state.dealer = dealer;
};

var UPDATE_USER_AVATAR = function UPDATE_USER_AVATAR(state, avatarUrl) {
    state.user.avatarUrl = avatarUrl;
};

var CLEAR_ALL_DATA = function CLEAR_ALL_DATA(state) {
    state.auth.isLoggedIn = false;
    state.auth.accessToken = null;
    state.auth.refreshToken = null;

    state.user.userId = '';
    state.user.userName = '';
    state.user.nickName = '';
    state.user.departName = '';
    state.user.departId = '';
    state.user.avatarUrl = '';

    state.dealer.isServiceProvider = false;
};

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(191);



var localStoragePlugin = function localStoragePlugin(store) {
    store.subscribe(function (mutation, state) {
        var syncedData = { auth: state.auth, user: state.user, dealer: state.dealer };

        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__state__["b" /* STORAGE_KEY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(syncedData));

        if (mutation.type === 'CLEAR_ALL_DATA') {
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__state__["b" /* STORAGE_KEY */]);
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = ([localStoragePlugin]);

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)
__webpack_require__(649)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  "data-v-21bd3d08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(688),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(687),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(685),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(691),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(683),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(690),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(689),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rtportal"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-grid"
  }, [_c('div', {
    staticClass: "rt-grid__header"
  }, [(_vm.$slots.toolbar) ? _c('rt-toolbar', {
    staticStyle: {
      "float": "right",
      "margin": "2px 20px 0 0"
    }
  }, [_vm._t("toolbar")], 2) : _vm._e(), _vm._v(" "), (_vm.isShowSearch) ? _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "176px",
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": _vm.quicksearchPlaceholder
    },
    model: {
      value: (_vm.quickSearch),
      callback: function($$v) {
        _vm.quickSearch = $$v
      },
      expression: "quickSearch"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left",
      "height": "30px",
      "margin-left": "10px"
    },
    attrs: {
      "slot": "append",
      "type": "primary"
    },
    on: {
      "click": _vm.handleQuickSearch
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.searchButtonName))]), _vm._v(" "), (_vm.isShowSearch && !_vm.$slots.more) ? _c('el-button', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "height": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.resetButtonName))]) : _vm._e(), _vm._v(" "), (_vm.$slots.more) ? _c('el-button', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "padding": "0",
      "width": "66px",
      "height": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resetButtonName) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.$slots.more) ? _c('el-button', {
    staticStyle: {
      "float": "left",
      "margin-left": "10px",
      "padding": "0",
      "width": "66px",
      "height": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCollapse
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('BUTTON_MORESCREEN')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$slots.more && _vm.showHidden),
      expression: "$slots.more && showHidden"
    }],
    staticClass: "rt-grid__moresearch"
  }, [_vm._t("more")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-grid__body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-grid__footer"
  }, [(_vm.showPagination) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.pageSizes,
      "layout": _vm.layout,
      "total": _vm.totalRecord
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleIndexChange
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "annotation"
  }, [_c('template', {
    slot: "toolbar"
  }, [_c('input', {
    ref: "upload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "value": "请点击上传附件"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('rt-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAdd),
      expression: "showAdd"
    }],
    attrs: {
      "text": _vm.$t('BUTTON_UPLOAD'),
      "type": "add",
      "disabled": _vm.disabledStatus
    },
    on: {
      "click": _vm.uploadFile
    }
  }), _vm._v(" "), _c('rt-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDelete),
      expression: "showDelete"
    }],
    attrs: {
      "type": "delete",
      "disabled": _vm.disabledStatus
    },
    on: {
      "click": _vm.deleteData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "annotationTop"
  }, [_c('span', [_vm._v("注释")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAdd),
      expression: "showAdd"
    }],
    attrs: {
      "disabled": _vm.disabledStatus
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v(_vm._s(_vm.$t("BUTTON_UPLOAD")))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDelete),
      expression: "showDelete"
    }],
    attrs: {
      "disabled": _vm.disabledStatus
    },
    on: {
      "click": _vm.deleteData
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "gridTable",
    attrs: {
      "data": _vm.attachmentData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('annotation.filename'),
      "prop": "filename",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('annotation.filesize'),
      "prop": "filesize"
    }
  }), _vm._v(" "), (_vm.showDetail) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('annotation.subject'),
      "prop": "subject"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDetail) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('annotation.nodetext'),
      "prop": "nodetext"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('annotation.createdon'),
      "prop": "createdon"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预览",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNotIE),
            expression: "isNotIE"
          }],
          attrs: {
            "href": scope.row.filelink,
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.downLoadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("点击预览")]), _vm._v(" "), _c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isIE),
            expression: "isIE"
          }],
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              _vm.downLoadOrOpenFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("点击预览")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('ACT'),
      "width": "81"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.filelink,
            "download": scope.row.filename
          },
          on: {
            "click": function($event) {
              _vm.downLoadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载")])]
      }
    }])
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "clearable": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Value,
      attrs: {
        "label": item.Text,
        "value": item.Value
      }
    }, [_vm._v("\n        " + _vm._s(item.Text) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "approveState"
    }
  }, _vm._l((_vm.stateList), function(state, index) {
    return _c('div', {
      key: state.Status,
      staticClass: "nodelist"
    }, [_c('div', {
      staticClass: "node"
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        'icon-approving': (state.Status !== 2 && state.Status !== 0), 'icon-approved': state.Status === 2, 'icon-submit': state.Status === 0
      }
    }), _vm._v(" "), _c('ul', [_c('li', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(state['OwneridName']))]), _vm._v(" "), _c('li', {
      staticClass: "date"
    }, [_vm._v(_vm._s(state['ApproveDate']))])])]), _vm._v(" "), (index !== _vm.stateList.length - 1) ? _c('div', {
      staticClass: "proce"
    }, [_c('span', [_vm._v("- - - - - - - ")])]) : _vm._e()])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('History')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "approveTrack"
    }
  }, [_c('ul', _vm._l((_vm.trackList), function(track, index) {
    return _c('li', {
      key: track.Date,
      class: {
        last: index === _vm.trackList.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "-7px"
      }
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        first: index === 0
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(track['Date']))]), _vm._v(" "), _c('span', {
      staticClass: "action"
    }, [_vm._v("[" + _vm._s(track['ActionType']) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(track['StepIdName']))]), _vm._v(" "), _c('span', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(track['OwneridName']))])]), _vm._v(" "), _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v(_vm._s(track.Memo))])])])])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "size": "small",
      "title": _vm.$t('BUTTON_APPROVALPROGRESS'),
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.dialogVisible) ? _c('rt-approval-progress', {
    attrs: {
      "entity-name": _vm.entityName,
      "entity-id": _vm.entityId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) { return null; }
        return _vm.deletevalue($event)
      }
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled,
      "icon": "search",
      "on-icon-click": _vm.showLookupDialog
    },
    model: {
      value: (_vm.lookupValue.name),
      callback: function($$v) {
        _vm.$set(_vm.lookupValue, "name", $$v)
      },
      expression: "lookupValue.name"
    }
  }), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "isMaskShow": _vm.isMaskShow,
      "entity": _vm.entity,
      "condition": _vm.condition,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "filter-fields": _vm.dialogFilterFields
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "rt-nav"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "rt-nav-item",
    class: {
      "is-active": _vm.active, "is-disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleItemClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "rt-lookup-dialog",
    attrs: {
      "size": "tiny",
      "close-on-click-modal": false,
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "搜索"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.searchPlaceholder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.handleSearch
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "lookupTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "450",
      "highlight-current-row": "",
      "data": _vm.tableData,
      "stripe": ""
    },
    on: {
      "row-click": _vm.handleClick,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "40",
      "selectable": _vm.selectable
    }
  }), _vm._v(" "), _vm._l((_vm.displayFields), function(display) {
    return _c('el-table-column', {
      key: display.name,
      attrs: {
        "show-overflow-tooltip": true,
        "prop": display.name,
        "label": display.label,
        "width": display.width
      }
    })
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.pageSizes,
      "layout": _vm.layout,
      "total": _vm.totalRecordCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleIndexChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-content",
    class: {
      'with-side': _vm.$slots.side
    }
  }, [(_vm.$slots.side) ? _c('div', {
    staticClass: "rt-content__side",
    style: (_vm.sideStyle)
  }, [_vm._t("side")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rt-content__main",
    attrs: {
      "id": "contentMain"
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    class: _vm.iconClass
  }), _vm._v("\n    " + _vm._s(_vm.buttonText) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-section",
    class: {
      'is-collapsed': _vm.isCollapsed
    }
  }, [_c('div', {
    staticClass: "rt-section__header"
  }, [_c('span', {
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "rt-section__header__arrow el-icon-arrow-down"
  }), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (!_vm.isCollapsed) ? _c('rt-toolbar', [_vm._t("toolbar")], 2) : _vm._e()], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    staticClass: "rt-section__content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-query"
  }, [_c('div', {
    staticClass: "rt-query__container"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "rt-query__collapse"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rows > 2),
      expression: "rows>2"
    }],
    attrs: {
      "icon": _vm.icon,
      "title": _vm.hintMessage
    },
    on: {
      "click": _vm.handleCollapse
    }
  })], 1)], 2), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40,
      "type": "flex"
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "rt-query__reset",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled,
      "v-show": _vm.visible
    },
    on: {
      "click": _vm.showLookupDialog
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('js-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "title": _vm.title == null ? _vm.buttonText : _vm.title,
      "entity": _vm.entity,
      "checkSelectable": _vm.checkSelectable,
      "condition": _vm.condition,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "filter-fields": _vm.dialogFilterFields,
      "searchPlaceholder": _vm.searchPlaceholder
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": true
    },
    model: {
      value: (_vm.lastApprovalMemo),
      callback: function($$v) {
        _vm.lastApprovalMemo = $$v
      },
      expression: "lastApprovalMemo"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-toolbar"
  }, [_vm._t("default"), _vm._v(" "), (_vm.showBack || _vm.showAutoback) ? [_c('div', {
    staticClass: "rt-divider"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleBackClick
    }
  }, [_vm._v(_vm._s(_vm.$t('BUTTON_RETURN')))])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "size": "auto",
      "title": _vm.title,
      "close-on-click-modal": false,
      "before-close": _vm.handleDialogClose,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "rt-excel-import"
  }, [_c('div', {
    staticClass: "rt-excel-import_tip"
  }, [_vm._v("\n            只能上传Excel(xls或xlsx)文件，且记录数不超过5000条\n        ")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    attrs: {
      "drag": "",
      "action": "/",
      "accept": ".xls,.xlsx",
      "http-request": _vm.handleHttpRequest,
      "show-file-list": false,
      "on-change": _vm.handleChange,
      "multiple": false,
      "auto-upload": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或\n                "), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("已选择文件：" + _vm._s(_vm.selectedFile.name))])]), _vm._v(" "), _c('div', {
    staticClass: "rt-excel-import__result",
    class: {
      'rt-excel-import__result_error': !_vm.isSuccessed, 'rt-excel-import__result_success': _vm.isSuccessed
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.importResult))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [(_vm.templateUrl) ? _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.templateExcelUrl
    }
  }, [_vm._v("下载模板")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isImporting
    },
    on: {
      "click": _vm.handleImport
    }
  }, [_vm._v("导 入")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "size": "auto",
      "title": "流程提交",
      "close-on-click-modal": false,
      "before-close": _vm.handleClose,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "rt-flowsubmit-dialog"
  }, [_c('h2', [_vm._v("选择签核流程\n      "), _c('span', [_vm._v("(下拉框中可能存在多个可选项目,请注意选择合适的流程)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-select', {
    model: {
      value: (_vm.selectedFlowId),
      callback: function($$v) {
        _vm.selectedFlowId = $$v
      },
      expression: "selectedFlowId"
    }
  }, _vm._l((_vm.flowList), function(flow) {
    return _c('el-option', {
      key: flow.FlowId,
      attrs: {
        "value": flow.FlowId,
        "label": flow.FlowName
      }
    })
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h2', [_vm._v("选择签核用户\n        "), _c('span', [_vm._v("(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)")])]), _vm._v(" "), _vm._l((_vm.stepList), function(step) {
    return _c('div', {
      key: step.StepName
    }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(step.StepName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-select', {
      model: {
        value: (step.ApproveUserId),
        callback: function($$v) {
          _vm.$set(step, "ApproveUserId", $$v)
        },
        expression: "step.ApproveUserId"
      }
    }, _vm._l((step.UserList), function(user) {
      return _c('el-option', {
        key: user.UserId,
        attrs: {
          "value": user.UserId,
          "label": user.UserName
        }
      })
    }))], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmiting
    },
    on: {
      "click": _vm.submitFlow
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "rt-lookup-dialog",
    class: !_vm.isMaskShow ? 'el-dialog--diy' : '',
    attrs: {
      "size": "tiny",
      "close-on-click-modal": false,
      "title": "查找",
      "visible": _vm.dialogVisible,
      "modal": _vm.isMaskShow,
      "modal-append-to-body": !_vm.isMaskShow
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "搜索"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索记录"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.handleSearch
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "lookupTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": _vm.isMaskShow ? 450 : 235,
      "highlight-current-row": "",
      "data": _vm.tableData,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "row-dblclick": _vm.handleConfirm,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row == _vm.currentRow) ? _c('i', {
          staticClass: "el-icon-check"
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.displayFields), function(display) {
    return _c('el-table-column', {
      key: display.name,
      attrs: {
        "show-overflow-tooltip": true,
        "prop": display.name,
        "label": display.label,
        "width": display.width
      }
    })
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.pageSizes,
      "layout": _vm.layout,
      "total": _vm.totalRecordCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleIndexChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("移除值")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_header_src_main__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_header_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__packages_header_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_content_src_main__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_content_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__packages_content_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_query_src_main__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_query_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__packages_query_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_button_src_main__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_button_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__packages_button_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_section_src_main__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_section_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__packages_section_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_lookup_chooser_src_lookup_chooser__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_lookup_chooser_src_lookup_chooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__packages_lookup_chooser_src_lookup_chooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__packages_lookup_chooser_src_lookup_chooser_dialog__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__packages_lookup_chooser_src_lookup_chooser_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__packages_lookup_chooser_src_lookup_chooser_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__packages_excel_import_src_main__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__packages_excel_import_src_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__packages_excel_import_src_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__packages_flow_src_submit_dialog__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__packages_flow_src_submit_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__packages_flow_src_submit_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__packages_approval_src_progress_dialog__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__packages_approval_src_progress_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__packages_approval_src_progress_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_flow_LastApprovalMemo__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_flow_LastApprovalMemo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_flow_LastApprovalMemo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__packages_annotation_main__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__packages_annotation_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__packages_annotation_main__);












//Lookup


//Lookup-chooser


//Excel导入

//流程提交

//审批进度


//最新审核意见

//附件


const components = [
    __WEBPACK_IMPORTED_MODULE_1__packages_header_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_2__packages_content_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_3__packages_toolbar_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_4__packages_query_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_5__packages_grid_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_6__packages_picklist_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_7__packages_button_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_8__packages_section_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_9__packages_nav_src_nav___default.a,
    __WEBPACK_IMPORTED_MODULE_10__packages_nav_src_nav_item___default.a,
    __WEBPACK_IMPORTED_MODULE_11__packages_lookup_src_lookup___default.a,
    __WEBPACK_IMPORTED_MODULE_12__packages_lookup_src_lookup_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_13__packages_lookup_chooser_src_lookup_chooser___default.a,
    __WEBPACK_IMPORTED_MODULE_14__packages_lookup_chooser_src_lookup_chooser_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_15__packages_excel_import_src_main___default.a,
    __WEBPACK_IMPORTED_MODULE_16__packages_flow_src_submit_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_17__packages_approval_src_progress___default.a,
    __WEBPACK_IMPORTED_MODULE_18__packages_approval_src_progress_dialog___default.a,
    __WEBPACK_IMPORTED_MODULE_20__packages_annotation_main___default.a,
    __WEBPACK_IMPORTED_MODULE_19__components_flow_LastApprovalMemo___default.a,
];

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function (Vue, opts) {
        components.map(function (component) {
            Vue.component(component.name, component);
        });
    }
});

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(161);
module.exports = __webpack_require__(265);


/***/ })

},[704]);


// WEBPACK FOOTER //
// static/js/app.97bff5ef979215be87b1.js